
import { PropertyModelManager } from "../../../modules/product/manager/property-model/PropertyModelManager";
import { AnonymousState } from "./AnonymousState";
import { PartnerState } from "./PartnerState";
import { BuilderUtil } from "../../../modules/main/util/builder/BuilderUtil";
import { ProductTypeEnum } from "../../../modules/product/model/dto/ProductTypeEnum";
import { CatchError } from "../../../modules/base/decorator/error/CatchError";
import { Environment } from "../../../../environments/Environment";
import { ChangeType, DiscretePriceEventName, IbreadcrumbProduct, IBulkPriceViewValue, IDeliveryCost, IDeliveryCostView, IDeliveryCountry, IDeliveryItemViewRecord, IDeliveryProduct, IDeliveryQtyPriceObj, IDeliveryViewRecord, IDesignModelOptionViewValue, IDiscretePriceParams, IOperationStatus, IPriceItemViewValue, IProductDetailManager, IProductDetailState, IProductInfoViewValue, IProductKeyValue, IProductSnapshot, IPropertyDetailScope, IPropertyKey, IPropertyService, IPropertyViewValue, ISearchShippingRequestObj, ISkuCountryDeliveryCache, ISkuDeliveryView, ISkuProductInfoCache, ISkuPropertyCodeKey, PageUrlParams, StoreInfo } from "./product-detail";
import { ProductDetailAnonymous } from "./product-detail-anonymous";
import { ProductDetailAuthorized } from "./product-detail-authorized";
import { SkuAttributeModel } from "@modules/property-model/model/domain/SkuAttributeModel";
import type { IPropertyChangeStrategy } from "./manager/property-change/property-change-strategy";
import { ProfileModel } from "@modules/property-model/model/domain/ProfileModel";
import { BusinessException } from "@core/error/business-exception";
import { IErrorResponse } from "@modules/common/rest/model";
import type { IError, IResponse, IToken } from "@core/data-access/model";
// import { AnonymousPageController, PageCacheKey } from "@modules/basic/page";
import { AnonymousPageController } from "@modules/basic/page/anonymous/anonymous-page.controller";
import type { ProductDetailObjectTree } from "./product-detail-object-tree";
import type { IAnonymousRestService } from "@modules/user/rest/anonymous-rest";
import { IStorageService, StorageProvider } from "@core/storage";
import { IFormController, IServiceProvider, isUndefined } from "angular";
import { IPartnerRestService } from "@modules/user/rest/partner/partner-rest-service";
import { IProductRestService } from '@modules/product/rest/products-rest';
import { SetupInitParams } from "../../store-product/store-product";
import type { PropertyModel } from "@modules/property-model/model/domain/PropertyModel";
import { IPartnerInfoRestService } from "@modules/partner/rest/partner-info-rest";
import type { IProductCategoriesRestService } from "@modules/product/categories/rest/product-categories-rest";
import { envConfig } from "@env/env-config";
import type { AttributeValue } from "@modules/product/model/domain/attribute/AttributeValue";
import { ProductData } from "@modules/product/model/domain/data/ProductData";
import type { IProductData } from "@modules/product/product/model/domain/IProductData";
import { error } from "jquery";
import type { IPermissionService } from "@modules/basic/page/page-service";
import type { ICountryRestService } from "@modules/user/rest/country/country-rest";
import { PromptTypeEnum } from "@modules/base/decorator/error/PromptType.enum";
import type { IShippingRestService } from "@modules/shipping/rest/shipping-rest";
import { IShipping } from "@modules/shipping/model/domain/shipping";
import { IShippingPriceItem } from "@modules/shipping/model/domain/shipping-price-item";
import { ReactiveQuery } from "@modules/common/media-query-manager";
import type { ICmsConfigRestService } from "@modules/cms/rest/cms-config-rest";
import type { IBuilderPathRest, IPathParams } from "@modules/main/rest/builder/builder-rest";
import { BuilderManager } from "@modules/main/builder/service/builder.manager";
import type { ICartRestService } from "@modules/cart/rest/cart-rest";
import type { IStoreProductV2RestService } from "@modules/store/store-product-v2/rest/store-product-v2-rest";
import type { IStoreProductSettingModalParams } from "@components/store-product-setting/store-product-setting";
import { ProductPriceManager } from "./manager/pricing/product-price.manager";
import { IAttributeValue } from "@modules/product/product/model/domain/IAttributeValue";
import { DefaultCatalogUtil } from "@modules/catalog/default-catalog-util";
import { UrlUtil, util } from "@core/utils";
import { productCatalogWithPagePath } from "@modules/catalog/product-catalog/model/domain/ProductCatalog";
import type { IPriceList } from "./manager/pricing/price";
import type { IMessageDialogOptions } from "@qpUIs/qp-message-dialog/qp-message-dialog-options.interface";
import type { ICartParams } from "@modules/cart/model/domain/ICartParams";
import { Freight, IFreight } from "@modules/shipping/model/domain/freight";
import type { FreightPriceItem, IFreightPriceItem } from "@modules/shipping/model/domain/freight-price-item";
import type { IMessageDialog } from "@qpUIs/qp-message-dialog/qp-message-dialog.interface";
import type { IPricingService } from "./manager/pricing/IPricingService";
import type { ICurrencyObj } from "@modules/main/header/header";
import type { IEventBusParameter } from "@core/event-bus/event-bus-parameter";
import type { IUserDataService } from "@modules/user/service/data/i-user-data-service";
import type { productCatalogIframeUpdateCurrencyParams } from "@pages/personal-center/products/products-catalog.controller";
import { deserialize } from "typescript-json-serializer";
import { ProductPropertyFormEventIdEnum } from "./property-form-window/product-property-form-event-id.enum";
import type { IProductPricingRestService } from "@modules/product/rest/pricing/product-pricing-rest";
import { IProductPrice } from "@modules/product/model/domain/pricing/product-price";
import type { PropertyModelForm } from "@modules/product/propertyForm/model/domain/property-model-form/property-model-form";
import type { GetKeyValueEventData, GetPropertyMdoelEventData, KeyValueEventDataAttribute, LifeCycleAfterValidateEventData, LifeCycleEventData, LifeCycleOnValidateEventData, OnErrorEventData, OnResizeEventData, PropertyFormWinwowEventData, PropertyModelEventData, PropertyValidateEventData, ResetTokenEventData } from "@modules/product/propertyForm/model/domain/property-form-window/property-form-winwow-event-data";
import type { PropertyFormWindowPostMessage, ResetTokenPostMessageData, SavePostMessageData } from "@modules/product/propertyForm/model/domain/property-form-window/property-form-window-post-message";
import { PropertyFormEventEnum } from "@modules/product/propertyForm/model/domain/property-form-window/property-form-event.enum";
import { constant, result } from "lodash";
import { StoreProductType } from "@core/utils/config/website-store-products.config";
import { StoreType } from "@core/utils/config/website-stores.config";
import { IModalParams } from "@components/add-store-product-modal/add-store-product-modal";
import { IDesignMethodRestService } from "@modules/product/design-method/design-method-rest";
import { isNullOrUndefined } from "@core/comparators";
import { ISkuAttributeValue } from "@modules/product/design-method/model/dto/skuAttributeValue";
import { IUrlParameter as IRandomBuilderUrlParameter } from "@pages/random-builder/random-builder";
import is from "@core/comparators/is";
import { IStoresRestService } from "@modules/store/stores/rest/stores-rest";
import { WhiteLabelPriceTypeEnum } from "@modules/product/pricing/model/domain/WhiteLabelPriceTypeEnum";
import { IAttrChangeEventParams, ICurrencyChangeEventParams, IRestConfig, RestTypeEnum } from "@components/discrete-price-list";
import { InquiryPriceDisplayMode } from "@components/inquiry-price";
import { IQpMessageFadeindown } from "@qpUIs/message-fadeindown/qp-message-fadeindown.interface";
import { IEventBus } from "@core/event-bus/event-bus";
import { PurchaseTrackingService } from "@modules/payment/service/purchase-tracking.service";

// implements IProductDetailController
export class ProductDetailController extends AnonymousPageController {
    public static readonly $inject: string[] = [
        "runtimeContext", "eventBus", "$scope", "propertyService", "pricingService",
        "qpLoading", "partnerRestService", "$uibModal", "builderRestService",
        "urlBuilder", "$q", "$translate", "$window", "$filter", "userManager",
        "pageContext", "propertyChangeService", "$objectTree", "anonymousRestService",
        "productV2RestService", "$location", "productCategoriesRestService", "rootPath",
        "$timeout", "permissionService", "countryRestService", "productDetailManager",
        "shippingRestService", "$interval", "cmsConfigRestService", "cartRestService",
        "storeProductV2RestService", "qpMessageFadeindown", "$sce", "qpMessageDialog",
        "$injector", "userDataService", "productPricingRestService", "designMethodRestService",
        "storesRestService", "purchaseTrackingService"
    ];

    // 当前页面产品id
    /**
     * @deprecated
     */
    public currentProductId;

    public loginState: qpmn.pages.products.detail.IPageState;
    // 当前产品属性
    public property: Array<qpmn.product.model.domain.propertyModel.IProfileModel> | Array<qpmn.product.model.domain.IAttributeValue>;
    // 店铺列表数据
    public stores: Array<qpmn.store.model.dto.IStoreModel>;

    // 产品名称
    /**
     * @deprecated
     */
    public productName: string;
    // 店铺类型
    public storeTypes: Array<qpmn.store.model.domain.IStoreType>;
    // 产品图片
    public images: Array<string> = [];
    // 页面初始化
    public initFinish: boolean = false;
    // 控制页面显示的产品描述数量
    public specDisplayNum: number;
    // 产品描述当前页码
    private specCurrentPage: number;
    // 货币符号
    /**
     * @deprecated
     */
    // public symbol: string;
    // 价格列表数据
    public pricingList: IBulkPriceViewValue;
    // 是否正在执行价格计算
    public isRequest_pricing = false;
    // 产品单价
    public productPrice: string;
    // 产品最大购买数量
    public QTYMAXLIMIT = 99999;
    // 按钮显示
    public buttonShow: boolean = true;
    // 加入店铺列表默认为关闭状态
    public addStoreOpen: boolean = false;
    // 产品详情操作按钮是否固定在底部状态变量
    public fixedOperateState: boolean = true;
    // 产品详情操作按钮是否固定在顶部状态变量
    public fixedTopOperateState: boolean = false;
    // 菜单栏默认为关闭状态
    public menuIsOpen: boolean = false;
    // 模态框属性列表默认为折叠状态
    public productAttributesShow: boolean = false;
    // 询价相关属性
    public productAttributes: object = {};
    public displayMode: string = InquiryPriceDisplayMode.Fold;
    public isProductAttributesValid: boolean = true;
    public isOpenInquiryPrice: boolean = true;
    public propertyModelId: string | undefined;
    public isVertical: boolean = false;
    // 测试用属性
    public testIsValid: string = "true";
    // 文件地址前缀
    public fileRoot: string = envConfig.getPath("file", "file/");
    // wooCommerece插件地址
    public wooCommerecePath: string = envConfig.wooCommerecePath;

    // shopify插件地址
    public shopifyPath: string = envConfig.shopifyPath;
    // 店铺id（个人中心--》店铺产品列表--》添加店铺产品）
    public sourceStoreId: string | undefined;
    // 店铺id（个人中心--》店铺产品列表--》添加店铺产品）
    public sourceStoreName: string | undefined;
    // 店铺id（个人中心--》店铺产品列表--》添加店铺产品）
    public sourceStoreUrl: string | undefined;
    private categoriesList;

    public breadcrumb: Array<IbreadcrumbProduct>;

    public emailAddress: string;
    public supportEmail: string;

    public currentProduct: IProductData;

    // 页面url地址参数
    public urlParameter: string;
    // 锁定属性,true时锁定,false时解锁
    public propertyLock: boolean = false;

    // 是否固定价格
    public fixedPrice: boolean = false;
    // 是否属性影响计价
    public needChangedWhenAttrs: boolean = false;
    // 是否数量影响计价
    public needChangedWhenQty: boolean = false;
    // 价格类型
    public priceType: WhiteLabelPriceTypeEnum | undefined;
    // 离散价格范围
    public qtyList: Array<number> = [];
    // 产品计价配置
    public restConfig: IRestConfig;

    // 默认分类路径
    // private defaultCatalogUrl: string;


    // public  临时产品状态模板存储对象
    public addProductModalObject: object = {
        [ProductTypeEnum.SKU]: "addSkuProduct.html",
        [ProductTypeEnum.CONFIGURABLE]: "addCfgProduct.html"
    }
    // 产品图当前展示图片索引
    public imageActiveIndex: number = 0;

    private propertyMap;
    // 计价队列
    private pricingQueue: Array<any> = [];

    private homePage: string;
    // 面包屑产品类目导航信息-加载中
    private breadcrumbLoading: boolean;
    // 店铺产品Id
    private storeProductId: string | undefined;
    private readonly RELAUNCH_DEFAULT_CONFIG = {
        // 是否反向显示confirm和取消按钮
        reverseButtons: true,
        // 是否显示取消按钮
        showCancelButton: false,
        // 取消按钮的自定义class类
        cancelButtonClass: 'alert-login-cancel',
        // 确认按钮的自定义class类
        confirmButtonClass: 'alert-login-confirm',
        // 为按钮添加默认的swal2样式
        buttonsStyling: true,
        // 是否允许点击对话框外部来关闭对话框
        allowOutsideClick: false,
        // 是否允许按下Esc键来关闭对话框
        allowEscapeKey: false
    }
    private loadingImage: string;
    // 产品描述信息显示状态(移动端)
    private infoStatusInMobile: IProductInfoViewValue;
    // 产品配送费用计算表单
    private shippingQtytest: IFormController;
    private shippingQtyForm: IFormController;

    // 用户默认货币code
    private userCurrencyCode: string;
    // 离散价格缓存
    private discretePriceCache: { [key: string]: string } = {};
    // 产品运费加载状态
    private deliveriesPriceLoading: boolean;
    // 店铺类型
    private storeType: StoreType | undefined;
    /*************************************属性表单集成****************************************/
    // 属性表单初始化状态
    private propertyFormLoaded: boolean;
    // 属性表单更新
    private propertyChanging: boolean;
    // 属性表单保存状态
    private propertySaving: boolean;
    // 属性表单Iframe高度
    private propertyIframeHeight: string;
    // 属性表单propertyModel数据
    private propertyModelForm: PropertyModelForm;

    // 产品属性表单Iframe元素Id
    private propertyIframeEleId: string = "productPropertyModelIFrame";

    /*************************************属性表单集成****************************************/
    // 页面Url参数propertyModelId
    private urlPropertyModelId: string | undefined;
    // 页面当前锚点
    public anchIdArr: Array<any>;
    public currentAnchId: string;
    // 产品信息描述当前激活tab项-pc端
    public activeInfoIndex: number | undefined;

    /*********************************************随机卡********************************************/
    // 随机设计模式
    public designModel: string | undefined;
    // 随机设计显示名称
    public designModelName: string | undefined;
    // 随机设计模式选择列表
    public designModelOptions: Array<string> | undefined;
    public designModelOptionsViewValue: Array<IDesignModelOptionViewValue>;
    // 属性关联产品设计模式
    public attributeRelationDesignMethod: boolean;

    /*********************************************随机卡********************************************/

    /*************************************离散数量价格表********************************************/
    // 离散数量价格表EventBus事件
    public discretePriceEventName: { [key: string]: string };

    /*************************************离散数量价格表********************************************/

    constructor(
        public runtimeContext: qpmn.main.IRuntimeContext,
        public eventBus: IEventBus,
        public $scope: IPropertyDetailScope,
        public propertyService: IPropertyService,
        public pricingService: IPricingService,
        public qpLoading: qp.loading.IQpLoading,
        public partnerRestService: IPartnerRestService,
        public $uibModal: angular.ui.bootstrap.IModalService,
        public builderRestService: IBuilderPathRest,
        public urlBuilder: qpmn.common.rest.IUrlBuilderService,
        public $q: angular.IQService,
        public $translate: angular.translate.ITranslateService,
        public $window: angular.IWindowService,
        public $filter: angular.IFilterService,
        public userManager: qpmn.user.IUserManager,
        public pageContext: qpmn.main.IPageContext,
        public propertyChangeService: IPropertyChangeStrategy,
        public $objectTree: ProductDetailObjectTree,
        public anonymousRestService: IAnonymousRestService,
        public productV2RestService: IProductRestService,
        public $location: angular.ILocationService,
        public productCategoriesRestService: IProductCategoriesRestService,
        public rootPath: string,
        public $timeout: angular.ITimeoutService,
        public permissionService: IPermissionService,
        public countryRestService: ICountryRestService,
        public productDetailManager: IProductDetailManager,
        public shippingRestService: IShippingRestService,
        public $interval: angular.IIntervalService,
        public cmsConfigRestService: ICmsConfigRestService,
        public cartRestService: ICartRestService,
        public storeProductV2RestService: IStoreProductV2RestService,
        public qpMessageFadeindown: IQpMessageFadeindown,
        public $sce: angular.ISCEService,
        public qpMessageDialog: IMessageDialog,
        public $injector: angular.auto.IInjectorService,
        public userDataService: IUserDataService,
        public productPricingRestService: IProductPricingRestService,
        public designMethodRestService: IDesignMethodRestService,
        public storesRestService: IStoresRestService,
        public purchaseTrackingService: PurchaseTrackingService
    ) {
        // super(anonymousUserRestService, runtimeContext, eventBus, $scope);
        super($objectTree, anonymousRestService);
        this.$objectTree.setUserDataService(this.userDataService);
        // 初始为未匿名状态
        this.loginState = new AnonymousState();
        // 价格列表默认为关闭状态
        this.$scope.pricingIsOpen = false;
        // 默认产品数量
        this.productQuantity = 1;
        // 邮件地址
        this.emailAddress = envConfig.supportEmail;
        this.supportEmail = envConfig.supportEmail;
        this.homePage = envConfig.getHomePage(this.rootPath);

        // 设置产品描述信息显示状态（移动端）
        this.infoStatusInMobile = {};

        // 监听Pricing状态改变,当开启/关闭状态改变时,触发价格计算
        this.$scope.$watch("pricingIsOpen", (newVal, oldVal) => {
            if (newVal == oldVal) {
                return;
            }
            // 价格列表关闭状态时不触发价格计算
            if (!newVal) {
                return;
            }
            // 更新价格列表
            this.addToPricingQueue();
        })



        // 初始化propertyViewValue
        this.propertyMap = {};
        this.specCurrentPage = 1;

        // 监听页面滚动事件 决定返回顶部按钮是否显示（弃用2025-1-21）
        // this.$window.addEventListener("scroll", () => {
        //     this.fixedOperateBtn();
        // });

        if (window.self != window.top) {
            this.updateIframeCurrency = this.updateIframeCurrency.bind(this);
            window.addEventListener("message", this.updateIframeCurrency, false);
        }

        Object.assign(this, new ProductPriceManager());
        this.updatePriceByCurrency = this.updatePriceByCurrency.bind(this);
        this.eventBus.addEventListener("UpdateCurrency", this.updatePriceByCurrency, this);
        this.$scope.$on("$destroy", () => {
            this.eventBus.removeEventListener("UpdateCurrency", this.updatePriceByCurrency, this);
            window.removeEventListener("message", this.updateIframeCurrency, false);
        })


        /*******************************属性表单集成************************************/
        //* 监听propertyFormWindow对象派发的事件
        window.addEventListener("message", (event) => {
            if (event && event.data) {
                let eventData: PropertyFormWinwowEventData = event.data;
                if (eventData && eventData.type) {
                    switch (eventData.type) {
                        case PropertyFormEventEnum.PROPERTY_FORM_WINDOW_ON_INIT:
                            //propertyIframeWindow-初始化-开始
                            const propertyOnInitEventData = eventData.data as LifeCycleEventData;
                            if (propertyOnInitEventData.unique && propertyOnInitEventData.unique === this.propertyIframeEleId) {
                                this.propertyIframeOnInit();
                            }
                            break;
                        case PropertyFormEventEnum.PROPERTY_FORM_WINDOW_AFTER_VIEW_INIT:
                            // propertyIframeWindow-初始化-结束
                            const propertyAfterViewInitEventData = eventData.data as LifeCycleEventData;
                            if (propertyAfterViewInitEventData.unique && propertyAfterViewInitEventData.unique === this.propertyIframeEleId) {
                                this.propertyIframeLoaded(eventData);
                            }
                            break;

                        case PropertyFormEventEnum.PROPERTY_FORM_WINDOW_ON_EXPIRED:
                            // propertyIframeWindow-token过期
                            const propertyOnExpiredEventData = eventData.data as LifeCycleEventData;
                            if (propertyOnExpiredEventData.unique && propertyOnExpiredEventData.unique === this.propertyIframeEleId) {
                                this.propertyIframeExpired();
                            }
                            break;
                        case PropertyFormEventEnum.PROPERTY_FORM_WINDOW_ON_RESIZE:
                            // propertyIframeWindow-表单页面尺寸变化
                            const propertyOnResizeEventData = eventData.data as LifeCycleEventData;
                            if (propertyOnResizeEventData.unique && propertyOnResizeEventData.unique === this.propertyIframeEleId) {
                                this.propertyIframeOnResize(eventData);
                            }
                            break;
                        case PropertyFormEventEnum.PROPERTY_FORM_WINDOW_ON_ERROR:
                            //propertyIframeWindow-表单运行过程中产生了异常
                            const propertyOnErrorEventData = eventData.data as LifeCycleEventData;
                            if (propertyOnErrorEventData.unique && propertyOnErrorEventData.unique === this.propertyIframeEleId) {
                                this.propertyIframeOnError(eventData);
                            }
                            break;
                        case PropertyFormEventEnum.PROPERTY_FORM_WINDOW_LIFE_CYCLE_ON_VALIDATE:
                            // propertyIframeWindow-表单开始执行验证
                            const propertySelfValidatingEventData = eventData.data as LifeCycleOnValidateEventData;
                            if (propertySelfValidatingEventData.unique && propertySelfValidatingEventData.unique === this.propertyIframeEleId) {
                                this.propertyIframelifeCycleValidating(eventData);
                            }
                            break;
                        case PropertyFormEventEnum.PROPERTY_FORM_WINDOW_LIFE_CYCLE_AFTER_VALIDATE:
                            //propertyIframeWindow-表单验证结束
                            const propertySelfValidatedEventData = eventData.data as LifeCycleAfterValidateEventData;
                            if (propertySelfValidatedEventData.unique && propertySelfValidatedEventData.unique === this.propertyIframeEleId) {
                                this.propertyIframelifeCycleValidated(eventData);
                            }
                            break;
                        case PropertyFormEventEnum.PROPERTY_FORM_WINDOW_ON_TIMEOUT:
                            // propertyIframeWindow-调用超时
                            const propertyOnTimeOutEventData = eventData.data as LifeCycleEventData;
                            if (propertyOnTimeOutEventData.unique && propertyOnTimeOutEventData.unique === this.propertyIframeEleId) {
                                this.propertyIframeOnTimeout();
                            }
                            break;
                        case PropertyFormEventEnum.PROPERTY_FORM_WINDOW_AFTER_SAVE:
                            //propertyIframeWindow-save事件回调
                            this.propertyIframeSaved(eventData);
                            break;
                        case PropertyFormEventEnum.PROPERTY_FORM_WINDOW_AFTER_RESET_TOKEN:
                            // propertyIframeWindow-ResetToken事件回调
                            this.propertyIframeAfterResetToken(eventData);
                            break;
                        case PropertyFormEventEnum.PROPERTY_FORM_WINDOW_AFTER_GET_KEY_VALUE:
                            // propertyIframeWindow-GetKeyValue事件回调
                            this.propertyIframeAfterGetKeyValue(eventData);
                            break;
                        case PropertyFormEventEnum.PROPERTY_FORM_WINDOW_AFTER_VALIDATE:
                            // propertyIframeWindow-Validated事件回调
                            this.propertyIframeValidated(eventData);
                            break;
                        case PropertyFormEventEnum.PROPERTY_FORM_WINDOW_AFTER_GET:
                            // propertyIframeWindow-查询表单完整数据-回调事件
                            this.propertyIframePropertyModelCallback(eventData);
                            break;
                    }
                }
            }
        });


        /*******************************属性表单集成************************************/

        /*************************************离散数量价格表********************************************/
        // 离散数量价格表EventBus事件
        this.discretePriceEventName = {
            attrChangeEventName: DiscretePriceEventName.ProductAttrChange,
            currencyChangeEventName: DiscretePriceEventName.CurrencyChange,
        }
    }

    public get isRandomMode(): boolean {
        return this.designModel !== undefined && this.designModel.toUpperCase() === "RANDOM";
    }

    /**
     * @deprecated(2025-1-21 移除操作栏悬浮效果)
     * @description 产品详情按钮是否固定在底部
     */
    public fixedOperateBtn() {
        //按钮距离可视化窗口顶部的距离
        const operationBtnTop: number = document.getElementById("info-area-operating")?.getBoundingClientRect().top as number;
        //按钮距离可视化窗口底部的距离
        const operationBtnBottom: number = document.getElementById("info-area-operating")?.getBoundingClientRect().bottom as number;
        //按钮高度 68px
        const infoOperationHeight: number = document.getElementById("info-area-operating")?.clientHeight as number;
        // 获取header部分高度-header固定视窗顶部
        const headHeight = (document.getElementById("fixed-header")?.clientHeight) ? document.getElementById("fixed-header")?.clientHeight : 0;

        // 获取浏览器可视窗口高度
        let viewHeight = document.documentElement.clientHeight;
        if (operationBtnBottom as number < infoOperationHeight && operationBtnBottom < viewHeight) {
            this.fixedOperateState = false;
            if (this.fixedTopOperateState) {
                this.$timeout(() => {
                    // 获取操作按钮容器
                    let operationBtnBox = document.getElementById('operation-fixed-box');
                    if (operationBtnBox) {
                        operationBtnBox.style.top = 'auto';
                        operationBtnBox.style.bottom = '0';
                    }
                })
            } else {
                this.$timeout(() => {
                    // 获取操作按钮容器
                    let operationBtnBox = document.getElementById('operation-fixed-box');
                    if (operationBtnBox) {
                        operationBtnBox.style.top = `${headHeight}px`;
                    }
                })
            }
        } else if (operationBtnTop > viewHeight) {
            this.fixedOperateState = false;
            this.fixedTopOperateState = true;
            this.$timeout(() => {
                // 获取操作按钮容器
                let operationBtnBox = document.getElementById('operation-fixed-box');
                if (operationBtnBox) {
                    operationBtnBox.style.top = 'auto';
                    operationBtnBox.style.bottom = '0';
                }
            })
        }
        else {
            this.fixedOperateState = true;
            this.fixedTopOperateState = false;
            this.$timeout(() => {
                // 获取操作按钮容器
                let operationBtnBox = document.getElementById('operation-fixed-box');
                if (operationBtnBox) {
                    operationBtnBox.style.top = `${headHeight}px`;
                }
            })

        }
        this.$scope.$applyAsync();
    }

    /**
     * @desc 调整builder定制
     * 
     * @returns 
     */
    @CatchError()
    public startDesign(productType: ProductTypeEnum) {
        // TODO V2-Property属性表单
        if (this.$scope.formCode) {
            const eventId = ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_START_DESIGN_CONFIGURABLE;
            // 执行V2-propertyForm属性表单校验，跳转builder
            this.propertyFormValidate(eventId);
            return;
        }
        // 检查属性是否合法,属性不合法时,拒绝提交
        if (!PropertyModelManager.checkPropertyModelLegal(this.propertyDomain)) {
            // 属性不合法时，不给出弹窗提示
            // window.qpAlertPrompt.info(this.$translate.instant('DETAIL_INPUT_ERROR_TITLE'), this.$translate.instant("DETAIL_INPUT_ERROR"));
            return;
        }
        // 锁定属性表单
        this.propertyLock = true;
        // propertyModelId
        var propertyModelId;

        this.saveProperty(this.propertyDomain)
            .then(pmResp => {
                if (!pmResp.success) {
                    return;
                }
                const pm = pmResp.data;
                propertyModelId = pm._id;
                // 随机定制产品-跳转随机设计定制页面
                if (this.designModel === 'RANDOM') {
                    // 锁定属性表单
                    this.propertyLock = false;
                    this.goRandomDesign(propertyModelId, productType);
                    return;
                } else {
                    let _builderParams: IPathParams = BuilderManager.creatParams({
                        propertyModelId: String(pm._id),
                        type: "builder",
                        platform: "PC"
                    });
                    _builderParams.builderType = "Partner";

                    // 获取产品关联的builder地址
                    return this.builderRestService.getPath(_builderParams.builderType, _builderParams)
                }
            })
            .then(pathResp => {
                if (!pathResp) {
                    return;
                }
                // builder地址
                let path = pathResp.data as string;
                // 获取builder集成页地址
                let builderPagePath = BuilderUtil.getBuilderPagePath(path, this.pageContext.rootPath);

                // 拼接builder集成也url参数
                let _sourceId;
                if (this.$filter('lowercase')(productType) == this.$filter('lowercase')(ProductTypeEnum.CONFIGURABLE)) {
                    _sourceId = String(propertyModelId);
                } else {
                    // TODO 暂不支持（无sku产品类型的产品详情页面）
                    // if (this.$filter('lowercase')(productType) == this.$filter('lowercase')(ProductTypeEnum.SKU)) {
                    //     _sourceId = String(this.currentProductId);
                    // } 
                    // 
                    window.qpAlertPrompt.info(this.$translate.instant('PRODUCT_DETAIL_INVALID_ORDER_A_SAMPLE_TITLE'), this.$translate.instant("PRODUCT_DETAIL_INVALID_ORDER_A_SAMPLE_CONTENT"));
                    return;
                }
                let builderPath = this.urlBuilder.setUrlParams(builderPagePath, {
                    // TODO source路径方法待改善
                    source: "productDetail",
                    sourceId: _sourceId,
                    qty: "1",
                    prePath: window.location.pathname,
                    productType: productType,
                    propertyModelVersion: "V1"
                }, this)
                if (!angular.isUndefined(this.$scope.cmsConfigVersion)) {
                    builderPath = this.urlBuilder.setUrlParams(builderPath, {
                        cmsConfigVersion: String(this.$scope.cmsConfigVersion)
                    }, this)
                }
                // 设置店铺产品ID参数
                if (!angular.isUndefined(this.storeProductId)) {
                    builderPath = this.urlBuilder.setUrlParams(builderPath, {
                        storeProductId: String(this.storeProductId)
                    }, this)
                }
                // 跳转至builder定制页
                window.location.href = builderPath;
            })
            .catch((error) => {
                this.permissionService.onRequestFail(error);
            })
            .finally(() => {
                this.propertyLock = false;
            })

    }

    /**
     * @description 切换产品展示图
     * @param targetIndex 
     */
    public changeExhibitImage(targetIndex: number) {
        this.imageActiveIndex = targetIndex;
    }

    /**
    * @description 向左、右移动滚动条
    * @param 
    */
    public descriptionLeft() {
        $(".nav-tabs").animate({ scrollLeft: "-=206" }, 400);
    }
    public descriptionRight() {
        $(".nav-tabs").animate({ scrollLeft: "+=206" }, 400);
    }

    /**
     * @description 保存当前属性表单
     * @param propertyModel 
     * @returns 
     */
    private saveProperty(propertyModel: PropertyModel): angular.IPromise<IResponse<PropertyModel>> {
        const defer = this.$q.defer<IResponse<PropertyModel>>();

        this.propertyService.save(this.propertyDomain)
            .then(resp => {
                if (!resp.success) {
                    defer.resolve(resp);
                    return;
                }
                // 属性不合法时,保存会失败
                const isLegal = PropertyModelManager.checkPropertyModelLegal(resp.data);
                if (isLegal) {
                    defer.resolve(resp);
                    return;
                }
                // 属性不合法处理:给出提示,并更新视图,在UI上显示错误信息
                this.propertyDomain = resp.data;
                this.propertyService.updateViewValue(this.propertyMap, this.propertyDomain, this.$scope.profileKey)
                // 属性不合法时,不给出弹窗提示
                // window.qpAlertPrompt.info(this.$translate.instant('DETAIL_INPUT_ERROR_TITLE'), this.$translate.instant("DETAIL_INPUT_ERROR"));
                resp.success = false;
                defer.resolve(resp);
            }).catch((error) => {
                this.permissionService.onRequestFail(error);
                defer.reject(error);
            })

        return defer.promise;
    }

    /**
     * @description 添加产品到购物车（完备产品）
     * */
    public addToCart() {

        // TODO V2-propertyForm校验属性表单-派发事件
        if (this.$scope.formCode) {
            const eventId = ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_ADD_TO_CARD;
            this.propertyFormValidate(eventId);
            return;
        }

        // 检查属性是否合法,属性不合法时,拒绝提交
        if (!PropertyModelManager.checkPropertyModelLegal(this.propertyDomain)) {
            // 属性不合法时,不给出弹窗提示
            // window.qpAlertPrompt.info(this.$translate.instant('DETAIL_INPUT_ERROR_TITLE'), this.$translate.instant("DETAIL_INPUT_ERROR"));
            this.qpLoading.close();
            return
        }
        // 产品最小购买数量MOQ--是否处于加载状态
        if (this.operationStats.updateQty) {
            return;
        }
        // 校验产品类型--是否为成品产品
        if (!this.$scope.isFinished) {
            window.qpAlertPrompt.info(this.$translate.instant('A103B0011'), this.$translate.instant("A103B0012"));
            return;
        }
        // 校验产品购买数量--是否大于等于1,小于最大值
        if (this.productQuantity < this.moq || this.productQuantity > this.QTYMAXLIMIT || !this.productQuantity) {
            window.qpAlertPrompt.info(this.$translate.instant('A103B0013'), this.$translate.instant("A103B0014"));
            return;
        }

        this.qpLoading.open();
        //保存propertyModel，创建sku产品
        this.saveProperty(this.propertyDomain)
            .then(resp => {
                if (!resp.success) {
                    return;
                }
                let pmResp = resp;
                const propertyModelId = pmResp.data._id;
                let addCartParams: ICartParams = {
                    propertyModelId: pmResp.data._id,
                    qty: this.productQuantity,
                    // 旧接口数据兼容
                    productInstanceName: null
                }
                if (!angular.isUndefined(this.storeProductId)) {
                    addCartParams.storeProductId = this.storeProductId;
                }
                return this.cartRestService.addToCart(addCartParams)
            })
            .then(resp => {
                if (!resp) {
                    return;
                }
                // 跳转购物车页
                window.location.href = this.pageContext.rootPath + "cart/";
            })
            .catch(error => {
                // 请求常规错误处理
                this.permissionService.onRequestFail(error);
            })
            .finally(() => {
                this.qpLoading.close();
            })

    }




    /*********************************** Chore *********************************/
    // 产品详情页状态(实名登录状态/匿名登录状态)
    public state: IProductDetailState;
    // 产品属性viewValue
    public propertyViewValue: IPropertyViewValue;
    public configurableProductId: number;
    // 产品属性的model值
    public propertyDomain: PropertyModel;

    /**
     * @description 修改当前Controller状态
     * @param state 
     */
    private changeState(state: IProductDetailState) {
        this.state = state;
        this.state.setContext(this);
    }

    /**
     * @description 获取当前Controller状态
     */
    private getCurrentState(): IProductDetailState {
        if (this.$objectTree.isAnonymous()) {
            return new ProductDetailAnonymous(this.userManager, this.$objectTree);
        } else {
            return new ProductDetailAuthorized(this.$objectTree, this.partnerRestService, this.qpLoading, this.$uibModal, this.$scope, this.pageContext, this.$window, this.productV2RestService, this.$q, this.builderRestService);
        }
    }

    private checkInitParameter(): boolean {
        return true;
    }

    private initScopeByCMS() {
        const currentProductIdElem = document.getElementById("currentProductId");
        const productNameElem = document.getElementById("productName");
        const symbolElem = document.getElementById("symbol");
        const currencyCodeElem = document.getElementById("currencyCode");
        const isFinishedElem = document.getElementById("isFinished");

        const versionedProductAttributeIdElem = document.getElementById("versionedProductAttributeId");
        const publishProfileCodesSizeElem = document.getElementById("publishProfileCodesSize");
        const publishProfileCodesElem = document.getElementById("publishProfileCodes");
        const publishProfileIdsElem = document.getElementById("publishProfileIds");
        const configVersionElem = document.getElementById("configVersion");

        const publishAppTag = document.getElementById("appTag");
        const publishAppName = document.getElementById("appName");

        const hasMoqElem = document.getElementById("hasMoq");
        const moqElem = document.getElementById("moq");

        const pricingCountryNameElem = document.getElementById("countryName");
        const pricingCountryCodeElem = document.getElementById("countryCode");

        const formCodeElem = document.getElementById("formCode");

        const attributeVersionNumberElem = document.getElementById("attributeVersion");
        // 当前产品设计模式
        const defaultDesignModelElem = document.getElementById("currentAttributeDesignMethod");
        // 属性关联产品设计模式
        const attributeRelationDesignMethodElem = document.getElementById("attributeRelationDesignMethod");
        // 产品设计版本
        const designMethodVersionElem = document.getElementById("designMethodVersion");
        // 是否固定价格
        const fixedPriceElem = document.getElementById("fixedPrice");
        // 是否属性相关
        const priceAffectedByAttributeElem = document.getElementById("priceAffectedByAttribute");
        // 是否数量相关
        const priceAffectedByQuantityElem = document.getElementById("priceAffectedByQuantity");
        // 价格类型
        const priceTypeElem = document.getElementById("priceType");
        // 离散价格范围
        const discretePriceRangeElem = document.getElementById("discretePriceRange");

        this.$scope.currentProductId = angular.element(currentProductIdElem as HTMLElement).val() as string;
        this.$scope.symbol = angular.element(symbolElem as HTMLElement).val() as string;
        this.$scope.currencyCode = angular.element(currencyCodeElem as HTMLElement).val() as string;
        const isFinishedCMS = angular.element(isFinishedElem as HTMLElement).val() as string;
        this.$scope.isFinished = isFinishedCMS == "true" ? true : false;
        // 设置默认值,以防止旧版本CMS上下文中未配置
        this.$scope.pricingSetting = {
            name: "United States",
            isoCode2: "USD"
        }


        if (versionedProductAttributeIdElem) {
            const str_version = angular.element(versionedProductAttributeIdElem as HTMLElement).val() as string;
            this.$scope.attributeVersion = Number(str_version);
        }

        if (publishProfileCodesSizeElem) {
            const publishProfileCodespublishProfileCodesSize = angular.element(publishProfileCodesSizeElem as HTMLElement).val() as string;

            this.$scope.profileKey = Number(publishProfileCodespublishProfileCodesSize) > 0 ? 'code' : 'id';

            this.$scope.publishProfileCodes = [];
            const codeItem = angular.element(publishProfileCodesElem as HTMLElement).val() as string;
            this.$scope.publishProfileCodes.push(codeItem);
        }

        if (publishProfileIdsElem) {
            this.$scope.publishProfileIds = [];
            const profileIdItem = angular.element(publishProfileIdsElem as HTMLElement).val() as string;
            this.$scope.publishProfileIds.push(Number(profileIdItem));
        }

        if (configVersionElem) {
            const version_str = angular.element(configVersionElem as HTMLElement).val() as string;

            this.$scope.cmsConfigVersion = Number(version_str);
        }

        if (publishAppTag) {
            const publishAppTag_str = angular.element(publishAppTag as HTMLElement).val() as string;

            this.$scope.publishAppTag = publishAppTag_str;
        }

        if (publishAppName) {
            const publishAppName_str = angular.element(publishAppName as HTMLElement).val() as string;

            this.$scope.publishAppName = publishAppName_str;
        }

        if (hasMoqElem) {
            const hasMoqElem_str = angular.element(hasMoqElem as HTMLElement).val() as string;
            this.$scope.hasMoq = Boolean(hasMoqElem_str);
        }
        if (moqElem) {
            const moqElem_str = angular.element(moqElem as HTMLElement).val() as string;
            this.$scope.moq = Number(moqElem_str);
            this.moq = this.$scope.moq ? this.$scope.moq : 1;
        }

        if (pricingCountryNameElem) {
            const pricingCountryNameElem_str = angular.element(pricingCountryNameElem as HTMLElement).val() as string;
            const pricingCountryCodeElem_str = angular.element(pricingCountryCodeElem as HTMLElement).val() as string;

            this.$scope.pricingSetting.name = pricingCountryNameElem_str;
            this.$scope.pricingSetting.isoCode2 = pricingCountryCodeElem_str;
        }
        if (formCodeElem) {
            const formCodeElem_str = angular.element(formCodeElem as HTMLElement).val() as string;
            this.$scope.formCode = formCodeElem_str;
        }
        if (attributeVersionNumberElem) {
            const attributeVersionNumberElem_str = angular.element(attributeVersionNumberElem as HTMLElement).val() as string;
            this.$scope.attributeVersionNumber = attributeVersionNumberElem_str;
        }
        // 默认产品设计模式
        if (defaultDesignModelElem) {
            const defaultDesignModelElem_str = angular.element(defaultDesignModelElem as HTMLElement).val() as string;
            this.$scope.defaultDesignModel = defaultDesignModelElem_str;
            this.designModel = this.$scope.defaultDesignModel;
            this.designModelName = this.getDesignModelName(this.designModel);
        }
        // 属性关联产品设计模式
        if (attributeRelationDesignMethodElem) {
            const attributeRelationDesignMethodElem_str = angular.element(attributeRelationDesignMethodElem as HTMLElement).val() as string;
            this.$scope.attributeRelationDesignMethod = attributeRelationDesignMethodElem_str === 'true' ? true : false;
            this.attributeRelationDesignMethod = this.$scope.attributeRelationDesignMethod;
        } else {
            this.attributeRelationDesignMethod = false;
        }
        // 产品设计版本
        if (designMethodVersionElem) {
            const designMethodVersionElem_number = angular.element(designMethodVersionElem as HTMLElement).val();
            this.$scope.designMethodVersion = (is.undefined(designMethodVersionElem_number) || designMethodVersionElem_number === "") ? 1 : Number(designMethodVersionElem_number);
        } else {
            this.$scope.designMethodVersion = 1;
        }
        // 是否固定价格
        if (fixedPriceElem) {
            const fixedPriceElem_str = angular.element(fixedPriceElem as HTMLElement).val() as string;
            this.fixedPrice = this.$scope.isFixedPrice = fixedPriceElem_str === 'true' ? true : false;
        } else {
            this.fixedPrice = this.$scope.isFixedPrice = false;
        }
        // 是否属性相关
        if (priceAffectedByAttributeElem) {
            const priceAffectedByAttributeElem_str = angular.element(priceAffectedByAttributeElem as HTMLElement).val() as string;
            this.needChangedWhenAttrs = this.$scope.priceAffectedByAttribute = priceAffectedByAttributeElem_str === 'true' ? true : false;
        } else {
            this.needChangedWhenAttrs = this.$scope.priceAffectedByAttribute = false;
        }
        // 是否数量相关
        if (priceAffectedByQuantityElem) {
            const priceAffectedByQuantityElem_str = angular.element(priceAffectedByQuantityElem as HTMLElement).val() as string;
            this.needChangedWhenQty = this.$scope.priceAffectedByQuantity = priceAffectedByQuantityElem_str === 'true' ? true : false;
        } else {
            this.needChangedWhenQty = this.$scope.priceAffectedByQuantity = false;
        }
        // 价格类型
        if (priceTypeElem) {
            const priceTypeElem_str = angular.element(priceTypeElem as HTMLElement).val() as WhiteLabelPriceTypeEnum;
            this.priceType = this.$scope.priceType = priceTypeElem_str;
        }

        // 离散价格范围
        if (discretePriceRangeElem) {
            const discretePriceRangeElem_str = angular.element(discretePriceRangeElem as HTMLElement).val() as string;
            this.qtyList = this.$scope.discretePriceRange = discretePriceRangeElem_str.split(',').map(Number);
        } else {
            this.qtyList = this.$scope.discretePriceRange = [];
        }
    }

    @CatchError({ title: "Init fail" })
    private initObjectTree() {
        if (!this.$scope.currentProductId) {
            throw new BusinessException("Missing current product id");
        }
        // 设置当前产品id
        this.$objectTree.currentProductId = Number(this.$scope.currentProductId);
        if (this.$scope.symbol) {
            this.$objectTree.symbol = this.$scope.symbol;
        }
        // 初始化产品图片
        this.$objectTree.productImages = this.images;
        // 初始化产品名称
        this.$objectTree.productName = this.$scope.productName;
    }

    /**
     * @description 页面权限校验
     * 只有内部Partner可以访问内部产品
     * 非内部产品所有Partner都可以访问
     * @param isInternal 
     */
    private permission(isInternal: boolean): boolean {
        // 非内部产品都可以访问
        if (!isInternal) {
            return true;
        }
        // 内部产品需检查当前是否是内部Partner
        return this.$objectTree.isInternalPartner() && isInternal
    }



    private setSpecificationNum() {
        // 通过媒体查询,判断当前屏幕下能够显示多少个元素
        const query = {
            xs: "(max-width:768px)",
            sm: "(min-width:768px)",
            md: "(min-width:992px)",
            lg: "(min-width:1200px)"
        }


        ReactiveQuery.subscribe(query, screen => {
            this.$timeout(() => {
                // 视口的变化处理
                // 视窗大于1200px,显示4个产品描述项
                if (screen.lg) {
                    this.specDisplayNum = 4;
                } else if (!screen.lg && screen.md) {
                    // 视窗小于1200且大于992px,显示3个产品描述项
                    this.specDisplayNum = 3;
                } else if (screen.sm && !screen.md) {
                    // 视窗小于992px且大于768px,显示2个产品描述项
                    this.specDisplayNum = 2;
                } else if (screen.xs) {
                    this.specDisplayNum = 1;
                }
            })

        })

    }

    /**
     * @description 页面初始化处理
     */
    public $onInit() {
        this.controlInit();
    }

    public controlInit() {
        // TODO 获取用户默认货币code 
        this.$objectTree.userPreference.then(res => {
            // TODO 设置用户默认货币code
            this.userCurrencyCode = res.currencyCode;
            this.setSpecificationNum();
            this.initScopeByCMS();
            // 设置产品最小购买数量MOQ，作为productQuantity初始值
            this.productQuantity = this.moq;
            // 设置更新产品购买数量状态
            this.operationStats.updateQty = false;
            // 检查用户页面访问权限及token过期处理
            this.checkAuthorization(() => {

                // 获取页面url地址参数
                this.urlParameter = this.$window.location.search
                // 检查页面初始化参数完整性(url路径是否正确)
                let result = this.checkInitParameter();
                // 获取url路径中的storeId参数（页面来源：个人中心-->店铺产品列表-->添加店铺产品-->产品分类跳转来）  
                let urlrlParameter: PageUrlParams | null = this.urlBuilder.getUrlParameters();
                this.sourceStoreId = (urlrlParameter && urlrlParameter.storeId) ? urlrlParameter.storeId : undefined;
                this.sourceStoreName = (urlrlParameter && urlrlParameter.storeName) ? urlrlParameter.storeName : undefined;
                this.sourceStoreUrl = (urlrlParameter && urlrlParameter.storeUrl) ? urlrlParameter.storeUrl : undefined;
                if (urlrlParameter && urlrlParameter.storeType) {
                    this.storeType = urlrlParameter.storeType as StoreType;
                }

                // 设置店铺产品Id
                if (urlrlParameter && urlrlParameter.storeProductId) {
                    this.storeProductId = urlrlParameter.storeProductId;
                }

                // 设置url地址参数propertyModelId
                if (urlrlParameter && urlrlParameter.propertyModelId) {
                    this.urlPropertyModelId = urlrlParameter.propertyModelId;
                }
                // 设置页面当前锚点
                if (urlrlParameter && urlrlParameter.anchor) {
                    if (urlrlParameter.anchor === 'shipping') {
                        this.currentAnchId = '#productInfo';
                    }
                }
                // 设置Url地址参数designMode
                if (urlrlParameter && !is.undefined(urlrlParameter.designMode) && urlrlParameter.designMode) {
                    this.designModel = urlrlParameter.designMode;
                }

                // TODO初始化参数异常处理
                if (!result) { }
                // objectTree初始化
                this.initObjectTree();
                // 当前Ctrl状态
                let _state = this.getCurrentState();
                // 设置页面状态
                this.changeState(_state);
                this.qpLoading.open();
                // TODO propertyForm临时修改
                if (this.$scope.formCode) {
                    this.onInitByV2Property();
                    return;
                }
                // profileKey
                const _profileKey = this.$scope.profileKey;
                // 检查当前产品是否是内部产品
                // const isInternalPromise = this.productV2RestService.isInternal(Number(this.$scope.currentProductId));
                // 获取默认PropertyModel
                let defaultModelPromise;
                if (urlrlParameter && urlrlParameter.propertyModelId) {
                    const propertyModelId = Number(urlrlParameter.propertyModelId)
                    defaultModelPromise = this.propertyService.getProductProperty(Number(this.$scope.currentProductId), propertyModelId, this.$scope.attributeVersion);
                } else {
                    defaultModelPromise = this.propertyService.getProductProperty(Number(this.$scope.currentProductId), undefined, this.$scope.attributeVersion);
                }
                // const productDataPromise = angular.isUndefined(this.$scope.attributeVersion) ? this.productV2RestService.getOne(Number(this.$scope.currentProductId)) : this.productV2RestService.getOne(Number(this.$scope.currentProductId), this.$scope.attributeVersion);

                this.$q.all([defaultModelPromise])
                    .then(resp => {
                        const propertyResp = resp[0];
                        const productResp = resp[1];
                        // 无propertyModel详情页初始化
                        if (!propertyResp) {
                            this.initFinish = true;
                            return;
                        }

                        // this.currentProduct = productResp.data;

                        const defaultPropertyModel = propertyResp.data as PropertyModel;
                        // 由于在CMS过程中,设置需要显示的Profile可能与默认返回的active Profile不是同一个,因此需要在这里重置激活的Profile
                        defaultPropertyModel.profileModels.forEach(profileItem => {
                            // 通过profileCode查找
                            if (this.$scope.publishProfileCodes && this.$scope.publishProfileCodes.length > 0) {
                                const PROFILE_CODE = profileItem.profile.code as string;

                                profileItem.isActive = this.$scope.publishProfileCodes.indexOf(PROFILE_CODE) > -1 ? true : false;
                            } else {
                                // 通过profileId查找
                                const PROFILE_ID = profileItem.profile._id;

                                profileItem.isActive = this.$scope.publishProfileIds.indexOf(Number(PROFILE_ID)) > -1 ? true : false;
                            }
                        })

                        // 设置属性model值
                        this.propertyDomain = defaultPropertyModel;
                        if (this.propertyDomain.configurableProductId) {
                            this.$objectTree.configurableProductId = this.configurableProductId = this.propertyDomain.configurableProductId;
                        }
                        /******************** */
                        // 监听属性viewValue,viewValue改变后,触发属性更改后处理
                        // this.watchProperty();
                        // 绑定变量
                        this.productName = this.$scope.productName;
                        // this.symbol = this.$scope.symbol;
                        this.currentProductId = this.$scope.currentProductId;
                        // TODO 暂时只支持单profile
                        // this.$timeout(() => {
                        //     this.propertyMap = this.propertyService.creatPropertyViewValue(this.propertyDomain, this.$scope.profileKey);
                        //     this.propertyService.updateViewValue(this.propertyMap, this.propertyDomain, this.$scope.profileKey);
                        //     if (PropertyModelManager.checkPropertyModelLegal(this.propertyDomain)) {
                        //         const profile = this.propertyDomain.profileModels.find(item => {
                        //             return item.isActive;
                        //         })
                        //         const _profileId = isUndefined(profile) ? undefined : profile?.profile._id;
                        //         //根据当前propertyModel数据，获取当前属性键值对
                        //         const propertyKeyValue = this.creatPropertyKeyValue(this.propertyDomain);
                        //         // 产品属性与产品设计先关，先更新产品设计模式，后触发相关更新（最小购买数量|属性计价|预估配送费用）
                        //         const productId = this.$scope.currentProductId;
                        //         const skuAttributeValues: Array<ISkuAttributeValue> = this.creatPropertyKeyValueBySkuAtrCode(this.propertyDomain);
                        //         const versionedAttributeId = this.$scope.attributeVersion;
                        //         this.updateDesignModelInfo(productId, skuAttributeValues, _profileId, versionedAttributeId, this.designModel)
                        //             .then(designModel => {
                        //                 // 更新数量计价表
                        //                 this.addToPricingQueue();
                        //                 // 跳转锚点
                        //                 if (this.currentAnchId) {
                        //                     // 获取页面锚点数组
                        //                     this.anchIdArr = [];
                        //                     this.getAnchIdArr();
                        //                     this.anchIdArr.forEach((ele, index) => {
                        //                         if (ele.nodeTop <= Math.ceil(document.documentElement.scrollTop) && (index == this.anchIdArr.length - 1)) {
                        //                             this.currentAnchId = ele.id;
                        //                             return;
                        //                         }
                        //                         if (ele.nodeTop <= Math.ceil(document.documentElement.scrollTop) && this.anchIdArr[index + 1].nodeTop > document.documentElement.scrollTop) {
                        //                             this.currentAnchId = ele.id;
                        //                         }
                        //                     });
                        //                     //shipping信息开启
                        //                     this.activeInfoIndex = 1;
                        //                     this.infoStatusInMobile.shippingIsOpen = true;
                        //                     this.changeCurrentanchId(this.currentAnchId)
                        //                 }
                        //                 //加载预估产品配送费用
                        //                 this.initDeliveriesInfo();
                        //             })
                        //     }
                        // })
                        this.propertyMap = this.propertyService.creatPropertyViewValue(this.propertyDomain, this.$scope.profileKey);
                        this.propertyService.updateViewValue(this.propertyMap, this.propertyDomain, this.$scope.profileKey);
                        if (PropertyModelManager.checkPropertyModelLegal(this.propertyDomain)) {
                            const profile = this.propertyDomain.profileModels.find(item => {
                                return item.isActive;
                            })
                            const _profileId = isUndefined(profile) ? undefined : profile?.profile._id;
                            //根据当前propertyModel数据，获取当前属性键值对
                            const propertyKeyValue = this.creatPropertyKeyValue(this.propertyDomain);
                            // 产品属性与产品设计先关，先更新产品设计模式，后触发相关更新（最小购买数量|属性计价|预估配送费用）
                            const productId = this.$scope.currentProductId;
                            const skuAttributeValues: Array<ISkuAttributeValue> = this.creatPropertyKeyValueBySkuAtrCode(this.propertyDomain);
                            const versionedAttributeId = this.$scope.attributeVersion;
                            return this.updateDesignModelInfo(productId, skuAttributeValues, _profileId, versionedAttributeId, this.designModel)
                        }
                    })
                    .then(designModel => {
                        // 初始化离散计价参数
                        this.getRestConfig().then((res) => {
                            this.restConfig = res;
                        })
                        // 更新数量计价表
                        this.addToPricingQueue();
                        // 获取询价组件的propertyModelId（初始化时派发事件）
                        this.getPropertyModelIdForInquiryPrice().then(propertyModelId => {
                            this.propertyModelId = propertyModelId;
                        });
                        // 跳转锚点
                        if (this.currentAnchId) {
                            // 获取页面锚点数组
                            this.anchIdArr = [];
                            this.getAnchIdArr();
                            this.anchIdArr.forEach((ele, index) => {
                                if (ele.nodeTop <= Math.ceil(document.documentElement.scrollTop) && (index == this.anchIdArr.length - 1)) {
                                    this.currentAnchId = ele.id;
                                    return;
                                }
                                if (ele.nodeTop <= Math.ceil(document.documentElement.scrollTop) && this.anchIdArr[index + 1].nodeTop > document.documentElement.scrollTop) {
                                    this.currentAnchId = ele.id;
                                }
                            });
                            //shipping信息开启
                            this.activeInfoIndex = 1;
                            this.infoStatusInMobile.shippingIsOpen = true;
                            this.changeCurrentanchId(this.currentAnchId)
                        }
                        //加载预估产品配送费用
                        this.initDeliveriesInfo();
                    })
                    .catch((error) => {
                        this.permissionService.onRequestFail(error);
                    })
                    .finally(() => {
                        this.qpLoading.close();
                        this.initFinish = true;
                        // 移除操作区域悬浮效果（2025-1-21）
                        // this.fixedOperateBtn();
                    })
            })
        })
    }

    /**
     * @deprecated 2025-3-5
     * @description 初始化面包屑产品类目导航信息
     * */
    public breadcrumbOninit() {
        // 获取默认分类路径
        // let retCatalog = DefaultCatalogUtil.getDefaultCatalog(this.$objectTree, this.$q);
        // retCatalog.then((res) => {
        //     this.defaultCatalogUrl = UrlUtil.joinUrl([this.pageContext.rootPath, res.customizePath, (res.defaultCatalog as productCatalogWithPagePath).pagePath]);
        // }, (error) => {
        //     this.permissionService.onRequestFail(error);
        // })

        // 面包屑产品类目导航信息-加载中
        this.breadcrumbLoading = true;
        let breadcrumb: Array<IbreadcrumbProduct> = [];
        this.productCategoriesRestService.getCategories(Number(this.$scope.currentProductId)).then(res => {
            this.categoriesList = this.bubbleSort(res.data);
            // 面包屑配置数据--路由地址(记录当前page路径地址前缀，用于子类目路由配置地址url)
            let pagePathStr: string;
            this.categoriesList.forEach((item, index) => {
                // 当前关联产品类目对应的路由配置地址
                let pagePath: string = '';
                // 过滤pageName的“.html”字符
                if (item.pageName) {
                    item.pageName = item.pageName.replace('.html', '');
                } else {
                    const errorMsg = `productName:${item.name}, product Details CMS Release configuration Missing "pageName".`
                    this.sendError('product-detail.breadcrumbOninit()', errorMsg);
                    return;
                }
                // 创建面包屑产品类目配置数据--父类目（pageName/all），index==0时，当前产品类目为该产品类目的父节点
                if (index == 0) {
                    pagePathStr = item.pageName;
                    pagePath = pagePathStr + '/all';
                }
                // 创建面包屑产品类目配置数据--子类目（parentPageName/childPageName），当前产品类目为该产品类目的非父节点
                if (index > 0) {
                    pagePathStr = pagePathStr + '/' + item.pageName;
                    pagePath = pagePathStr;
                }
                // 生成面包屑产品类目配置数据
                if (pagePath.length > 0) {
                    let breadcrumbItem = {
                        name: item.name as string,
                        id: item.id as number,
                        pagePath: pagePath
                    }
                    breadcrumb.push(breadcrumbItem);
                }
            })
        }, error => {
            this.permissionService.onRequestFail(error);
        })
            .finally(() => {
                // 面包屑产品类目导航信息-加载完成
                this.breadcrumbLoading = false;
            })
        return breadcrumb;
    }

    /**
     * @description 面包屑树结构处理
     * @param source 
     * @returns 
     */
    public bubbleSort(source: Array<any>) {
        // 先找出根结点
        for (let j = 0; j < source.length; j++) {
            if (source[j].parentId == undefined) {
                let first = source[0];
                source[0] = source[j];
                source[j] = first;
            }
        }
        // 先找出第一个子结点
        for (let a = 1; a < source.length; a++) {
            if (source[a].parentId == source[0].id) {
                let first = source[1];
                source[1] = source[a];
                source[a] = first;
            }
        }
        // 冒泡,查找父节点并排序
        for (let i = 1; i < source.length; i++) {
            for (let j = 2; j < source.length; j++) {
                if (source[i].parentId && source[i].id == source[j].parentId) {
                    let child = source[j];
                    source[j] = source[i + 1];
                    source[i + 1] = child;
                } else {
                    continue;
                }
            }
        }

        return source;
    }

    private propertyWatchList: Array<any> = [];
    public cancelPropertyWatch() {
        this.propertyWatchList.forEach(item => {
            item();
        })
    }

    /**
     * @deprecated
     * @param key 
     */
    private changeViewProperty(key: string,) {
        // 属性更改后处理:执行属性计算|页面跳转
        this.propertyChangeService.afterPropertyChange({ viewValueKey: key, propertyViewValue: this.propertyMap[key], context: this });
    }


    /********************************************** Pricing ****************************************** */

    /**
     * @description 
     */
    public addToPricingQueue() {
        if (this.$scope.formCode) {
            this.addToPricingQueueByV2Property(this.propertyModelForm);
            return;
        }
        const attributePromise = this.propertyService.getAllAttributeValue(this);
        this.pricingQueue.push(attributePromise);

        // 若當前當前沒有執行價格計算，則觸發價格計算
        if (!this.isRequest_pricing) {
            this.doPricingCalculation();
        }
    }


    private doPricingCalculation() {
        // 检查计价队列是否为空,计价队列为空时,结束价格计算
        if (this.pricingQueue.length == 0) {
            this.isRequest_pricing = false;
            return;
        }
        this.isRequest_pricing = true;
        // 计价队列不为空,取队列最后一项执行价格计算
        const attrPromise = this.pricingQueue[this.pricingQueue.length - 1];
        // 清空计价队列
        this.pricingQueue.length = 0;
        attrPromise.then(attributeResp => {
            // 获取属性版本
            const attributeVersion = this.$scope.attributeVersion ? Number(this.$scope.attributeVersion) : undefined;
            // 执行价格计算
            if (!this.$objectTree.configurableProductId) {
                // TODO  configurableProductId参数缺失，弹框提示信息
                return;
            }
            // 获取产品设计模式，默认为固定设计"fixedDesign"
            const productDesignModel = this.designModel ? this.designModel : undefined;

            // 根据价格类型选择不同的计价方式
            if (this.verifyPriceType(WhiteLabelPriceTypeEnum.DISCRETE)) {
                // 获取产品数量
                const productQty = this.getPriceQty();
                this.doDiscretePricingCalculation(productQty, this.$objectTree.configurableProductId, attributeResp.data, attributeVersion);
            } else {
                // 阶梯计价和固定计价都默认拿阶梯价格表
                this.doIntervalPricingCalculation(this.$objectTree.configurableProductId, attributeResp.data, this.userCurrencyCode, productDesignModel, attributeVersion);
            }
        }, (rejectResp) => {
            this.isRequest_pricing = false;
            this.permissionService.onRequestFailed(rejectResp).then(e => {
                // 未知错误发送sentry
                this.sendError('product-deatail.productDetailController.doPricingCalculation.attrPromise', rejectResp);
            })
        })
    }

    /**
     * @description 阶梯计价计算
     * @param productId 
     * @param attributeData 
     * @param currencyCode 
     * @param designModel 
     * @param attributeVersion 
     */
    private doIntervalPricingCalculation(productId: number, attributeData: any, currencyCode: string, designModel?: string, attributeVersion?: number) {
        this.pricingService.getPricing(productId, attributeData, currencyCode, designModel, attributeVersion)
            .then(reps => {
                if (!reps) {
                    return;
                }
                // 更新价格列表
                this.pricingList = this.createPriceListViewValue(reps);
                // 获取产品数量
                const productQty = this.getPriceQty();
                // 更新产品售价
                this.productPrice = this.getIntervalPrice(productQty, this.pricingList);
                this.doPricingCalculation();
                
                // trackProductData
                let productData = this.initTrackProductData();
                this.purchaseTrackingService.trackProductDetail(productData, this.userCurrencyCode);
            }, (rejectResp) => {
                this.isRequest_pricing = false;
                let modalConfig: IMessageDialogOptions = {
                    title: this.$translate.instant("PRODUCT_DETAIL_PRICE_ISSUE_TITLE"),
                    content: this.$translate.instant("PRODUCT_DETAIL_PRICE_ISSUE_CONTENT", { supportmail: this.supportEmail }),
                }
                this.permissionService.onRequestFailed(rejectResp)
                    .then(e => {
                        if (!is.undefined(e) && !is.undefined(e.code)) {
                            if (e.code == "300310") {
                                // 平台货币配置缺失
                                const currentCurrency = e.errorParams?.currencyCode;
                                this.missingCurrencyConfigTipModal(modalConfig.title, currentCurrency);
                                return;
                            } else if (e.code == "3000601") {
                                //平台:{platformCode} 范围:{usageScope} 不支持货币:{currencyCode} ! 
                                const supportCurrencyCodes = e.errorParams.supportCurrencyCodes ? e.errorParams.supportCurrencyCodes.join(',') : undefined;
                                const platformCode = e.errorParams.platformCode;
                                const currentCurrency = e.errorParams.currencyCode;
                                this.nonsupportCurrencyTipModal(modalConfig.title, currentCurrency, platformCode, supportCurrencyCodes);
                                return;
                            } else {
                                this.qpMessageDialog.info(modalConfig);
                                // 未知错误发送sentry
                                this.sendError('product-deatail.productDetailController.doPricingCalculation.pricingService.getPricing', rejectResp);
                            }
                        } else {
                            this.qpMessageDialog.info(modalConfig);
                            // 未知错误发送sentry
                            this.sendError('product-deatail.productDetailController.doPricingCalculation.pricingService.getPricing', rejectResp);
                        }
                    })
            })
    }

    /**
     * @description 离散计价计算(带缓存)
     * @param qty 当前订单数量
     * @param productId 
     * @param attributeData 
     * @param attributeVersion 
     */
    private doDiscretePricingCalculation(qty: number, productId: number, attributeData: any, attributeVersion?: number) {
        // 创建当前属性快照作为pricing的key,进行价格缓存
        const attributeSnapshot = this.productDetailManager.creatAttributeSnapshot(attributeData);
        // 属性快照转为字符串，包含货币、设计模式和价格类型
        const snapshotKey = angular.toJson(attributeSnapshot) + `-${this.userCurrencyCode}` + `-${this.designModel}` + `-${WhiteLabelPriceTypeEnum.DISCRETE}` + `-${qty}`;

        // 检查缓存中是否存在当前属性快照的价格缓存
        if (this.discretePriceCache[snapshotKey]) {
            // 使用缓存数据更新产品售价
            const priceString = this.discretePriceCache[snapshotKey];
            if (priceString) {
                this.productPrice = priceString;
            }
            // 继续检查价格计算队列
            this.doPricingCalculation();
        } else {
            this.productPricingRestService.getDiscretePriceByAttrs(productId, [qty], attributeData, attributeVersion)
                .then((reps) => {
                    if (!reps) {
                        return;
                    }
                    const data = reps.data;
                    // 将价格信息加入缓存 并 更新产品售价
                    if (data && data.priceList && data.priceList.length > 0) {
                        this.productPrice = this.discretePriceCache[snapshotKey] = data.priceList[0].priceString;
                    }
                    // 继续检查价格计算队列
                    this.doPricingCalculation();
                }, error => {
                    this.isRequest_pricing = false;
                })
        }
    }


    /********************************************************************************************** */


    /**
     * @description 选中要添加产品的店铺，打开选择店铺模态框（partner为登录状态，且partner邮箱已激活;若产品包含产品属性,产品属性需合法）
     * @description 1、店铺未确定、店铺产品类型未确定：（1、选中店铺 --> 2、选择店铺产品类型）
     * @description 2、店铺已确定、店铺产品类型未确定：（1、选择店铺产品类型）
     */
    public openStoresAndTypeModal() {
        this.qpLoading.open();
        //产品包含propertyModal，进行校验产品属性，并保存propertyModel获取propertyModelId
        if (this.propertyDomain) {
            // 产品属性校验是否合法
            let isLegal = PropertyModelManager.checkPropertyModelLegal(this.propertyDomain);
            if (!isLegal) {
                this.qpLoading.close();
                // 产品属性校验失败，错误提示信息
                throw new BusinessException("A103B002");
            }
            // 保存当前PropertyModel，获取propertyModelId
            this.saveProperty(this.propertyDomain).then(resp => {
                if (!resp.success) {
                    return;
                }
                let propertyModel = resp.data as PropertyModel;

                let storeId: string | undefined = this.sourceStoreId ? this.sourceStoreId : undefined;
                this.qpLoading.close();
                this.state.selectedStore(propertyModel._id, storeId);
            }, error => {
                this.qpLoading.close();
                this.permissionService.onRequestFail(error);
            })
        } else {
            let storeId: string | undefined = this.sourceStoreId ? this.sourceStoreId : undefined;
            this.qpLoading.close();
            this.state.selectedStore(undefined, storeId);
        }
    }

    private remotePropertyModelMessage(sourcePM: PropertyModel): PropertyModel {
        if (!is.undefined(sourcePM) && !is.undefined(sourcePM.profileModels)) {
            sourcePM.profileModels.forEach(profileItem => {
                profileItem.attributeList.forEach(attrItem => {
                    attrItem.errorMsg = null;
                    if (!is.nullOrUndefined(attrItem.isLegal)) {
                        attrItem.isLegal = true;
                    }
                })
            })
        }
        return sourcePM;
    }

    // TODO 重置返回数据的dirty值,已和后台约定,暂时采用前端重置的方案,后续改为后端在返回数据时进行重置
    private resetIsdirty(propertyModel: PropertyModel) {
        propertyModel.profileModels.forEach(profileItem => {
            profileItem.attributeList.forEach(item => {
                item.isDirty = false;
            })
        })
    }
    /**
     * @description V1属性表单更新处理
     * */
    private calculateProperty(attributeId: number, value: string | number, key: string) {

        const keyInfo = key.split("-");
        // 获取当前用户更改属性所在的profile
        const profileKey = keyInfo[0];
        // 对PropertyModel对象进行深拷贝,基于深拷贝后的PropertyModel对象创建用于计算PropertyModel的请求对象
        //TODO(后期优化) const sourcePM: PropertyModel = deserialize(this.propertyDomain, PropertyModel);
        let sourcePM: PropertyModel = angular.fromJson(angular.toJson(this.propertyDomain));
        // sourcePM数据不存在--退出
        if (is.undefined(sourcePM)) {
            return;
        }
        // 去除PropertyModel中的错误信息
        sourcePM = this.remotePropertyModelMessage(sourcePM);
        let currentAttribute;
        try {
            // 获取当前用户操作的属性对象
            currentAttribute = PropertyModelManager.getAttributeById(attributeId, sourcePM.profileModels, profileKey);
        } catch (error) {
            window.qpAlertPrompt.warning("Program run parameter error", `Can not find attribute by id:${attributeId}`);
            return;
        }

        // 根据属性的enable和readonly检查当前属性能否被选中
        if (currentAttribute.selectType != "NON" && !PropertyModelManager.canSelect(value as number, currentAttribute)) {
            return;
        }


        // 根据属性类型(离散型|连续型)更新当前属性值
        if (currentAttribute.selectType == "NON") {
            PropertyModelManager.updateContinuousAttribute(value as string, currentAttribute);
        } else if (currentAttribute.selectType == "SINGLE") {
            PropertyModelManager.selectSingleDiscreteOption(value as number, currentAttribute);
        } else if (currentAttribute.selectType == "MULTI") {
            PropertyModelManager.selectMultiDiscreteOption(value as number, currentAttribute);
        }
        // sourcePM.configurableProductId = this.currentProductId;
        // 检查属性值是否发生过改变,只有属性值发生过改变才触发属性计算
        if (!currentAttribute.isDirty) {
            this.$timeout(() => {
                // this.propertyMap = this.propertyService.creatPropertyViewValue(sourcePM);                
                this.propertyService.updateViewValue(this.propertyMap, sourcePM, this.$scope.profileKey);
                this.qpLoading.close();
            })
            return;
        } else {
            this.qpLoading.open();
            // 调用REST接口执行计算
            this.propertyService.calculationAttribute(sourcePM, this.currentProductId).then((pmResp) => {
                if (!pmResp) {
                    return;
                }
                // TODO 重置返回数据的dirty值,已和后台约定,暂时采用前端重置的方案,后续改为后端在返回数据时进行重置
                this.resetIsdirty(pmResp.data);
                const activeProfile = pmResp.data.profileModels.find(item => {
                    return item.profile.code == profileKey || item.profile._id == profileKey;
                })
                if (!activeProfile) {
                    throw new Error("");
                }
                // 检查是否存在不合法的连续型属性
                const hasIllegal = PropertyModelManager.hasIllegalContinuousAttribute(activeProfile);
                // 有验证失败的连续型属性
                if (hasIllegal) {
                    // 保留错误信息,重置属性值
                    this.propertyDomain = PropertyModelManager.resetContinuousAttribute(this.propertyDomain, pmResp.data);
                } else {
                    this.propertyDomain = pmResp.data;
                }
                // this.propertyMap = this.propertyService.creatPropertyViewValue(pmResp.data);
                this.$timeout(() => {
                    this.propertyService.updateViewValue(this.propertyMap, this.propertyDomain, this.$scope.profileKey);
                    const isProductAttributesValid = PropertyModelManager.checkPropertyModelLegal(this.propertyDomain);

                    this.isProductAttributesValid = isProductAttributesValid;
                    this.dispatchInquiryPriceChange([
                        { propertyName: "isProductAttributesValid", value: isProductAttributesValid }
                    ]);

                    // 属性变化时重新获取propertyModelId（方法内部会派发事件通知组件）
                    this.getPropertyModelIdForInquiryPrice().then(propertyModelId => {
                        this.propertyModelId = propertyModelId;
                    });

                    if (isProductAttributesValid) {
                        const profile = this.propertyDomain.profileModels.find(item => {
                            return item.isActive;
                        })
                        const _profileId = isUndefined(profile) ? undefined : profile?.profile._id;
                        //根据当前propertyModel数据，获取当前属性键值对
                        const propertyKeyValue = this.creatPropertyKeyValue(this.propertyDomain);
                        // 产品属性与产品设计先关，先更新产品设计模式，后触发相关更新（最小购买数量|属性计价|预估配送费用）
                        const productId = this.$scope.currentProductId;
                        const skuAttributeValues: Array<ISkuAttributeValue> = this.creatPropertyKeyValueBySkuAtrCode(this.propertyDomain);
                        const versionedAttributeId = this.$scope.attributeVersion;
                        this.updateDesignModelInfo(productId, skuAttributeValues, _profileId, versionedAttributeId)
                            .then(designModel => {
                                // 更新MOQ数量
                                this.updateMinOrderQty(propertyKeyValue)
                                    .then(resMoq => {
                                        // 设置最小购买数量
                                        this.moq = resMoq;
                                        // 如果当前为离散价格表且价格受属性影响 或者 当前为阶梯价格表则更新产品价格（固定价格时没有价格类型，不执行更新）
                                        if (this.isNeedUpdatePrice(ChangeType.Attr)) {
                                            this.addToPricingQueue();
                                            this.propertyService.getAllAttributeValue(this).then((attributeResp) => {
                                                if (attributeResp.data && attributeResp.data.length > 0) {
                                                    const params: IAttrChangeEventParams = {
                                                        attrKeys: attributeResp.data
                                                    };
                                                    this.eventBus.dispatch(this.discretePriceEventName.attrChangeEventName, params);
                                                }
                                            })
                                        }
                                        // 触发预估配送费用更新
                                        if (this.tabShippingShow || this.infoStatusInMobile.shippingIsOpen) {
                                            // 获取预估配送费用信息
                                            this.searchDeliveryInfo(this.propertyDomain, this.shippingQty);
                                        }
                                    }, error => {
                                        this.permissionService.onRequestFailed(error);
                                    })

                            })
                    }
                })

            }, (error) => {
                // 错误处理-属性计算失败
                this.permissionService.onRequestFailed(error)
                    .then(e => {
                        // TODO 需后端添加对应的errorCode（后期优化）
                        let modalConfig: IMessageDialogOptions = {
                            title: this.$translate.instant("A103B0019"),
                            content: this.$translate.instant("A103B0020", { supportmail: this.supportEmail }),
                        }
                        this.qpMessageDialog.info(modalConfig);
                    })

                // if (error.data.data.code == 500) {
                //     window.qpAlertPrompt.error('A103B0015', 'A103B0017');
                // } else {
                //     this.permissionService.onRequestFail(error);
                // }
            }).finally(() => {
                this.qpLoading.close();
            })
        }

    }

    public dispatchInquiryPriceChange(changes: Array<{ propertyName: string; value: any }>): void {
        this.eventBus.dispatch(DiscretePriceEventName.InquiryPriceChange, changes);
    }

    /**
     * @description 获取询价组件的propertyModelId
     * 每次调用接口获取，先派发undefined通知组件加载，完成后派发新值
     * @param dispatchEvent 是否派发事件通知组件更新，默认为true
     */
    public getPropertyModelIdForInquiryPrice(dispatchEvent: boolean = true): angular.IPromise<string | undefined> {
        const defer = this.$q.defer<string | undefined>();

        if (!this.propertyDomain) {
            if (dispatchEvent) {
                this.dispatchInquiryPriceChange([
                    { propertyName: "propertyModelId", value: undefined }
                ]);
            }
            defer.resolve(undefined);
            return defer.promise;
        }

        // 先派发undefined通知组件开始加载
        if (dispatchEvent) {
            this.dispatchInquiryPriceChange([
                { propertyName: "propertyModelId", value: undefined }
            ]);
        }

        // 调用已存在的getPropertyModelId方法获取
        this.getPropertyModelId(this.propertyDomain).then(propertyModelId => {
            if (dispatchEvent) {
                this.dispatchInquiryPriceChange([
                    { propertyName: "propertyModelId", value: propertyModelId }
                ]);
            }
            defer.resolve(propertyModelId);
        }, error => {
            if (dispatchEvent) {
                this.dispatchInquiryPriceChange([
                    { propertyName: "propertyModelId", value: undefined }
                ]);
            }
            defer.resolve(undefined);
        });

        return defer.promise;
    }

    /**
     * @description 测试方法：手动设置产品属性校验状态
     * @param isValid 校验状态（字符串"true"/"false"）
     */
    public testSetProductAttributesValid(isValid: string): void {
        this.isProductAttributesValid = isValid === 'true';
        this.dispatchInquiryPriceChange([
            { propertyName: 'isProductAttributesValid', value: this.isProductAttributesValid }
        ]);
    }


    public seeMoreRelate(relatePath) {
        window.open(`${this.pageContext.rootPath}${relatePath}`, 'play1', 'toolbar=no,location=no,directories=no,status=no,menubar=no,resizable=no,copyhistory=no,scrollbars=yes,width=830,height=600');
    }




    /************************************** 详情预估运费 ******************************************/

    // 预估配送费用可选国家列表
    private countryList: Array<qpmn.user.model.domain.area.ICountryContent>;
    // 当前选中国家
    private preSearchCountry;
    // 查询的国家
    private searchCountry: qpmn.user.model.domain.area.ICountryContent | undefined;
    // 查询的国家
    private currentCountry: qpmn.user.model.domain.area.ICountryContent;
    // 查询的产品（SKU产品Id）
    private searchSkuId: string;
    // 默认查询国家
    private defaultDeliveryCountry: qpmn.user.model.domain.area.ICountryContent;
    // 配送地区预估费用查询记录
    private deliveryCtyQtyHistory: Array<string>;
    // 分页查询-单页查询最大值
    private MAX_INT_VAL = envConfig.maximumNumber;
    // 国家/地区列表信息加载
    private countryListloading: boolean;

    // 预估配送费用加载变量
    private deliveriesInfoLoading: boolean;

    //预估配送信息--地区配送信息本地缓存数据
    private skuCountryDeliveryCache: ISkuCountryDeliveryCache;

    // 预估配送信息-产品信息本地缓存数据
    private skuProductInfoCache: ISkuProductInfoCache;

    // 预估配送信息视图数据
    private skuDeliveriesViewValue: Array<ISkuDeliveryView>;
    // TODO 新预估配送费用视图
    private newDeliveryViewValue: ISkuDeliveryView;

    // 预估配送信息--展示视图标识记录
    private deliveryViewRecord: IDeliveryViewRecord;
    // TODO 产品信息-shipping显示状态
    private tabShippingShow: boolean;
    // 自定义产品配送数量
    private shippingQty: number | undefined;
    // 产品配送费用表单下载状态
    private shippingExcelLoading: boolean;



    /**
     * 初始化
     * 1.获取国家列表(单独的UI状态控制:单独的变量)(默认国家)
     * 2.通过产品id查询预估运费(取默认国家)
     * 3.查询产品信息(属性、名称)
     */
    public initDeliveriesInfo() {
        // 禁止点击触发
        if (this.deliveriesInfoLoading || this.countryListloading) {
            return;
        }
        // 预估配送费用可选国家为空--获取预估配送费用可选国家数据
        if (!this.countryList || !this.currentCountry) {
            // 国家列表信息加载-开启
            this.countryListloading = true;
            // 获取国家列表信息
            this.countryRestService.getUsableCountries(1, this.MAX_INT_VAL)
                .then(respData => {
                    // 设置国家列表信息--预估配送费用可选国家
                    this.countryList = respData.data.content;
                    // 设置默认国家
                    for (let country of this.countryList) {
                        if (country.isoCode2 == "US") {
                            // 设置默认选择country为美国
                            this.currentCountry = country;
                            break;
                        }
                    }
                    if (!this.currentCountry) {
                        // 设置默认选择country为国家列表第一项
                        this.currentCountry = this.countryList[0];
                    }
                    // 国家列表信息加载-关闭
                    this.countryListloading = false;
                    // 根据产品属性表单数据和配送地区，查询预估产品配送费用-延迟执行
                    this.getDeliveryInfo();
                }, error => {
                    // 国家列表信息加载-关闭
                    this.countryListloading = false;
                    this.permissionService.onRequestFail(error);
                });
        } else {
            // 根据产品属性表单数据和配送地区，查询预估产品配送费用
            this.getDeliveryInfo();
        }
    }

    /**
     * @description 根据产品属性表单数据和配送地区，获取产品运费计价初始化数据
     * */
    public getDeliveryInfo() {
        // TODO  V2属性表单--处理
        if (this.$scope.formCode) {
            this.searchDeliveryInfo(undefined, this.shippingQty);
        } else {
            // TODO  V1属性表单--处理
            if (this.propertyDomain) {
                // 查询预估配送费用信息
                this.searchDeliveryInfo(this.propertyDomain, this.shippingQty);
            } else {
                // 循环获取预估产品配送费用
                this.$timeout(() => {
                    this.getDeliveryInfo();
                }, 500)
            }
        }
    }

    /**
     * 初始化-Shipping-Pc端
     */
    public initShippingByTab() {
        // 产品信息-shipping显示状态-显示
        this.tabShippingShow = true;
        if (!this.initFinish) {
            return;
        }
        this.initDeliveriesInfo();
    }
    /**
     * @description 初始化-Shipping-mobile端
     */
    public initShippingByAccordion() {
        if (!this.initFinish) {
            return;
        }
        this.initDeliveriesInfo();
    }
    /**
     * @description 关闭shipping
     * */
    private closeShippingByTab() {
        // 产品信息-shipping显示状态-隐藏
        this.tabShippingShow = false;
    }

    /**
     * @description 查询-本地预估配送费用缓存
     * @param cacheKey: attributs+countryCode+qtys
     * */
    public getSkuCountryDeliveryCache(cacheKey: string): ISkuDeliveryView | undefined {

        if (this.skuCountryDeliveryCache && this.skuCountryDeliveryCache[cacheKey]) {
            return this.skuCountryDeliveryCache[cacheKey];
        } else {
            return undefined;
        }
    }

    /**
     * @description 设置-预估配送信息--地区配送信息本地缓存数据
     * @param attrCtyCodeKey
     * @param deliveryInfo
     * */
    public setSkuCountryDeliveryCache(attrCtyCodeKey: string, deliveryInfo: ISkuDeliveryView) {
        if (angular.isUndefined(this.skuCountryDeliveryCache)) {
            this.skuCountryDeliveryCache = {};
        }
        this.skuCountryDeliveryCache[attrCtyCodeKey] = deliveryInfo;
    }


    /**
     * @description 根据预估配送费用信息转换为预估配送信息视图数据
     * @param deliveryInfo 预估配送费用信息
     * */
    public createCountryDeliveryView(deliveryInfo: IFreight): IDeliveryCost {
        // 预估配送费用--国家
        const countryView: IDeliveryCountry = {
            code: deliveryInfo.countryCode,
            displayName: deliveryInfo.countryName
        };
        // 预估配送费用--配送信息
        const shippingPriceItems: Array<FreightPriceItem> = deliveryInfo.shippingPriceItems;
        let deliveryCostView: Array<IDeliveryCostView> = [];

        shippingPriceItems.forEach((item, index, source) => {
            let deliveryCostItemView: IDeliveryCostView = {
                country: countryView.code,
                countryName: countryView.displayName,
                isShow: index == 0 ? true : false,
                deliveryMethod: item.deliveryMethodName ? item.deliveryMethodName : item.deliveryMethod,
                turnaroundTime: item.turnaroundTime
            }
            // 设置运输时间
            if (deliveryCostItemView.turnaroundTime && !deliveryCostItemView.turnaroundTime.unsupported) {
                deliveryCostItemView.shippingTimeInfo = this.$translate.instant('SHIPPING_TABLE_TBODY_TIME', { from: deliveryCostItemView.turnaroundTime.from, to: deliveryCostItemView.turnaroundTime.to })
            }

            // 设置不同产品数量对应的预估配送费用
            for (let i = 0; i < item.qtyShippingPriceTables.length; i++) {
                const priceItem = item.qtyShippingPriceTables[i];
                if (priceItem.qty === 1 || priceItem.qty === 2 || priceItem.qty === 3 || priceItem.qty === 4 || priceItem.qty === 5) {
                    deliveryCostItemView[`qtyPrice${i + 1}`] = {
                        value: (priceItem.unsupported || !priceItem.price) ? null : priceItem.price
                    };
                    // price为null，提示用户（产品数量暂不支持配送，若有需求您可联系客服处理）
                    if (deliveryCostItemView[`qtyPrice${i + 1}`].value === null) {
                        deliveryCostItemView[`qtyPrice${i + 1}`].tip = this.$translate.instant("PRODUCT_DETAIL_SHIPPING_PRRICE_NULL_TIP");
                    }
                } else {
                    deliveryCostItemView.custonQtyPrice = {
                        value: (priceItem.unsupported || !priceItem.price) ? null : priceItem.price
                    };
                    // price为null，提示用户（产品数量暂不支持配送，若有需求您可联系客服处理）
                    if (deliveryCostItemView.custonQtyPrice.value === null) {
                        deliveryCostItemView.custonQtyPrice.tip = this.$translate.instant("PRODUCT_DETAIL_SHIPPING_PRRICE_NULL_TIP");
                    }
                }
            }
            // 设置单元格纵向合并数量
            if (deliveryCostItemView.isShow) {
                deliveryCostItemView.rowspan = shippingPriceItems.length;
            }

            deliveryCostView.push(deliveryCostItemView);
        });

        // 获取配送产品信息
        const deliveryProduct: IDeliveryProduct = {
            name: deliveryInfo.productName,
            productAttributeValue: deliveryInfo.productAttributeValue
        }
        const deliveryInfoView: IDeliveryCost = {
            country: countryView,
            deliveries: deliveryCostView
        };
        return deliveryInfoView;
    }

    /**
     * @description 根据预估配送费用信息转换为预估配送信息视图数据
     * @param deliveryInfo 预估配送费用信息
     * */
    public createProductInfoView(deliveryInfo: IFreight): IProductSnapshot {
        const productAttributeValue: string = deliveryInfo.productAttributeValue;
        // sku产品信息
        const productSnapshot: IProductSnapshot = {
            name: this.$scope.productName,
            property: productAttributeValue
        }

        return productSnapshot;
    }

    /**
     * @description 选择预估配送费用国家
     * @param country 国家
     * */
    public selectCountry(country: qpmn.user.model.domain.area.ICountryContent) {

        // 正在请求预估配送--禁止再次触发
        if (this.deliveriesInfoLoading) {
            return;
        }
        //TODO 设置预估运费选中国家(待优化)
        this.currentCountry = country;
        // 获取预估配送费用信息
        this.searchDeliveryInfo(this.propertyDomain, this.shippingQty);
    }

    /**
     * @description 获取当前搜索国家对应code
     * @param country
     * */
    public getCountryCode(country: qpmn.user.model.domain.area.ICountryContent): string {
        return country.isoCode2;
    }
    /**
     * @dscription 获取当前货币对应code
     * @param currency
     * */
    public getCurrencyCode(): string {
        return this.userCurrencyCode;
    }
    /**
     * @dscription 获取当前货币对应code
     * @param customQty 
     * */
    public getShippingQtyList(customQty?: number): Array<number> {
        // 预估配送费用默认产品数量区间
        let shippingQtyList = [1, 2, 3, 4, 5];
        if (customQty) {
            shippingQtyList.push(customQty);
        }
        return shippingQtyList;
    }


    /**
     * @description 根据产品属性和查询预估配送信息的国家、地区，查询到预估配送信息并转预估费用信息（产品信息、预估运费）视图数据
     * @param propertyModel 产品属性
     * @param shippingQty 产品数量配送数量
     * */
    public searchDeliveryInfo(propertyModel: PropertyModel | undefined, shippingQty?: number) {
        // 正在请求预估配送--禁止再次触发
        if (this.deliveriesInfoLoading) {
            return;
        }
        // 根据V2属性表单数据-获取产品配送信息
        if (this.$scope.formCode) {
            //TODO 校验当前产品属性是否合法
            const eventId = ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_SEARCH_SHIPPING;
            this.propertyFormValidate(eventId);
            return;

        } else {
            // 根据V1属性表单数据-获取产品配送信息
            // 校验当前产品属性是否合法
            const propertyVerify = PropertyModelManager.checkPropertyModelLegal(propertyModel as PropertyModel);

            // 产品属性校验未通过，提示用户查看当前属性表单是否合法
            if (!propertyVerify) {
                let tipConfig: IMessageDialogOptions = {
                    title: this.$translate.instant("A103B007"),
                    content: this.$translate.instant("A103B008", {
                        supportmail: this.supportmail
                    })
                }
                this.qpMessageDialog.info(tipConfig);
                return;
            }
            // 获取地区国家code
            const countryCode = this.getCountryCode(this.currentCountry);
            // 获取货币code
            const currencyCode = this.getCurrencyCode();
            // 获取预估配送信息-产品数量
            const shippingQtyList = this.getShippingQtyList(shippingQty);

            // 获取当前产品属性作为本地缓存key
            this.propertyService.getAllAttributeValue(this)
                .then(attributeResp => {
                    // 创建当前属性快照作为pricing的key,进行预估配送运费缓存
                    const attributeSnapshot = this.productDetailManager.creatAttributeSnapshot(attributeResp.data);
                    // 属性快照转为字符串
                    const snapshotKey = angular.toJson(attributeSnapshot);
                    // 产品数量拼接字符串
                    const qtysKey = 'qty' + shippingQtyList.join('-');
                    // 预估配送信息查询历史记录表示
                    const deliveryCtyQtyKey = `${currencyCode}-${snapshotKey}-${countryCode}-${qtysKey}`;
                    // 检查预估运费缓存
                    const skuDeliveryCache = this.getSkuCountryDeliveryCache(deliveryCtyQtyKey);
                    // 未查询到对应的预估运费缓存信息,调用rest接口
                    if (skuDeliveryCache) {
                        // 设置预估产品配送信息数据
                        this.skuDeliveriesViewValue = [skuDeliveryCache];
                    } else {
                        // 预估配送信息查询-开启
                        this.deliveriesInfoLoading = true;

                        this.shippingRestService.getFreight(currencyCode, countryCode, propertyModel as PropertyModel, shippingQtyList)
                            .then(respData => {
                                // 预估运费（当前查询的countryCode）转为预估运费视图数据
                                let freightData = deserialize(respData.data, Freight);
                                const deliveryInfo = this.createCountryDeliveryView(freightData);
                                // 产品信息
                                const productInfo = this.createProductInfoView(freightData);
                                // 设置预估配送信息视图数据
                                const skuDeliveryView: ISkuDeliveryView = {
                                    product: productInfo,
                                    shippingMethods: deliveryInfo.deliveries
                                }
                                this.skuDeliveriesViewValue = [skuDeliveryView];
                                //  设置预估配送信息--地区配送信息本地缓存数据
                                this.setSkuCountryDeliveryCache(deliveryCtyQtyKey, skuDeliveryView);
                                // 更新预估配送费用查询记录信息
                                if (this.deliveryCtyQtyHistory) {
                                    if (this.deliveryCtyQtyHistory.indexOf(deliveryCtyQtyKey) == -1) {
                                        this.deliveryCtyQtyHistory.push(deliveryCtyQtyKey);
                                    }
                                } else {
                                    this.deliveryCtyQtyHistory = [deliveryCtyQtyKey];
                                }
                            }, error => {
                                this.permissionService.onRequestFailed(error)
                                    .then(resError => {
                                        const errorCode = !is.undefined(resError) && !is.undefined(resError.code) ? resError.code : "";
                                        let tipConfig: IMessageDialogOptions = {
                                            title: this.$translate.instant("PRODUCT_DETAIL_SHIPPING_ISSUE_TITLE"),
                                            content: this.$translate.instant("PRODUCT_DETAIL_SHIPPING_ISSUE_TITLE_CONTENT2", { supportmail: envConfig.supportEmail })
                                        }
                                        if (errorCode == '200001') {
                                            // 产品不存在
                                            tipConfig.code = "A103B200001";
                                            tipConfig.msg = this.$translate.instant('A103B200001', {
                                                supportmail: this.supportmail
                                            });
                                        } else if (errorCode == '2000033' || errorCode == '2000055') {
                                            //2000033： propertyModel:{propertyModelId}；2000055：单双向属性计算参数错误（非逻辑）原因：{message}
                                            tipConfig.code = "A103B2000033";
                                            tipConfig.msg = this.$translate.instant('A103B2000033', {
                                                supportmail: this.supportmail
                                            });
                                        } else if (errorCode == '4000061' || errorCode == '4000062') {
                                            // 4000061：计算产品重量异常，原因如下:{message}；4000062：// 错误的产品重量！
                                            tipConfig.code = "A103B4000061";
                                            tipConfig.msg = this.$translate.instant('A103B4000061', {
                                                supportmail: this.supportmail
                                            });
                                        } else if (errorCode == '4000063') {
                                            // 调用PS运费远程服务接口异常,信息:{message}
                                            tipConfig.code = "A103B4000063";
                                            tipConfig.msg = this.$translate.instant('A103B4000063', {
                                                supportmail: this.supportmail
                                            });
                                        } else if (errorCode == '30000027' || errorCode == '30000028') {
                                            // 30000027：产品id:{productId}没有找到生效的生产天数配置；30000028：生产天数计算配置id:{configId}没有生产配置,检查ProductionDaySetting
                                            tipConfig.code = "A103B30000027";
                                            tipConfig.msg = this.$translate.instant('A103B30000027', {
                                                supportmail: this.supportmail
                                            });
                                        } else if (errorCode == "300310") {
                                            // 平台货币配置缺失
                                            const currentCurrency = resError.errorParams?.currencyCode;
                                            this.missingCurrencyConfigTipModal(this.$translate.instant('PRODUCT_DETAIL_SHIPPING_ERROR_TITLE'), currentCurrency);
                                            return;
                                        } else if (errorCode == "3000601") {
                                            //平台:{platformCode} 范围:{usageScope} 不支持货币:{currencyCode} ! 
                                            const supportCurrencyCodes = resError.errorParams.supportCurrencyCodes ? resError.errorParams.supportCurrencyCodes.join(',') : undefined;
                                            const platformCode = resError.errorParams.platformCode ? resError.errorParams.platformCode : (envConfig.APP_NAME).toUpperCase();
                                            const currentCurrency = resError.errorParams.currencyCode;
                                            this.nonsupportCurrencyTipModal(tipConfig.title, currentCurrency, platformCode, supportCurrencyCodes);
                                            return;
                                        } else {
                                            this.qpMessageDialog.info(tipConfig);
                                            // 未知错误发送sentry
                                            this.sendError('product-deatail.productDetailController.searchDeliveryInfo', error);
                                        }
                                        this.qpMessageDialog.info(tipConfig);
                                    })
                            })
                            .finally(() => {
                                // 预估配送信息查询状态--关闭
                                this.deliveriesInfoLoading = false;
                            })
                    }
                });
        }
    }


    /**
     * @deprecated 2024-10-28
     * @description 添加预估配送信息
     * */
    public addDeliveryInfo() {
        // 正在请求预估配送--禁止再次触发
        if (this.deliveriesInfoLoading) {
            return;
        }
        this.currentCountry = this.preSearchCountry;
        // 获取预估配送费用信息
        this.searchDeliveryInfo(this.propertyDomain, this.shippingQty);
    }

    /**
     * @description 根据自定义产品配送数量，获取产品预估配送信息
     * */
    private customShippingQty() {
        if (this.deliveriesInfoLoading) {
            return;
        }
        // 产品运费自定义数量校验
        const qtyLegal = this.shippingQtyValidate(this.shippingQty);
        if (!qtyLegal) {
            document.getElementById('shippingQty')!.focus();
        } else {
            // 获取预估配送费用信息
            this.searchDeliveryInfo(this.propertyDomain, this.shippingQty);
        }
    }

    /**
     * @description 2024-10-28
     * @description 清空预估配送费用信息--初始化预估配送费用信息（当前产品属性表单、默认查询地区）
     * */
    public resetDeliveriesInfo() {
        // 正在请求预估配送--禁止再次触发
        if (this.deliveriesInfoLoading) {
            return;
        }
        // 设置预查询国家为默认国家
        this.preSearchCountry = this.$scope.pricingSetting;
        // 设置默认国家
        for (let country of this.countryList) {
            if (country.isoCode2 == "US") {
                // 设置默认选择country为美国
                this.currentCountry = country;
                break;
            }
        }
        // 清空预估配送信息--展示视图标识记录
        this.deliveryViewRecord = {};
        // 预估配送费用查询
        this.searchDeliveryInfo(this.propertyDomain);
    }

    /**
     * @description 根据当前产品属性，创建PropertyModelId
     * */
    public createPropertyModelId(propertyDomain: PropertyModel | undefined): angular.IPromise<number | undefined> {
        let defer = this.$q.defer<number | undefined>();
        //产品包含propertyModal，进行校验产品属性，并保存propertyModel获取propertyModelId
        if (propertyDomain) {
            // 产品属性校验是否合法
            let isLegal = PropertyModelManager.checkPropertyModelLegal(this.propertyDomain);
            if (!isLegal) {
                this.qpLoading.close();
                // 产品属性校验失败，错误提示信息
                defer.reject();
                throw new BusinessException("A103B002");
            }
            // 保存当前PropertyModel，获取propertyModelId
            this.saveProperty(this.propertyDomain).then(resp => {
                if (!resp.success) {
                    return;
                }
                let propertyModel = resp.data as PropertyModel;
                defer.resolve(propertyModel._id);
            }, error => {
                defer.reject(error);
            })
        } else {
            defer.resolve(undefined);
        }
        return defer.promise;
    }



    /**
     * @description 获取当前产品属性对应的SKU产品id
     * */
    public createSkuId(currentProductId, propertyModelId): angular.IPromise<string> {
        let defer = this.$q.defer<string>();
        const ProductDataPromise = angular.isUndefined(this.$scope.attributeVersion) ? this.productV2RestService.getOne(currentProductId) : this.productV2RestService.getOne(currentProductId, this.$scope.attributeVersion);

        // 确认当前产品类型，存储当前产品信息（产品类型，sku产品Id，configurable产品Id）
        ProductDataPromise.then(productResp => {
            // 当前产品为非纯SKU产品类型,包含关联的可配置产品Id；当前产品为可配置产品；生成sku产品id
            if ((productResp.data.multilingualKey == "com.qpp.cgp.domain.product.SkuProduct" && productResp.data.configurableProductId) || (productResp.data.multilingualKey == "com.qpp.cgp.domain.product.ConfigurableProduct")) {
                const configurableProductId = productResp.data.multilingualKey == "com.qpp.cgp.domain.product.SkuProduct" ? productResp.data.configurableProductId : productResp.data.id;
                // 根据当前产品属性和可配置产品Id，生成对应的SKU产品Id
                this.productV2RestService.creatSku(configurableProductId as number, Number(propertyModelId)).then(resp => {
                    let skuProductId = resp.data.id;
                    defer.resolve(String(skuProductId));
                }, error => {
                    defer.reject(error);
                })
            }
            // 当前产品为纯SKU产品类型,不包含关联的可配置产品Id，直接返回当前纯sku产品id
            if (productResp.data.multilingualKey == "com.qpp.cgp.domain.product.SkuProduct" && !productResp.data.configurableProductId) {
                let skuProductId = productResp.data.id;
                defer.resolve(String(skuProductId));
            }
        }, error => {
            defer.reject(error);
        })
        return defer.promise;
    }


    /**
     * @description 根据产品属性和查询预估配送信息的国家、地区，下载产品预估配送费用Excel
     * @param propertyModel 产品属性
     * @param currencyCode 货币Code
     * @param country  国家
     * @param shippingQtyList 产品配送数量
     * */
    public downLoadShippingExcel() {

        // 正在请求预估配送--禁止再次触发
        if (this.shippingExcelLoading || this.deliveriesInfoLoading) {
            return;
        }
        if (this.$scope.formCode) {
            // 执行属性校验
            this.propertyFormValidate(ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_DOWNLOAD_SHIPPING);
            return;
        }
        // 校验当前产品属性是否合法
        const propertyModel = this.propertyDomain;
        const propertyVerify = PropertyModelManager.checkPropertyModelLegal(propertyModel);

        // 产品属性校验未通过，提示用户查看当前属性表单是否合法
        if (!propertyVerify) {
            let tipConfig: IMessageDialogOptions = {
                title: this.$translate.instant("A103B007"),
                content: this.$translate.instant("A103B008", {
                    supportmail: this.supportmail
                })
            }
            this.qpMessageDialog.info(tipConfig);
            return;
        }
        // 获取地区国家code
        const countryCode = this.getCountryCode(this.currentCountry);
        // 获取货币code
        const currencyCode = this.getCurrencyCode();
        // 获取自定义产品数量
        const shippingQtyList = this.getShippingQtyList(this.shippingQty);
        // 预估配送信息excel下载-开启 
        this.shippingExcelLoading = true;
        this.shippingRestService.downloadExcel(currencyCode, countryCode, propertyModel, shippingQtyList)
            .then(respData => {

            }, error => {
                this.permissionService.onRequestFailed(error)
                    .then(resError => {
                        const errorCode = resError.code;
                        let tipConfig: IMessageDialogOptions = {
                            title: this.$translate.instant("PRODUCT_DETAIL_SHIPPING_EXPORT_ISSUE_TITLE"),
                            content: this.$translate.instant("PRODUCT_DETAIL_SHIPPING_EXPORT_ISSUE_CONTENT1", { supportmail: envConfig.supportEmail })
                        }
                        if (errorCode == '200001') {
                            // 产品不存在
                            tipConfig.code = "A103B200001";
                            tipConfig.msg = this.$translate.instant('A103B200001');
                        } else if (errorCode == '2000033' || errorCode == '2000055') {
                            //2000033： propertyModel:{propertyModelId}；2000055：单双向属性计算参数错误（非逻辑）原因：{message}
                            tipConfig.code = "A103B2000033";
                            tipConfig.msg = this.$translate.instant('A103B2000033');
                        } else if (errorCode == '4000061' || errorCode == '4000062') {
                            // 4000061：计算产品重量异常，原因如下:{message}；4000062：// 错误的产品重量！
                            tipConfig.code = "A103B4000061";
                            tipConfig.msg = this.$translate.instant('A103B4000061');
                        } else if (errorCode == '4000063') {
                            // 调用PS运费远程服务接口异常,信息:{message}
                            tipConfig.code = "A103B4000063";
                            tipConfig.msg = this.$translate.instant('A103B4000063');
                        } else if (errorCode == '30000027' || errorCode == '30000028') {
                            // 30000027：产品id:{productId}没有找到生效的生产天数配置；30000028：生产天数计算配置id:{configId}没有生产配置,检查ProductionDaySetting
                            tipConfig.code = "A103B30000027";
                            tipConfig.msg = this.$translate.instant('A103B30000027');
                        } else if (errorCode == "300310") {
                            // 平台货币配置缺失
                            const currentCurrency = resError.errorParams?.currencyCode;
                            this.missingCurrencyConfigTipModal(this.$translate.instant('PRODUCT_DETAIL_SHIPPING_EXPORT_ERROE_TITLE'), currentCurrency);
                            return;
                        } else if (errorCode == "3000601") {
                            //平台:{platformCode} 范围:{usageScope} 不支持货币:{currencyCode} ! 
                            const supportCurrencyCodes = resError.errorParams.supportCurrencyCodes ? resError.errorParams.supportCurrencyCodes.join(',') : undefined;
                            const platformCode = resError.errorParams.platformCode ? resError.errorParams.platformCode : (envConfig.APP_NAME).toUpperCase();
                            const currentCurrency = resError.errorParams.currencyCode;
                            this.nonsupportCurrencyTipModal(tipConfig.title, currentCurrency, platformCode, supportCurrencyCodes);
                            return;
                        } else {
                            // 未知错误发送sentry
                            this.sendError('product-deatail.productDetailController.downLoadShippingExcel', error);
                        }
                        this.qpMessageDialog.info(tipConfig);
                    })
            })
            .finally(() => {
                // 预估配送信息excel下载--关闭
                this.shippingExcelLoading = false;
            })
    }

    /**
    * @description 获取产品计价配置
    */
    public async getRestConfig(): Promise<IRestConfig> {
        const restConfig: IRestConfig = {
            type: RestTypeEnum.PRODUCT,
            productId: Number(this.$scope.currentProductId)
        }
        if (this.$scope.attributeVersion) {
            restConfig.propertyVersioned = this.$scope.attributeVersion;
        }
        if (this.$scope.currencyCode) {
            restConfig.currencyCode = this.getCurrencyCode();
        }
        const attributeResp = await this.propertyService.getAllAttributeValue(this);
        if (attributeResp.data && attributeResp.data.length > 0) {
            restConfig.attrKeys = attributeResp.data;
        }
        return restConfig;
    }

    /**
     * @description 构造传递到离散价格表中所需的参数
     */
    private async createDiscreteParameter(): Promise<IDiscretePriceParams> {
        // 构造传递到离散价格表中所需的参数
        const discretePriceParams: IDiscretePriceParams = {
            qtyList: this.qtyList && this.qtyList.length > 0 ? this.qtyList : undefined,
            fixedPrice: this.fixedPrice,
            needChangedWhenQty: this.needChangedWhenQty,
            needChangedWhenAttrs: this.needChangedWhenAttrs
        };
        // EventBus事件名
        Object.keys(this.discretePriceEventName).forEach((key) => {
            discretePriceParams[key] = this.discretePriceEventName[key];
        });
        discretePriceParams['restConfig'] = await this.getRestConfig();
        return discretePriceParams;
    }

    /**
     * @description 查看离散数量价格表
     */
    private async showDiscretePrice() {
        const isProductAttributesValid = PropertyModelManager.checkPropertyModelLegal(this.propertyDomain);
        const propertyModelId = await this.getPropertyModelIdForInquiryPrice();

        let discretePriceModalInstance = this.$uibModal.open({
            animation: false,
            backdrop: false,
            keyboard: false,
            windowClass: "discrete-price-list-modal",
            component: "discretePriceListModal",
            size: "price-list-container",
            resolve: {
                items: async () => {
                    const params = await this.createDiscreteParameter();
                    params.inquiryPrice = {
                        productName: this.$scope.productName || "",
                        isRandomMode: this.designModel !== undefined && this.designModel.toUpperCase() === "RANDOM",
                        isProductAttributesValid: isProductAttributesValid,
                        displayMode: InquiryPriceDisplayMode.Fold,
                        isOpenInquiryPrice: true,
                        propertyModelId: propertyModelId,
                    };
                    return params;
                }
            }
        });

        discretePriceModalInstance.result.then(() => {
        });
    }

    /**
     * @description 查看阶梯数量价格表
     */
    private async showTieredPrice() {
        const productDetailControllerThis = this;
        const isProductAttributesValid = PropertyModelManager.checkPropertyModelLegal(this.propertyDomain);
        const propertyModelId = await this.getPropertyModelIdForInquiryPrice();

        this.addToPricingQueue();
        let openMultipleModals = this.$uibModal.open({
            animation: false,
            backdrop: false,
            keyboard: true,
            bindToController: true,
            scope: this.$scope,
            controller: ['$scope', function ($scope) {
                let $ctrl = this;
                $ctrl.bulkOrderPageUrl = productDetailControllerThis.pageContext.rootPath + "bulk-order-discount/";
                $ctrl.close = () => {
                    openMultipleModals.close();
                }
                $ctrl.productName = productDetailControllerThis.$scope.productName || "";
                $ctrl.isProductAttributesValid = isProductAttributesValid;
                $ctrl.isRandomMode = productDetailControllerThis.designModel !== undefined && productDetailControllerThis.designModel.toUpperCase() === "RANDOM";
                $ctrl.displayMode = InquiryPriceDisplayMode.Fold;
                $ctrl.isOpenInquiryPrice = true;
                $ctrl.propertyModelId = propertyModelId;
            }],
            controllerAs: '$ctrl',
            windowClass: "modal-container",
            templateUrl: "price-list-modal.template",
            size: "price-list"
        })
    }

    /**
     * @description 查看批量产品价格
     * */
    public viewBulkPrice() {
        if (this.$scope.priceType == WhiteLabelPriceTypeEnum.DISCRETE) {
            this.showDiscretePrice();
        } else if (this.$scope.priceType == WhiteLabelPriceTypeEnum.INTERVAL || !this.$scope.priceType || this.fixedPrice) {
            // 无价格类型、阶梯计价、固定计价时默认使用阶梯价格表
            this.showTieredPrice();
        }
    }

    /**
     * @description 验证当前价格表是否为传入的价格表类型
     */
    public verifyPriceType(priceType: WhiteLabelPriceTypeEnum) {
        if (priceType == WhiteLabelPriceTypeEnum.DISCRETE) {
            return this.$scope.priceType == priceType;
        } else if (priceType == WhiteLabelPriceTypeEnum.INTERVAL) {
            return this.$scope.priceType == priceType || this.fixedPrice || !this.$scope.priceType;
        }
    }


    /**
     * @description 获取推荐产品详情页pageName，跳转推荐产品页面
     * @param productId
     * */
    public goRelatedProduct(productId: number) {
        this.cmsConfigRestService.getPageName(productId, this.$scope.publishAppName, this.$scope.publishAppTag)
            .then(resp => {
                // 获取关联产品详情页面地址
                let pageName = resp.data as string;
                pageName = pageName.replace('.html', '');
                this.$window.location.href = `${this.rootPath}products/${pageName}?`
                if (!angular.isUndefined(this.urlParameter)) {
                    this.$window.location.href = `${this.rootPath}products/${pageName}/${this.urlParameter}`;
                } else {
                    this.$window.location.href = `${this.rootPath}products/${pageName}`;
                }
            }, error => {
                //  未找到指定产品详情页处理，提示用户产品页面缺失
                if (error.data.data.code === 300740) {
                    const tipText = this.$translate.instant('A103B0010') + `(productId:${error.data.data.errorParams.productId})`
                    window.qpAlertPrompt.info(this.$translate.instant('A103B009'), tipText);
                    return;
                } else {
                    this.permissionService.onRequestFail(error);
                }
            })
    }

    public changeQty(qty) {
        if (qty < 1) {
            return;
        }
        this.productQuantity = parseFloat(qty);
        if (this.isNeedUpdatePrice(ChangeType.Qty)) {
            this.addToPricingQueue();
        }
    }


    /*************************************** ADD TO STORE -Chore *************************************/

    /**
     * @description 店铺合法性校验，根据店铺id查询，查询店铺是否属于当前用户
     * @params storeId
     * @return 
     * */
    private verifyStore(storeId?: string): angular.IPromise<boolean> {
        let defer = this.$q.defer<boolean>();
        if (is.undefined(storeId)) {
            this.$timeout(() => {
                defer.resolve(true);
            })
        } else {
            this.storesRestService.verifyStore(storeId)
                .then(res => {
                    defer.resolve(res.data);
                }, error => {
                    defer.resolve(error);
                })
        }
        return defer.promise;
    }
    /**
     * @description 清空店铺产品先关信息（店铺id，店铺类型，店铺URL，店铺名称）
     * **/
    private clearStoreInfo() {
        // 清空店铺id
        this.sourceStoreId = undefined;
        // 清空店铺类型
        this.storeType = undefined;
        // 清空店铺URL
        this.sourceStoreUrl = undefined;
        // 清空店铺名称
        this.sourceStoreName = undefined;
    }

    /**
     * @description 添加店铺产品
     * **/
    private addToStore() {
        // 店铺合法性校验
        this.verifyStore(this.sourceStoreId)
            .then(res => {
                if (!is.undefined(res)) {
                    if (res) {
                        //url地址传入店铺属于当前用户-开启添加店铺产品模态框
                        this.openAddProductModal();
                    } else {
                        //url地址传入店铺不属于当前用户 --提示用户用户重新选择店铺                       
                        let tipConfig: IMessageDialogOptions = {
                            title: this.$translate.instant("PRODUCT_DETAIL_VERIFY_STORE_TITLE"),
                            content: this.$translate.instant("PRODUCT_DETAIL_VERIFY_STORE_CONTENT"),
                            buttons: ['ok', 'cancel']
                        }
                        this.qpMessageDialog.info(tipConfig)
                            .then(btnKey => {
                                // 取消
                                if (btnKey === 'cancel') {
                                    return;
                                }
                                // 确认
                                if (btnKey === 'ok') {
                                    // 清空店铺相关信息
                                    this.clearStoreInfo();
                                    // 开启添加店铺产品模态框
                                    this.openAddProductModal();
                                }
                            })
                    }
                } else {
                    return;
                }
            }, error => {
                // 店铺合法性校验失败提示
                this.permissionService.onRequestFailed(error)
                    .then(e => {
                        // 添加店铺产品失败
                        let tipConfig: IMessageDialogOptions = {
                            title: this.$translate.instant("PRODUCT_DETAIL_ADD_TO_STORE_FAILED_TITLE"),
                            content: this.$translate.instant("PRODUCT_DETAIL_ADD_TO_STORE_FAILED_CONTENT", { "supportmail": envConfig.supportEmail }),
                            buttons: ['ok'],
                            code: "301518599",
                            msg: this.$translate.instant('PRODUCT_DETAIL_ADD_TO_STORE_FAILED_CONTENT_BY_STORE')
                        }
                        this.qpMessageDialog.info(tipConfig);
                        // 主动抛sentry
                        this.sendError('product-deatail.productDetailController.addToStore.verifyStore', error);
                    });
            })
    }

    /**
     * @description 添加店铺产品模态框
     * */
    public openAddProductModal() {
        // 由于在触发属性更改时,只会计算单个映射链中的属性校验,因此需要再提交表单的时候重新检查一次啊属性的合法性,为了用户体验,在打开店铺选择模态框时先执行一次报错PropertyModel的操作
        // TODO V2-propertyForm获取propertyModel数据-派发事件
        if (this.$scope.formCode) {
            const eventId = ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_ADD_STORE_PRODUCT;
            this.propertyFormValidate(eventId);
            return;
        }

        //属性表单校验
        this.saveProperty(this.propertyDomain)
            .then(resp => {
                if (!resp.success) {
                    return;
                }

                // 预添加店铺产品的店铺已确定，店铺产品类型()已确定(随机卡（随机设计）)
                if (this.storeType && this.sourceStoreId && this.designModel === 'RANDOM') {
                    // 打开店铺产品设置页
                    const storeInfo: StoreInfo = { platform: this.storeType, id: this.sourceStoreId };
                    const storeProductType = "SKU_WITH_DESIGN";
                    // 创建店铺产品设置页模态框参数
                    let modelParams: IStoreProductSettingModalParams = {
                        storeProductType: storeProductType,
                        storeIds: [storeInfo.id],
                        storeName: this.sourceStoreName as string,
                        storeUrl: this.sourceStoreUrl ? this.sourceStoreUrl : undefined,
                        editType: "add",
                        rootPath: this.rootPath,
                        isFinished: this.$scope.isFinished,
                        cmsConfigVersion: this.$scope.cmsConfigVersion,
                        storeType: this.storeType,
                        productDesignModel: this.designModel,
                        designMethodVersion: this.$scope.designMethodVersion
                    }
                    if (this.$scope.attributeVersion) {
                        modelParams.attributeVersion = this.$scope.attributeVersion;
                    }
                    // 设置产品计价类型
                    if (!is.undefined(this.$scope) && !is.undefined(this.$scope.priceType)) {
                        modelParams.whiteLabelPriceType = this.$scope.priceType;
                    }
                    // 设置产品是否为固定价格
                    if (!is.undefined(this.$scope) && !is.undefined(this.$scope.isFixedPrice)) {
                        modelParams.whiteLabelfixedPrice = this.$scope.isFixedPrice;
                    }
                    // 设置产品价格是否受属性影响
                    if (!is.undefined(this.$scope) && !is.undefined(this.$scope.priceAffectedByAttribute)) {
                        modelParams.whiteLabelPriceAffectedByAttribute = this.$scope.priceAffectedByAttribute;
                    }
                    // 设置产品价格是否受数量影响
                    if (!is.undefined(this.$scope) && !is.undefined(this.$scope.priceAffectedByQuantity)) {
                        modelParams.whiteLabelPriceAffectedByQuantity = this.$scope.priceAffectedByQuantity;
                    }
                    // 设置产品离散计价默认qty数组
                    if (!is.undefined(this.$scope) && !is.undefined(this.$scope.discretePriceRange)) {
                        modelParams.whiteLabelDiscretePriceRange = this.$scope.discretePriceRange;
                    }
                    // 根据店铺产品类型，设置对应的whiteLabelProductId和propertyModelId
                    this.openAddProductModalAfter(modelParams, storeProductType, storeInfo);
                } else {
                    // addStoreProductModal模态框参数
                    let addStoreProductModalParams = {
                        rootPath: this.pageContext.rootPath,
                        // TODO 选择店铺界面开发尚未完成,先采用固定店铺id
                        // storeId: this.sourceStoreId ?? [{ id: "44506843", type: "WooCommerce" }],
                        storeId: this.sourceStoreId,
                        store: {
                            id: this.sourceStoreId,
                            platform: this.storeType,
                            storeName: this.sourceStoreName,
                            storeUrl: this.sourceStoreUrl ? this.sourceStoreUrl : undefined
                        },
                        isFinished: this.$scope.isFinished,

                        whitelabelProductId: this.currentProductId,
                        versionedAttributeId: this.$scope.attributeVersion
                    }
                    //店铺产品产品类型已确定（SKU_WITH_DESIGN）
                    if (this.designModel === 'RANDOM') {
                        addStoreProductModalParams['productType'] = "SKU_WITH_DESIGN";
                    }

                    // 打开选择
                    const storeProductModalInstance = this.$uibModal.open({
                        component: "addStoreProductModal",
                        windowClass: "add-store-modal",
                        backdrop: 'static',
                        keyboard: false,
                        size: "lg",
                        resolve: {
                            items: () => {
                                return addStoreProductModalParams;
                            }
                        }
                    });

                    // 店铺产品类型
                    // export type IStoreProductType = "SKU_WITH_DESIGN" | "SKU_WITHOUT_DESIGN" | "FULL_PRODUCT_WITHOUT_DESIGN";
                    storeProductModalInstance.result.then(modalParams => {
                        if (!modalParams) {
                            return;
                        }
                        // 打开店铺产品设置页
                        const storeInfo = modalParams.stores[0];
                        const storeProductType = modalParams.storeProductType as StoreProductType;
                        const isBind = modalParams.isBind;
                        // 创建店铺产品设置页模态框参数
                        let modelParams: IStoreProductSettingModalParams = {
                            storeProductType: storeProductType,
                            storeIds: [storeInfo.id],
                            storeName: storeInfo.storeName,
                            storeUrl: storeInfo.storeUrl ? storeInfo.storeUrl : undefined,
                            editType: "add",
                            rootPath: this.rootPath,
                            isFinished: this.$scope.isFinished,
                            cmsConfigVersion: this.$scope.cmsConfigVersion,
                            storeType: storeInfo.platform,
                            isBind: isBind,
                            designMethodVersion: this.$scope.designMethodVersion
                        }
                        // 设置属性版本
                        if (this.$scope.attributeVersion) {
                            modelParams.attributeVersion = this.$scope.attributeVersion;
                        }
                        // 设置产品设置模式
                        if (this.designModel) {
                            modelParams.productDesignModel = this.designModel;
                        }
                        // 设置产品计价类型
                        if (!is.undefined(this.$scope) && !is.undefined(this.$scope.priceType)) {
                            modelParams.whiteLabelPriceType = this.$scope.priceType;
                        }
                        // 设置产品是否为固定价格
                        if (!is.undefined(this.$scope) && !is.undefined(this.$scope.isFixedPrice)) {
                            modelParams.whiteLabelfixedPrice = this.$scope.isFixedPrice;
                        }
                        // 设置产品价格是否受属性影响
                        if (!is.undefined(this.$scope) && !is.undefined(this.$scope.priceAffectedByAttribute)) {
                            modelParams.whiteLabelPriceAffectedByAttribute = this.$scope.priceAffectedByAttribute;
                        }
                        // 设置产品价格是否受数量影响
                        if (!is.undefined(this.$scope) && !is.undefined(this.$scope.priceAffectedByQuantity)) {
                            modelParams.whiteLabelPriceAffectedByQuantity = this.$scope.priceAffectedByQuantity;
                        }
                        // 设置产品离散计价默认qty数组
                        if (!is.undefined(this.$scope) && !is.undefined(this.$scope.discretePriceRange)) {
                            modelParams.whiteLabelDiscretePriceRange = this.$scope.discretePriceRange;
                        }
                        // 根据店铺产品类型，设置对应的whiteLabelProductId和propertyModelId
                        this.openAddProductModalAfter(modelParams, storeProductType, storeInfo);
                    }, () => { })
                }
            })

    }
    /**
    * @description 关闭添加店铺产品模态框后，根据店铺产品类型，创建店铺产品设置页参数
    * @param modelParams
    * @param storeProductType
    * @param storeInfo
    * */
    public openAddProductModalAfter(modelParams: IStoreProductSettingModalParams, storeProductType: StoreProductType, storeInfo: StoreInfo) {
        // 根据店铺产品类型，设置对应的whiteLabelProductId和propertyModelId
        if (storeProductType === 'SKU_WITH_DESIGN' || storeProductType === "SKU_WITHOUT_DESIGN") {
            if (is.undefined(this.propertyDomain)) {
                // TODO 产品属性信息缺失提示


                return;
            } else {
                this.qpLoading.open();
                this.getPropertyModelId(this.propertyDomain)
                    .then(resPertyModelId => {
                        const propertyModelId = Number(resPertyModelId);
                        modelParams.propertyModelId = String(propertyModelId);
                        // 获取sku产品Id
                        this.getSkuProductId(this.configurableProductId, propertyModelId)
                            .then(resSkuProductId => {
                                modelParams.skuWhitelabelProductId = String(resSkuProductId);
                                this.openStoreProductSetting(modelParams, storeInfo);
                            }, error => {
                                this.permissionService.onRequestFail(error);
                            })
                            .finally(() => {
                                this.qpLoading.close();
                            })
                    }, error => {
                        this.qpLoading.close();
                        // 产品属性校验失败，错误提示信息
                        // this.permissionService.onRequestFail(error);
                        throw new BusinessException("A103B002");
                    });
            }
        } else if (storeProductType === 'FULL_PRODUCT_WITHOUT_DESIGN') {
            modelParams.configurableWhitelabelProductId = String(this.configurableProductId);
            this.openStoreProductSetting(modelParams, storeInfo);

        } else {
            const msg = this.$translate.instant("A103B0016", { storeProductType: storeProductType });
            window.qpAlertPrompt.info("", msg);
        }
    }

    /**
    * @description 关闭添加店铺产品模态框后，根据店铺产品类型，创建店铺产品设置页参数
    * @param modelParams
    * @param storeProductType
    * @param storeInfo
    * @param propertyModelId
    * */
    public openAddProductModalAfterByV2Property(modelParams: IStoreProductSettingModalParams, storeProductType: StoreProductType, storeInfo: StoreInfo, propertyModelId: string) {
        // 根据店铺产品类型，设置对应的whiteLabelProductId和propertyModelId
        if (storeProductType === 'SKU_WITH_DESIGN' || storeProductType === "SKU_WITHOUT_DESIGN") {
            modelParams.propertyModelId = propertyModelId;
            // 获取sku产品Id
            this.getSkuProductId(this.configurableProductId, Number(propertyModelId))
                .then(resSkuProductId => {
                    modelParams.skuWhitelabelProductId = String(resSkuProductId);
                    this.openStoreProductSetting(modelParams, storeInfo);
                }, error => {
                    this.permissionService.onRequestFail(error);
                })
                .finally(() => {
                    this.qpLoading.close();
                })
        } else if (storeProductType === 'FULL_PRODUCT_WITHOUT_DESIGN') {
            modelParams.configurableWhitelabelProductId = String(this.configurableProductId);
            this.openStoreProductSetting(modelParams, storeInfo);

        } else {
            const msg = this.$translate.instant("A103B0016", { storeProductType: storeProductType });
            window.qpAlertPrompt.info("", msg);
        }
    }

    /**
     * @description 打开店铺产品设置页
     * @param modalParams
     * */

    public openStoreProductSetting(modalParams: IStoreProductSettingModalParams, storeInfo: StoreInfo) {
        // 打开店铺产品设置页
        const productSettingModalInstance = this.$uibModal.open({
            component: "storeProductSettingModal",
            windowClass: "add-product",
            backdropClass: "add-product-backdrop",
            resolve: {
                items: () => {
                    return modalParams;
                }
            }
        });

        productSettingModalInstance.result.then(resultParams => {
            if (angular.isUndefined(resultParams)) {
                return;
            }
            // 获取店铺产品id
            const storeProductId = resultParams.storeProductId;

            // 提示用户店铺产品保存成功，主动跳转个人中心-店铺产品列表
            if (storeInfo.platform === 'Manual' || storeInfo.platform === 'ManualStore') {
                // 设置提示信息
                this.qpMessageFadeindown.show(this.$translate.instant('CREATE_STORE_PRODUCT_SUCCEED'));
                this.$window.location.href = this.rootPath + "dashboard/index.html#!/store/" + storeInfo.id + "/products";
            } else {
                // 设置提示信息
                let tipTitle: string, tipContent: string, cancelButtonText: string, confirmButtonText: string, createRunningTip: string;
                if (storeInfo.platform === "PopUp") {
                    tipTitle = this.$translate.instant('CREATE_STORE_PRODUCT_PUBLISH_TIP_TITLE');
                    tipContent = this.$translate.instant('CREATE_STORE_PRODUCT_PUBLISH_TIP_CONTENT', { publishBtn: this.$translate.instant('CREATE_STORE_PRODUCT_PUBLISH_TIP_PUBLISH_BTN'), laterBtn: this.$translate.instant("CREATE_STORE_PRODUCT_PUBLISH_TIP_LATER_BTN") });
                    cancelButtonText = this.$translate.instant('CREATE_STORE_PRODUCT_PUBLISH_TIP_LATER_BTN');
                    confirmButtonText = this.$translate.instant('CREATE_STORE_PRODUCT_PUBLISH_TIP_PUBLISH_BTN');
                    createRunningTip = this.$translate.instant('CREATE_STORE_PRODUCT_PUBLISHING_TIP');
                } else {
                    tipTitle = this.$translate.instant('CREATE_STORE_PRODUCT_SYNC_TIP_TITLE');
                    tipContent = this.$translate.instant('CREATE_STORE_PRODUCT_SYNC_TIP_CONTENT', { syncBtn: this.$translate.instant('CREATE_STORE_PRODUCT_SYNC_TIP_SYNC_BTN'), laterBtn: this.$translate.instant("CREATE_STORE_PRODUCT_SYNC_TIP_LATER_BTN") });
                    cancelButtonText = this.$translate.instant('CREATE_STORE_PRODUCT_SYNC_TIP_LATER_BTN');
                    confirmButtonText = this.$translate.instant('CREATE_STORE_PRODUCT_SYNC_TIP_SYNC_BTN');
                    createRunningTip = this.$translate.instant('CREATE_STORE_PRODUCT_SYNCING_TIP');
                }
                // 提示用户店铺产品保存成功，提示用户是否需要发布店铺产品，主动跳转个人中心-店铺产品列表
                // 店铺产品发布|同步提示（Publish | Sync）
                window.qpAlertPrompt[PromptTypeEnum.QUESTION](tipTitle, tipContent, {
                    fn: () => {
                        this.storeProductV2RestService.syncDataByAsync(storeInfo.id, storeProductId).then(resp => {
                            // 店铺产品同步中（异步）
                            this.qpMessageFadeindown.show(createRunningTip);
                            // 跳转至店铺产品页面
                            if (this.$window.top && this.$window.top.location.href.indexOf("dashboard") != -1) {
                                let path = this.$window.top.location.href.split("/dashboard/");

                                this.$window.top.location.href = this.$sce.trustAsResourceUrl(UrlUtil.joinUrl([path[0], "dashboard/index.html#!/store/" + storeInfo.id + "/products"]));
                            } else {
                                this.$window.location.href = this.rootPath + "dashboard/index.html#!/store/" + storeInfo.id + "/products";
                            }
                        }, (error) => {
                            this.permissionService.onRequestFailed(error)
                                .then(e => {
                                    let tipTitle: string, tipContent: string;
                                    if (storeInfo.platform === "PopUp") {
                                        tipTitle = this.$translate.instant('STORE_PRODUCT_PUBLISH_FAILED_TITLE');
                                        tipContent = this.$translate.instant('STORE_PRODUCT_PUBLISH_FAILED_CONTENT', { supportmail: envConfig.supportEmail });
                                    } else {
                                        tipTitle = this.$translate.instant('STORE_PRODUCT_SYNC_FAILED_TITLE');
                                        tipContent = this.$translate.instant('STORE_PRODUCT_SYNC_FAILED_CONTENT', { supportmail: envConfig.supportEmail });
                                    }

                                    // 店铺产品同步失败提示
                                    let tipConfig: IMessageDialogOptions = {
                                        title: tipTitle,
                                        content: tipContent
                                    }
                                    // 获取errorCode
                                    const errorCode = (!is.undefined(e) && !is.undefined(e.code)) ? e.code : undefined;
                                    if (!is.undefined(errorCode) && errorCode == "3000935") {
                                        tipConfig.code = "3000935";
                                        tipConfig.msg = this.$translate.instant('3000935');
                                    } else {
                                        this.sendError("product-deatail.productDetailController.openStoreProductSetting.storeProductV2RestService.syncDataByAsync", error)
                                    }
                                    this.qpMessageDialog.info(tipConfig);
                                })
                        });
                    }
                }, {
                    fn: () => {
                        // 跳转至店铺产品页面
                        if (this.$window.top && this.$window.top.location.href.indexOf("dashboard") != -1) {
                            let path = this.$window.top.location.href.split("/dashboard/");

                            this.$window.top.location.href = this.$sce.trustAsResourceUrl(UrlUtil.joinUrl([path[0], "dashboard/index.html#!/store/" + storeInfo.id + "/products"]));
                        } else {
                            this.$window.location.href = this.rootPath + "dashboard/index.html#!/store/" + storeInfo.id + "/products";
                        }
                    }
                }, { ...this.RELAUNCH_DEFAULT_CONFIG, cancelButtonText: cancelButtonText, confirmButtonText: confirmButtonText });
            }
        })
    }
    /**
     * @description 根据propertyDomain，校验产品属性是否合法，属性合法创建propertyModel，获取propertyModelId
     * @params propertyDomain
    */
    public getPropertyModelId(propertyDomain: PropertyModel): angular.IPromise<string> {
        let defer = this.$q.defer<string>();
        // 产品属性校验是否合法
        let isLegal = PropertyModelManager.checkPropertyModelLegal(propertyDomain);
        if (!isLegal) {
            // 走Promise链的catch，触发异常处理
            defer.reject();
        } else {
            // 保存当前PropertyModel，获取propertyModelId
            this.saveProperty(this.propertyDomain).then(resp => {
                if (!resp.success) {
                    return;
                }
                const propertyModel = resp.data as PropertyModel;
                defer.resolve(String(propertyModel._id));
            }, error => {
                this.permissionService.onRequestFail(error);
                defer.reject();
            });
        }
        return defer.promise;
    }

    /**
     * @description 根据propertymodelId和configurableProductId创建skuProductId
     * */
    public getSkuProductId(configurableProductId: number, propertymodelId: number): angular.IPromise<number> {
        let defer = this.$q.defer<number>();
        this.productV2RestService.creatSku(configurableProductId, propertymodelId).then(resp => {
            const skuProductId = resp.data.id;
            defer.resolve(skuProductId);
        }, error => {
            defer.reject(error);
        });
        return defer.promise;
    }


    /*****************************  Chore  *****************************/


    /********  属性定义  ******* */
    // 产品购买数量
    public productQuantity: number;
    // 最小购买数量
    public moq: number = 1;
    // 记录产品展示页正在执行的所有操作状态
    public operationStats: IOperationStatus = {};


    /************************ */
    /**
     * @description 更新产品最小下单数量
     * @param attrKeyArray
     */
    public updateMinOrderQty(propertyKeyValue: Array<IPropertyKey>): angular.IPromise<number> {
        let defer = this.$q.defer<number>();
        // 更新产品购买数量-开启
        this.operationStats.updateQty = true;
        if (this.$scope.hasMoq) {
            const propertyInfo = {
                versionedAttributeId: this.$scope.attributeVersion,
                attributeValues: propertyKeyValue
            }
            // 调用查询接口,获取MOQ值
            this.productV2RestService.getMoq(this.configurableProductId, propertyInfo)
                .then(moqResp => {
                    defer.resolve(moqResp.data);
                    // this.moq = moqResp.data;
                    // TODO 加购数量少于MOQ时,更新加购数量
                    // if (this.productQuantity < this.moq) {
                    //     this.productQuantity = this.moq;
                    // }
                })
                .catch(error => {
                    defer.reject(error);
                })
                .finally(() => {
                    // 更新产品购买数量-关闭
                    this.operationStats.updateQty = false;
                })
        } else {
            defer.resolve(this.$scope.moq);
            // 更新产品购买数量-关闭
            this.operationStats.updateQty = false;
        }
        return defer.promise;
    }

    /**
     * @description 根据当前属性表单数据,创建属性键值对（attributeId）
     * @param propertyModel
     * */
    public creatPropertyKeyValue(propertyModel: PropertyModel): Array<IPropertyKey> {
        // 获取当前属性键值对
        const attributeValues = PropertyModelManager.convertAllAttributeValue(propertyModel);
        // 组成属性键值对返回
        let keyValues: Array<IPropertyKey> = []
        attributeValues.forEach(item => {

            if (item.isSku && item.skuAttributeId) {
                let itemValue: number | string | Array<number> | null = null;
                if (item.value) {
                    itemValue = item.value;
                } else if (item.optionIds) {
                    const optionIds = item.optionIds.split(',');
                    let optionIdlist: Array<number> = [];
                    optionIds.forEach(optionId => {
                        optionIdlist.push(Number(optionId));
                    })
                    itemValue = optionIdlist;
                }

                const keyValue: IPropertyKey = {
                    attributeId: item.attributeId,
                    value: itemValue
                }
                // 检查键值对数组中是否已存在当前属性
                const matchedItem = keyValues.find(valueItem => {
                    return item.attributeId == valueItem.attributeId
                })
                if (!matchedItem) {
                    keyValues.push(keyValue);
                }
            }
        })
        return keyValues;
    }
    /**
     * @description 根据当前属性表单数据,创建属性键值对（skuAttributeCode）
     * @param propertyModel
     * */
    public creatPropertyKeyValueBySkuAtrCode(propertyModel: PropertyModel): Array<ISkuPropertyCodeKey> {
        // 获取当前属性键值对
        const attributeValues = PropertyModelManager.convertAllAttributeValue(propertyModel);
        // 组成属性键值对返回
        let keyValues: Array<ISkuPropertyCodeKey> = []
        attributeValues.forEach(item => {
            if (item.isSku && item.skuAttributeCode) {
                let itemValue: number | string | Array<number | string> | null = null;
                if (item.value) {
                    itemValue = item.value;
                } else if (item.optionValues) {
                    const optionValues = item.optionValues.split(',');
                    let optionValuelist: Array<string | number> = [];
                    optionValues.forEach(optionValue => {
                        optionValuelist.push(optionValue);
                    })
                    itemValue = optionValuelist;
                }

                const keyValue: ISkuPropertyCodeKey = {
                    skuAttributeCode: item.skuAttributeCode,
                    value: itemValue
                }
                // 检查键值对数组中是否已存在当前属性
                const matchedItem = keyValues.find(valueItem => {
                    return item.skuAttributeCode == valueItem.skuAttributeCode;
                })
                if (isUndefined(matchedItem) && keyValue.value !== null) {
                    keyValues.push(keyValue);
                }
            }
        })
        return keyValues;
    }
    /********* Chore待定 **********/
    /**
     * @description 创建产品价格视图数据
     * @param priceList
     * @return priceListViewValue
     * */

    private createPriceListViewValue(priceList: IPriceList): IBulkPriceViewValue {
        let priceListViewValue: IBulkPriceViewValue = priceList;
        Object.keys(priceListViewValue).forEach((key, index) => {
            let keyPriceList = priceList[key];
            keyPriceList.forEach((item, index) => {
                // 产品计价表单-第一项
                if (index === 0) {
                    // form==to
                    if (item.from == item.to) {
                        item.qtyInterval = item.from;
                    } else {
                        item.qtyInterval = `${item.from}-${item.to}`;
                    }
                }
                // 产品计价表单-中间项
                if (index !== 0 && index !== keyPriceList.length - 1) {
                    item.qtyInterval = `${item.from}-${item.to}`;
                }
                // 产品计价表单-最后一项
                if (index === keyPriceList.length - 1) {
                    item.qtyInterval = `${item.from}+`;
                }
            });
        })

        return priceListViewValue;
    }

    /**
     * @description 产品运费计价--产品配送数量校验
     * @description 1、5<qty<999999;2、正整数
     * */
    private shippingQtyErrorMessage: string | undefined;
    public shippingQtyValidate(qty: number | undefined): boolean {
        let checkResult: boolean;
        if (angular.isUndefined(qty) || qty === null) {
            checkResult = true;
            this.shippingQtyErrorMessage = undefined;
        } else {
            //产品配送数量向下取整
            const tempQty = Math.floor(qty as number);
            if (qty as number <= 5) {
                // 设置表单项-qty提示信息
                checkResult = false;
                document.getElementById('shippingQty')!.focus();
                this.shippingQtyErrorMessage = this.$translate.instant("PRODUCT_DETAIL_SHIPPING_CUSTOM_QTY_MIN_TIP", { minQty: 6 });
            } else if (qty as number > this.QTYMAXLIMIT) {
                // 设置表单项-qty提示信息
                checkResult = false;
                document.getElementById('shippingQty')!.focus();
                this.shippingQtyErrorMessage = this.$translate.instant("PRODUCT_DETAIL_SHIPPING_CUSTOM_QTY_MAX_TIP", { maxQty: this.QTYMAXLIMIT });
            } else {
                this.shippingQty = tempQty;
                checkResult = true;
                this.shippingQtyErrorMessage = undefined;
            }
        }
        return checkResult;
    }

    /**
     * @description 用户货币变动，根据用户货币类型显示价格（1、产品最低价格；2、产品数量计价列表；3、产品运费）
     * */
    private updatePriceByCurrency(params: IEventBusParameter<ICurrencyObj>) {
        const currency: ICurrencyObj = params.args;
        // 货币类型发生变动时
        if (currency.code !== this.userCurrencyCode) {
            this.$timeout(() => {
                // 更新user货币code
                this.userCurrencyCode = currency.code;
                // 派发货币偏好变更事件
                const params: ICurrencyChangeEventParams = {
                    currencyCode: this.userCurrencyCode
                };
                this.eventBus.dispatch(DiscretePriceEventName.CurrencyChange, params);
                // 1、产品最低价格；
                this.addToPricingQueue();
                // 3、产品运费
                // 触发预估配送费用更新
                if (this.tabShippingShow || this.infoStatusInMobile.shippingIsOpen) {
                    // 获取预估配送费用信息
                    this.updateDeliveryPrice(this.propertyDomain, this.shippingQty);
                }
            })
        }

    }

    /**
     * @description 根据产品属性和查询预估配送信息的国家、地区，更新预估配送信息并转预估费用信息（产品信息、预估运费）视图数据价格
     * @param propertyModel 产品属性
     * @param shippingQty 产品数量配送数量
     * */
    public updateDeliveryPrice(propertyModel: PropertyModel, shippingQty?: number) {
        // 预估配送费正在加载--禁止再次触发
        if (this.deliveriesPriceLoading) {
            return;
        }
        if (this.$scope.formCode) {
            //TODO 校验当前产品属性是否合法
            const eventId = ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_SEARCH_SHIPPING;
            this.propertyFormValidate(eventId);
            return;
        }

        // 校验当前产品属性是否合法
        const propertyVerify = PropertyModelManager.checkPropertyModelLegal(propertyModel);

        // 产品属性校验未通过，提示用户查看当前属性表单是否合法
        if (!propertyVerify) {
            let tipConfig: IMessageDialogOptions = {
                title: this.$translate.instant("A103B007"),
                content: this.$translate.instant("A103B008", {
                    supportmail: this.supportmail
                })
            }
            this.qpMessageDialog.info(tipConfig);
            return;
        }
        // 获取地区国家code
        const countryCode = this.getCountryCode(this.currentCountry);
        // 获取货币code
        const currencyCode = this.getCurrencyCode();
        // 获取预估配送信息-产品数量
        const shippingQtyList = this.getShippingQtyList(shippingQty);

        // 获取当前产品属性作为本地缓存key
        this.propertyService.getAllAttributeValue(this)
            .then(attributeResp => {
                // 创建当前属性快照作为pricing的key,进行预估配送运费缓存
                const attributeSnapshot = this.productDetailManager.creatAttributeSnapshot(attributeResp.data);
                // 属性快照转为字符串
                const snapshotKey = angular.toJson(attributeSnapshot);
                // 产品数量拼接字符串
                const qtysKey = 'qty' + shippingQtyList.join('-');
                // 预估配送信息查询历史记录表示
                const deliveryCtyQtyKey = `${currencyCode}-${snapshotKey}-${countryCode}-${qtysKey}`;
                // 检查预估运费缓存
                const skuDeliveryCache = this.getSkuCountryDeliveryCache(deliveryCtyQtyKey);
                // 未查询到对应的预估运费缓存信息,调用rest接口
                if (skuDeliveryCache) {
                    // 设置预估产品配送信息数据
                    this.skuDeliveriesViewValue = [skuDeliveryCache];
                } else {
                    // 预估配送费用加载-开启
                    this.deliveriesPriceLoading = true;
                    this.shippingRestService.getFreight(currencyCode, countryCode, propertyModel, shippingQtyList)
                        .then(respData => {
                            // 预估运费（当前查询的countryCode）转为预估运费视图数据
                            let freightData = deserialize(respData.data, Freight);
                            const deliveryInfo = this.createCountryDeliveryView(freightData);
                            // 产品信息
                            const productInfo = this.createProductInfoView(freightData);
                            // 设置预估配送信息视图数据
                            const skuDeliveryView: ISkuDeliveryView = {
                                product: productInfo,
                                shippingMethods: deliveryInfo.deliveries
                            }
                            this.skuDeliveriesViewValue = [skuDeliveryView];
                            //  设置预估配送信息--地区配送信息本地缓存数据
                            this.setSkuCountryDeliveryCache(deliveryCtyQtyKey, skuDeliveryView);
                            // 更新预估配送费用查询记录信息
                            if (this.deliveryCtyQtyHistory) {
                                if (this.deliveryCtyQtyHistory.indexOf(deliveryCtyQtyKey) == -1) {
                                    this.deliveryCtyQtyHistory.push(deliveryCtyQtyKey);
                                }
                            } else {
                                this.deliveryCtyQtyHistory = [deliveryCtyQtyKey];
                            }
                        }, error => {
                            this.permissionService.onRequestFailed(error)
                                .then(resError => {
                                    const errorCode = resError.code;
                                    let tipConfig: IMessageDialogOptions = {
                                        title: this.$translate.instant("PRODUCT_DETAIL_SHIPPING_ISSUE_TITLE"),
                                        content: this.$translate.instant("PRODUCT_DETAIL_SHIPPING_ISSUE_TITLE_CONTENT2", { supportmail: envConfig.supportEmail })
                                    }
                                    if (errorCode == '200001') {
                                        // 产品不存在
                                        tipConfig.code = "A103B200001";
                                        tipConfig.msg = this.$translate.instant('A103B200001', {
                                            supportmail: this.supportmail
                                        });
                                    } else if (errorCode == '2000033' || errorCode == '2000055') {
                                        //2000033： propertyModel:{propertyModelId}；2000055：单双向属性计算参数错误（非逻辑）原因：{message}
                                        tipConfig.code = "A103B2000033";
                                        tipConfig.msg = this.$translate.instant('A103B2000033', {
                                            supportmail: this.supportmail
                                        });
                                    } else if (errorCode == '4000061' || errorCode == '4000062') {
                                        // 4000061：计算产品重量异常，原因如下:{message}；4000062：// 错误的产品重量！
                                        tipConfig.code = "A103B4000061";
                                        tipConfig.msg = this.$translate.instant('A103B4000061', {
                                            supportmail: this.supportmail
                                        });
                                    } else if (errorCode == '4000063') {
                                        // 调用PS运费远程服务接口异常,信息:{message}
                                        tipConfig.code = "A103B4000063";
                                        tipConfig.msg = this.$translate.instant('A103B4000063', {
                                            supportmail: this.supportmail
                                        });
                                    } else if (errorCode == '30000027' || errorCode == '30000028') {
                                        // 30000027：产品id:{productId}没有找到生效的生产天数配置；30000028：生产天数计算配置id:{configId}没有生产配置,检查ProductionDaySetting
                                        tipConfig.code = "A103B30000027";
                                        tipConfig.msg = this.$translate.instant('A103B30000027', {
                                            supportmail: this.supportmail
                                        });
                                    } else if (errorCode == "300310") {
                                        // 平台货币配置缺失
                                        const currentCurrency = resError.errorParams?.currencyCode;
                                        this.missingCurrencyConfigTipModal(this.$translate.instant('PRODUCT_DETAIL_SHIPPING_ERROR_TITLE'), currentCurrency);
                                        return;
                                    } else if (errorCode == "3000601") {
                                        //平台:{platformCode} 范围:{usageScope} 不支持货币:{currencyCode} ! 
                                        const supportCurrencyCodes = resError.errorParams.supportCurrencyCodes ? resError.errorParams.supportCurrencyCodes.join(',') : (envConfig.APP_NAME).toUpperCase();
                                        const platformCode = resError.errorParams.platformCode;
                                        const currentCurrency = resError.errorParams.currencyCode;
                                        this.nonsupportCurrencyTipModal(tipConfig.title, currentCurrency, platformCode, supportCurrencyCodes);
                                        return;
                                    } else {
                                        this.qpMessageDialog.info(tipConfig);
                                        // 未知错误发送sentry
                                        this.sendError('product-deatail.productDetailController.searchDeliveryInfo', error);
                                    }
                                })
                        })
                        .finally(() => {
                            // 预估配送费用状态--关闭
                            this.deliveriesPriceLoading = false;
                        })
                }
            });
    }

    /**
     * @description 更新dashboard中产品下单购物车时iframe的货币
     * */
    private updateIframeCurrency(args: productCatalogIframeUpdateCurrencyParams) {
        if (args.data.type == "UpdateCurrency") {
            this.eventBus.dispatch("UpdateCurrency", {
                code: args.data.data.currencyCode
            });
        }
    }

    /**
     * @description 用户偏好设置，货币不支持提示信息
     * @param tipTitle
     * */
    private missingCurrencyConfigTipModal(tipTitle: string, currentCurrency: string) {
        // 平台名称
        const appName = (envConfig.APP_NAME).toUpperCase();
        // 客服服务邮箱
        const serviceEmail = envConfig.serviceEmail;
        const updateCurrencyBtn = this.$translate.instant('HEADER_PREFERENCE_CURRENCY');
        let modalConfig: IMessageDialogOptions = {
            title: tipTitle,
            content: this.$translate.instant("PRODUCT_DETAIL_CURRENCY_CONFIG_MISSING", { updateCurrencyBtn: updateCurrencyBtn, appName: appName, serviceEmail: serviceEmail })
        }
        modalConfig.code = "A103B300310"
        modalConfig.msg = this.$translate.instant('A103B300310', { currentCurrency: currentCurrency })
        this.qpMessageDialog.warning(modalConfig);
    }

    /**
     * @description 用户偏好设置，货币不支持提示信息
     * @param tipTitle
     * */
    private nonsupportCurrencyTipModal(tipTitle: string, currentCurrency: string, appName: string, supportCurrencies: string) {
        // 客服服务邮箱
        const serviceEmail = envConfig.serviceEmail;
        const updateCurrencyBtn = this.$translate.instant('HEADER_PREFERENCE_CURRENCY');
        let modalConfig: IMessageDialogOptions = {
            title: tipTitle,
            content: this.$translate.instant("PRODUCT_DETAIL_CURRENCY_NONSUPPORT", { updateCurrencyBtn: updateCurrencyBtn, appName: appName })
        }
        modalConfig.code = "A103B3000601"
        modalConfig.msg = this.$translate.instant('A103B3000601', { currentCurrency: currentCurrency, supportCurrencies: supportCurrencies, appName: appName })
        this.qpMessageDialog.warning(modalConfig);
    }


    /************************************************属性表单集成***************************************************/

    /**
     * @description propertyIframeWindow--属性表單視圖初始化完成
     * */
    public propertyIframeOnInit() {
        // 属性表单初始化状态-开启
        this.propertyFormLoaded = false;
    }


    /**
     * @description propertyIframeWindow--属性表單視圖初始化完成
     * */
    public propertyIframeLoaded(eventData) {
        //属性表单初始化完成-获取propertyModelForm数据，初始化页面
        if (eventData.success) {
            const eventId = ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_PAGE_ONINIT;
            this.propertyIframeGetPropertyModel(eventId);
        } else {
            // 提示用户，V2属性表单初始化失败提示
            let config: IMessageDialogOptions = {
                title: this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE"),
                content: this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE_CONTENT", { supportmail: envConfig.supportEmail }),
                code: "251113501",
                msg: this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE_251113501")
            }
            this.qpMessageDialog.info(config);
        }

    }

    /**
     * @description propertyIframeWindow--属性表单自身验证_开启
     * */
    public propertyIframelifeCycleValidating(eventData: PropertyFormWinwowEventData) {
        // 属性表单加载状态-开启
        this.propertyChanging = true;
    }

    /**
     * @description propertyIframeWindow--属性表单自身验证_关闭
     * @param eventData
     * */
    public propertyIframelifeCycleValidated(eventData: PropertyFormWinwowEventData) {
        const propertyValidatedDate = eventData.data as LifeCycleAfterValidateEventData;
        // 属性表单加载状态-关闭
        this.propertyChanging = false;
        if (eventData.success && propertyValidatedDate) {
            const propertyModel = propertyValidatedDate as unknown as PropertyModelForm;
            // 更新propertyModelForm数据
            this.propertyModelForm = propertyModel;
            // 属性表单不合法
            if (propertyModel.errorInfos && propertyModel.errorInfos.length > 0) {
                return;
            } else {
                // 属性表单合法
                // TODO 更新产品设计模式
                const productId = this.$scope.currentProductId;
                this.updateDesignModelInfoByFormId(productId, this.propertyModelForm._id)
                    .then(designModel => {
                        // 新增产品计价队列项-执行产品计价
                        this.addToPricingQueue();
                        // 触发预估配送费用更新
                        if (this.tabShippingShow || this.infoStatusInMobile.shippingIsOpen) {
                            // 获取预估配送费用信息
                            this.searchDeliveryInfo(undefined, this.shippingQty);
                        }
                        // 更新产品最小购买数量
                        if (this.$scope.hasMoq) {
                            const eventKeyValueId = ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_MOQ;
                            this.propertyIframeGetKeyValue(eventKeyValueId);
                        }
                    })
            }

        } else {
            // 提示用户，属性表单自身校验失败
            let config: IMessageDialogOptions = {
                title: this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE"),
                content: this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE_CONTENT", { supportmail: envConfig.supportEmail }),
                code: "251216064",
                msg: this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE_251216064"),
            }
            this.qpMessageDialog.info(config);
        }
    }

    /**
     * @description propertyIframeWindow--Token过期，重置token
     * */
    public propertyIframeExpired() {
        // 重新获取token信息，调用属性表单token重置方法
        this.permissionService.syncCheckAuthorization(() => {
            // 重置token-属性表单
            this.propertyIframeResetToken(ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_RESET_TOKEN);
        })
    }

    /**
     * @description propertyIframeWindow--重置token
     * @param eventId
     * */
    public propertyIframeResetToken(eventId: string) {
        // 属性表单加载状态-开启
        this.propertyChanging = true;
        // 获取propertyIframeWindow对象
        const propertyIframeWindow = this.getPropertyIframeWindow();
        if (propertyIframeWindow === null || !this.$objectTree.token) {
            // 属性表单加载状态-关闭
            this.propertyChanging = false;
            this.propertyIframeResetToken(eventId);
            return;
        }
        // 更新外部property数据-属性键值对-派发事件
        const postMessageData: ResetTokenPostMessageData = {
            eventId: eventId,
            token: this.$objectTree.token.access_token,
            tokenType: this.$objectTree.token.token_type,
            unique: this.propertyIframeEleId
        }
        const argObj: PropertyFormWindowPostMessage = {
            type: PropertyFormEventEnum.PROPERTY_FORM_WINDOW_RESET_TOKEN,
            data: postMessageData
        };
        propertyIframeWindow.postMessage(argObj, '*');
    }

    /**
     * @description propertyIframeWindow--重置token回调
     * */
    public propertyIframeAfterResetToken(eventData: PropertyFormWinwowEventData) {
        const afterResetTokenEventData = eventData.data as ResetTokenEventData;
        if (afterResetTokenEventData.eventId === ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_RESET_TOKEN) {
            if (eventData.success) {
                // 属性表单加载状态-关闭
                this.propertyChanging = false;
            } else {
                // 提示用户，属性表单自身校验失败
                let config: IMessageDialogOptions = {
                    title: this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE"),
                    content: this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE_CONTENT", { supportmail: envConfig.supportEmail }),
                    code: "249962969",
                    msg: this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE_249962969")
                }
                this.qpMessageDialog.info(config);
            }
        }

    }
    /**
      * @description propertyIframeWindow--GetKeyValue事件
      * */
    public propertyIframeGetKeyValue(eventId: string) {
        // 获取propertyIframeWindow对象
        const propertyIframeWindow = this.getPropertyIframeWindow();
        if (propertyIframeWindow === null) {
            // 属性表单保存状态-开启
            this.propertySaving = false;
            this.propertyIframeGetKeyValue(eventId);
            return;
        }
        // 更新外部property数据-属性键值对-派发事件
        const argObj: PropertyFormWindowPostMessage = {
            type: PropertyFormEventEnum.PROPERTY_FORM_WINDOW_GET_KEY_VALUE,
            data: {
                eventId: eventId,
                unique: this.propertyIframeEleId
            }
        };
        propertyIframeWindow.postMessage(argObj, '*');
    }

    /**
     * @description propertyIframeWindow--GetKeyValue事件回调
     * */
    public propertyIframeAfterGetKeyValue(eventData: PropertyFormWinwowEventData) {
        if (eventData.success) {
            const keyValueEventData = eventData.data as GetKeyValueEventData;
            // 页面初始化
            if (keyValueEventData.eventId === ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_MOQ) {
                if (this.$scope.hasMoq) {
                    // 根据GetKeyValue事件回调返回数据，获取属性键值对
                    const attrKeyArray = this.creatAttrKeyValueByV2Property(keyValueEventData.attributes);
                    this.updateMinOrderQty(attrKeyArray)
                        .then(resMoq => {
                            // 设置最小购买数量
                            this.moq = resMoq;
                        }, error => {
                            this.permissionService.onRequestFailed(error);
                        })
                }
            }
            // 查询产品预估配送费用
            if (keyValueEventData.eventId === ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_SEARCH_SHIPPING) {
                // 获取产品预估运费
                this.searchDeliveryInfoByV2Property(this.propertyModelForm, keyValueEventData.attributes, this.shippingQty);
            }
            // 查询产品价格
            if (keyValueEventData.eventId === ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_PRICING) {
                this.doPricingCreatePricingByV2Property(this.propertyModelForm, keyValueEventData.attributes);
            }
        } else {
            const keyValueEventData = eventData.data as GetKeyValueEventData;
            if (keyValueEventData.eventId === ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_SEARCH_SHIPPING || keyValueEventData.eventId === ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_PRICING || keyValueEventData.eventId === ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_PRICING) {
                // V2属性表单获取属性keyValue异常
                let config: IMessageDialogOptions = {
                    title: this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE"),
                    content: this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE_CONTENT", { supportmail: envConfig.supportEmail }),
                    code: "251216855"
                }
                if (keyValueEventData.eventId) {
                    config.msg = this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE_251216855_BY_EVENTID", { eventId: keyValueEventData.eventId });
                } else {
                    config.msg = this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE_251216855");
                }
                this.qpMessageDialog.info(config);
            }
        }
    }

    /**
     * @description 根据propertyIframeWindow--GetKeyValue事件回调返回数据，创建当前选中项属性键值对数组
     * @params attributes
     * */

    public creatAttrKeyValueByV2Property(attributes: Array<KeyValueEventDataAttribute>): Array<IPropertyKey> {
        // 组成属性键值对返回
        let keyValues: Array<IPropertyKey> = []
        attributes.forEach(item => {
            if (item.skuAttributeId) {
                const keyValue: IPropertyKey = {
                    attributeId: item.attributeId,
                    value: item.value
                }
                keyValues.push(keyValue);
            }
        })
        return keyValues;
    }
    /**
     * @description 根据propertyIframeWindow--GetKeyValue事件回调返回数据，创建当前产品属性快照
     * @params attributes
     * */
    public creatAttributeSnapshotByV2Property(attributes: Array<KeyValueEventDataAttribute>) {
        let snapshot = {}
        attributes.forEach(item => {
            snapshot[item.attributeId] = item.value;
        })
        return snapshot;
    }

    /**
     * @description propertyIframeWindow--表单页面尺寸变化
     * */
    public propertyIframeOnResize(eventData: PropertyFormWinwowEventData) {
        const resizeEventData = eventData.data as OnResizeEventData;
        // 成功
        if (eventData.success) {
            this.propertyIframeHeight = `${resizeEventData.height + 16}` + resizeEventData.unit;
        } else {
            //设置默认属性表单高度
            this.propertyIframeHeight = "373px";
        }
        this.$timeout(() => {
            // 属性表单初始化状态-关闭
            this.propertyFormLoaded = true;
        });
    }

    /**
     * @description propertyIframeWindow--表单运行过程中产生了异常
     * */
    public propertyIframeOnError(eventData: PropertyFormWinwowEventData) {
        // 添加异常错误处理 404 | 500
        const errorEventDate = eventData as OnErrorEventData;
        let config: IMessageDialogOptions = {
            title: this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE"),
            content: this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE_CONTENT", { supportmail: envConfig.supportEmail }),
            code: "251113554"
        }
        if (errorEventDate.eventId) {
            config.msg = this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE_251113554_BY_EVENTID", { eventId: errorEventDate.eventId })
        } else {
            config.msg = this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE_251113554")
        }
        // V2属性表单接口报404
        if (errorEventDate.code === '404') {
            config.title = this.$translate.instant("SYSTEM_ERROR_TITLE");
            config.content = this.$translate.instant("SYSTEM_ERROR_CONTENT", { supportmail: envConfig.supportEmail });

            this.qpMessageDialog.error(config);
            return;
        }
        // V2属性表单接口报500
        if (errorEventDate.code === '500') {
            config.title = this.$translate.instant("NETWORK_CONNECTION_TIMEOUT_TITLE");
            config.content = this.$translate.instant("NETWORK_CONNECTION_TIMEOUT_CONTENT");
            if (errorEventDate.eventId) {
                config.msg = this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE_251113554_BY_EVENTID", { eventId: errorEventDate.eventId })
            }
        }

        this.qpMessageDialog.info(config);
    }
    /**
     * @description propertyIframeWindow--调用超时
     * */
    public propertyIframeOnTimeout() {
        //属性表单相应超时
        let config: IMessageDialogOptions = {
            title: this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE"),
            content: this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE_CONTENT", { supportmail: envConfig.supportEmail }),
            code: "249962976",
            msg: this.$translate.instant('PRODUCT_PROPERTY_FORM_ISSUE_249962976')
        }
        this.qpMessageDialog.info(config);
    }
    /**
     * @description 校验property--propertyIframeWindow
     * @param eventId
     * */
    public propertyFormValidate(eventId: string) {
        // 属性表单加载状态-开启
        this.propertyChanging = true;
        // 获取propertyIframeWindow对象
        const propertyIframeWindow = this.getPropertyIframeWindow();
        if (propertyIframeWindow === null) {
            // 属性表单加载状态-开启
            this.propertyChanging = false;
            this.propertyFormValidate(eventId);
            return;
        }
        const argObj: PropertyFormWindowPostMessage = {
            type: PropertyFormEventEnum.PROPERTY_FORM_WINDOW_VALIDATE,
            data: {
                eventId: eventId,
                unique: this.propertyIframeEleId
            }
        };
        propertyIframeWindow.postMessage(argObj, '*');
    }

    /**
     * @description propertyIframeWindow--属性表单验证_关闭
     * */
    public propertyIframeValidated(eventData: PropertyFormWinwowEventData) {
        const validatedDate = eventData.data as PropertyValidateEventData;
        this.$timeout(() => {
            // 属性表单验证-成功
            if (eventData.success && validatedDate.isLegal) {
                //start deign-保存属性表单-跳转builder进行定制
                if (validatedDate.eventId === ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_START_DESIGN_CONFIGURABLE) {
                    this.propertyFormSave(ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_START_DESIGN_CONFIGURABLE);
                }
                //add to store product-保存属性表单-打开店铺产品设置页
                if (validatedDate.eventId === ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_ADD_STORE_PRODUCT) {
                    this.propertyFormSave(ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_ADD_STORE_PRODUCT);
                }
                //add to card-保存属性表单-添加产品到购物车
                if (validatedDate.eventId === ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_ADD_TO_CARD) {
                    this.propertyFormSave(ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_ADD_TO_CARD);
                }
                //获取产品配送费用
                if (validatedDate.eventId === ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_SEARCH_SHIPPING) {
                    // 获取属性键值对
                    this.propertyIframeGetKeyValue(ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_SEARCH_SHIPPING)
                }
                // 下载产品配送费用Excel
                if (validatedDate.eventId === ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_DOWNLOAD_SHIPPING) {
                    this.downLoadShippingExcelByV2Property(this.propertyModelForm);
                }
            } else {
                if (validatedDate.eventId === ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_START_DESIGN_CONFIGURABLE || validatedDate.eventId === ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_ADD_STORE_PRODUCT || validatedDate.eventId === ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_ADD_TO_CARD || validatedDate.eventId === ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_ADD_TO_CARD || validatedDate.eventId === ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_SEARCH_SHIPPING || validatedDate.eventId === ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_DOWNLOAD_SHIPPING) {
                    // 提示用户，属性表单校验失败
                    let config: IMessageDialogOptions = {
                        title: this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE"),
                        content: this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE_CONTENT", { supportmail: envConfig.supportEmail }),
                        code: "251217152",
                        msg: this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE_251217152")
                    }
                    this.qpMessageDialog.info(config);
                }
            }
            // 属性表单加载状态-关闭
            this.propertyChanging = false;
        })
    }

    /**
     * @description 保存property--propertyIframeWindow
     * @param eventId
     * */
    public propertyFormSave(eventId: string) {
        // 属性表单保存状态-开启
        this.propertySaving = true;
        // 获取propertyIframeWindow对象
        const propertyIframeWindow = this.getPropertyIframeWindow();
        if (propertyIframeWindow === null) {
            // 属性表单保存状态-开启
            this.propertySaving = false;
            this.propertyFormSave(eventId);
            return;
        }
        const postMessageData: SavePostMessageData = {
            saveNew: false,
            eventId: eventId,
            unique: this.propertyIframeEleId
        };
        const argObj: PropertyFormWindowPostMessage = {
            type: PropertyFormEventEnum.PROPERTY_FORM_WINDOW_SAVE,
            data: postMessageData
        };
        propertyIframeWindow.postMessage(argObj, '*');
    }

    /**
     * @description propertyIframeWindow--保存propertyForm回调
     * */
    public propertyIframeSaved(eventData: PropertyFormWinwowEventData) {
        // 成功
        let propertyModelData = eventData.data as PropertyModelEventData;
        if (eventData.success) {
            //保存属性表单-跳转builder进行定制
            if (propertyModelData.eventId === ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_START_DESIGN_CONFIGURABLE) {
                this.startDesignByV2Property('CONFIGURABLE', propertyModelData);
            }
            //保存属性表单-打开店铺产品设置页
            if (propertyModelData.eventId === ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_ADD_STORE_PRODUCT) {
                this.openAddProductModalByV2Property(propertyModelData);
            }
            // 保存属性表单-添加产品到购物车
            if (propertyModelData.eventId === ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_ADD_TO_CARD) {
                this.addToCartByV2Property(propertyModelData);
            }

        } else {
            if (propertyModelData.eventId === ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_START_DESIGN_CONFIGURABLE || propertyModelData.eventId === ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_ADD_STORE_PRODUCT || propertyModelData.eventId === ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_ADD_TO_CARD) {
                //TODO（待优化） 提示用户属性表单保存失败，是否需要回退上一个版本
                let config: IMessageDialogOptions = {
                    title: this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE"),
                    content: this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE_CONTENT", { supportmail: envConfig.supportEmail }),
                    code: "251216800",
                    msg: this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE_251216800")
                }
                this.qpMessageDialog.info(config);
            }

        }

        // 属性表单保存状态-关闭
        this.propertySaving = false;
    }
    /**
     * @description propertyIframeWindow--查询表单完整数据
     * */
    public propertyIframeGetPropertyModel(eventId: string) {
        // 属性表单保存状态-开启
        // this.propertySaving = true;
        // 获取propertyIframeWindow对象
        const propertyIframeWindow = this.getPropertyIframeWindow();
        if (propertyIframeWindow === null) {
            // 属性表单保存状态-开启
            this.propertySaving = false;
            this.propertyIframeGetPropertyModel(eventId);
            return;
        }
        const argObj: PropertyFormWindowPostMessage = {
            type: PropertyFormEventEnum.PROPERTY_FORM_WINDOW_GET,
            data: {
                eventId: eventId,
                unique: this.propertyIframeEleId
            }
        };
        propertyIframeWindow.postMessage(argObj, '*');
    }

    /**
     * @description propertyIframeWindow--查询表单完整数据-回调
     * */
    public propertyIframePropertyModelCallback(eventData: PropertyFormWinwowEventData) {
        const data = eventData.data as GetPropertyMdoelEventData;
        // 成功
        if (eventData.success) {
            // 更新propertyModelForm
            this.propertyModelForm = data.propertyModel;
            // 页面初始化-更新propertyModelForm数据
            if (data.eventId === ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_PAGE_ONINIT) {
                const productId = this.$scope.currentProductId;
                const formId = data.propertyModel._id;
                this.updateDesignModelInfoByFormId(productId, formId, this.designModel)
                    .then(() => {
                        this.initFinish = true;
                        this.$objectTree.configurableProductId = this.configurableProductId = this.propertyModelForm.configurableProductId;
                        // 加载数量价格表
                        // if (this.$scope.currencyCode !== this.userCurrencyCode) {
                        //     this.addToPricingQueue();
                        // }
                        this.addToPricingQueue();
                        // 触发预估配送费用更新
                        // if (this.tabShippingShow || this.infoStatusInMobile.shippingIsOpen) {
                        //     // 获取预估配送费用信息
                        //     this.searchDeliveryInfo(this.propertyModelForm, this.shippingQty);
                        // }
                        //加载预估产品配送费用
                        // if (this.tabShippingShow || this.activeInfoIndex === 1 || this.infoStatusInMobile.shippingIsOpen) {
                        //     this.initDeliveriesInfo();
                        // }
                        this.initDeliveriesInfo();
                        // 触发产品最小购买数量
                        if (this.$scope.hasMoq) {
                            this.propertyIframeGetKeyValue(ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_MOQ);
                        }
                        // 跳转锚点
                        if (this.currentAnchId) {
                            // 获取页面锚点数组
                            this.anchIdArr = [];
                            this.getAnchIdArr();
                            this.anchIdArr.forEach((ele, index) => {
                                if (ele.nodeTop <= Math.ceil(document.documentElement.scrollTop) && (index == this.anchIdArr.length - 1)) {
                                    this.currentAnchId = ele.id;
                                    return;
                                }
                                if (ele.nodeTop <= Math.ceil(document.documentElement.scrollTop) && this.anchIdArr[index + 1].nodeTop > document.documentElement.scrollTop) {
                                    this.currentAnchId = ele.id;
                                }
                            });
                            //shipping信息开启
                            this.activeInfoIndex = 1;
                            this.infoStatusInMobile.shippingIsOpen = true;
                            this.changeCurrentanchId(this.currentAnchId)
                        }
                    })
            }
        } else {
            if (data.eventId === ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_PAGE_ONINIT) {
                //查询表单完整数据失败-提示用户属性表单异常
                let config: IMessageDialogOptions = {
                    title: this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE"),
                    content: this.$translate.instant("PRODUCT_PROPERTY_FORM_ISSUE_CONTENT", { supportmail: envConfig.supportEmail }),
                }
                this.qpMessageDialog.info(config);
            }
        }
    }
    /**
     * URL安全访问
     * @param url 
     * @returns 
     */
    public trustAsUrl(url: string) {
        const propertyFormUrl = this.createPropertyUrl(url);
        return this.$sce.trustAsResourceUrl(propertyFormUrl);
    }
    /**
     * @param url 
     * @returns 
     */
    public createPropertyUrl(url: string): string {
        let propertyFormUrl: string = url;

        // 获取token信息
        const partnerToken: IToken | undefined = this.$objectTree.token;
        if (!partnerToken) {
            // 重新获取token信息
            this.permissionService.syncCheckAuthorization(() => {
                // 重置token-属性表单
                return this.createPropertyUrl(url);
            })
        } else {
            // 获取当前时间戳
            const timestamp = String(new Date().getTime());
            // 设置属性表单地址信息
            const appPath = envConfig.appPath();
            propertyFormUrl = `${appPath}${propertyFormUrl}?token=${partnerToken.access_token}&tokenType=${partnerToken.token_type}&discrete=select&unique=${this.propertyIframeEleId}&timestamp=${timestamp}`;
            if (this.urlPropertyModelId) {
                propertyFormUrl = propertyFormUrl + `&propertyModelId=${this.urlPropertyModelId}`;
            }
        }
        return propertyFormUrl;
    }


    /**
     * @decription  获取propertyIframeWindow对象
     * */
    private getPropertyIframeWindow(): Window | null {
        // 获取Iframe中的propertyIframe.window
        let propertyIframeWindow;
        // 通过原生DOM,获取iframe元素对象
        let iframeEle = document.getElementById(this.propertyIframeEleId);
        if (iframeEle) {
            propertyIframeWindow = (iframeEle as HTMLIFrameElement).contentWindow;
        } else {
            propertyIframeWindow = window.frames[this.propertyIframeEleId];
        }
        if (!propertyIframeWindow) {
            return null;
        }
        return propertyIframeWindow;
    }

    /**
     * @desc 调整builder定制
     * @param productType
     * @returns 
     */
    public startDesignByV2Property(productType: string, propertyModelData: PropertyModelEventData) {
        switch (this.designModel) {
            case 'RANDOM':
                this.goRandomDesign(propertyModelData.propertyModelId, productType);
                this.propertyLock = false;
                break;
            default:
                const propertyModelId = propertyModelData.propertyModelId;
                let _builderParams: IPathParams = BuilderManager.creatParams({
                    propertyModelId: propertyModelId,
                    type: "builder",
                    platform: "PC"
                });
                _builderParams.builderType = "Partner";

                // 获取产品关联的builder地址
                this.builderRestService.getPath(_builderParams.builderType, _builderParams)
                    .then(pathResp => {
                        if (!pathResp) {
                            return
                        }
                        // builder地址
                        let path = pathResp.data as string;
                        // 获取builder集成页地址
                        let builderPagePath = BuilderUtil.getBuilderPagePath(path, this.pageContext.rootPath);

                        // 拼接builder集成也url参数
                        let _sourceId;
                        if (this.$filter('lowercase')(productType) == this.$filter('lowercase')(ProductTypeEnum.CONFIGURABLE)) {
                            _sourceId = String(propertyModelId);
                        } else {
                            // TODO 暂不支持（无sku产品类型的产品详情页面）
                            // if (this.$filter('lowercase')(productType) == this.$filter('lowercase')(ProductTypeEnum.SKU)) {
                            //     _sourceId = String(this.currentProductId);
                            // } 
                            // 
                            window.qpAlertPrompt.info(this.$translate.instant('PRODUCT_DETAIL_INVALID_ORDER_A_SAMPLE_TITLE'), this.$translate.instant("PRODUCT_DETAIL_INVALID_ORDER_A_SAMPLE_CONTENT"));
                            return;
                        }

                        let builderPath = this.urlBuilder.setUrlParams(builderPagePath, {
                            // TODO source路径方法待改善
                            source: "productDetail",
                            sourceId: _sourceId,
                            qty: "1",
                            prePath: window.location.pathname,
                            productType: productType,
                            propertyModelVersion: "V2"
                        }, this)
                        if (!angular.isUndefined(this.$scope.cmsConfigVersion)) {
                            builderPath = this.urlBuilder.setUrlParams(builderPath, {
                                cmsConfigVersion: String(this.$scope.cmsConfigVersion)
                            }, this)
                        }
                        // 设置店铺产品ID参数
                        if (!angular.isUndefined(this.storeProductId)) {
                            builderPath = this.urlBuilder.setUrlParams(builderPath, {
                                storeProductId: String(this.storeProductId)
                            }, this)
                        }
                        // 设置属性版本编号
                        if (this.$scope.attributeVersionNumber) {
                            builderPath = this.urlBuilder.setUrlParams(builderPath, {
                                attributeVersionNumber: this.$scope.attributeVersionNumber
                            }, this)
                        }
                        // 跳转至builder定制页
                        window.location.href = builderPath;
                    })
                    .catch((error) => {
                        this.permissionService.onRequestFail(error);
                    })
                    .finally(() => {
                        this.propertyLock = false;
                    });
                break;
        }
    }
    /**
     * @desc 打开店铺产品设置页-添加店铺产品（storeProductType:'SKU_WITH_DESIGN' || "SKU_WITHOUT_DESIGN"）
     * @param productType
     * @returns 
     */
    public openAddProductModalByV2Property(propertyModelData: PropertyModelEventData) {
        const propertyModelId = propertyModelData.propertyModelId;

        // 预添加店铺产品的店铺已确定，店铺产品类型已确定(随机卡（随机设计）)
        if (this.storeType && this.sourceStoreId && this.designModel === 'RANDOM') {
            // 打开店铺产品设置页
            const storeInfo: StoreInfo = { platform: this.storeType, id: this.sourceStoreId };
            const storeProductType = "SKU_WITH_DESIGN";
            // 创建店铺产品设置页模态框参数
            let modelParams: IStoreProductSettingModalParams = {
                storeProductType: storeProductType,
                storeIds: [storeInfo.id],
                storeName: this.sourceStoreName as string,
                storeUrl: this.sourceStoreUrl ? this.sourceStoreUrl : undefined,
                editType: "add",
                rootPath: this.rootPath,
                isFinished: this.$scope.isFinished,
                cmsConfigVersion: this.$scope.cmsConfigVersion,
                propertyModelVersion: "V2",
                storeType: this.storeType,
                productDesignModel: this.designModel,
                designMethodVersion: this.$scope.designMethodVersion
            }
            if (this.$scope.attributeVersion) {
                modelParams.attributeVersion = this.$scope.attributeVersion;
            }
            // 设置产品计价类型
            if (!is.undefined(this.$scope) && !is.undefined(this.$scope.priceType)) {
                modelParams.whiteLabelPriceType = this.$scope.priceType;
            }
            // 设置产品是否为固定价格
            if (!is.undefined(this.$scope) && !is.undefined(this.$scope.isFixedPrice)) {
                modelParams.whiteLabelfixedPrice = this.$scope.isFixedPrice;
            }
            // 设置产品价格是否受属性影响
            if (!is.undefined(this.$scope) && !is.undefined(this.$scope.priceAffectedByAttribute)) {
                modelParams.whiteLabelPriceAffectedByAttribute = this.$scope.priceAffectedByAttribute;
            }
            // 设置产品价格是否受数量影响
            if (!is.undefined(this.$scope) && !is.undefined(this.$scope.priceAffectedByQuantity)) {
                modelParams.whiteLabelPriceAffectedByQuantity = this.$scope.priceAffectedByQuantity;
            }
            // 设置产品离散计价默认qty数组
            if (!is.undefined(this.$scope) && !is.undefined(this.$scope.discretePriceRange)) {
                modelParams.whiteLabelDiscretePriceRange = this.$scope.discretePriceRange;
            }

            // 根据店铺产品类型，设置对应的whiteLabelProductId和propertyModelId
            this.openAddProductModalAfterByV2Property(modelParams, storeProductType, storeInfo, propertyModelId);
        } else {
            // addStoreProductModal模态框参数
            let addStoreProductModalParams = {
                rootPath: this.pageContext.rootPath,
                // TODO 选择店铺界面开发尚未完成,先采用固定店铺id
                // storeId: this.sourceStoreId ?? [{ id: "44506843", type: "WooCommerce" }],
                storeId: this.sourceStoreId,
                store: {
                    id: this.sourceStoreId,
                    platform: this.storeType,
                    storeName: this.sourceStoreName,
                    storeUrl: this.sourceStoreUrl ? this.sourceStoreUrl : undefined
                },
                isFinished: this.$scope.isFinished,
                whitelabelProductId: this.currentProductId,
                versionedAttributeId: this.$scope.attributeVersion
            }
            //店铺产品产品类型已确定（SKU_WITH_DESIGN）
            if (this.designModel === 'RANDOM') {
                addStoreProductModalParams['productType'] = "SKU_WITH_DESIGN";
            }

            // 打开选择
            const storeProductModalInstance = this.$uibModal.open({
                component: "addStoreProductModal",
                windowClass: "add-store-modal",
                size: "lg",
                resolve: {
                    items: () => {
                        return addStoreProductModalParams;
                    }
                }
            });

            // 店铺产品类型
            // export type IStoreProductType = "SKU_WITH_DESIGN" | "SKU_WITHOUT_DESIGN" | "FULL_PRODUCT_WITHOUT_DESIGN";
            storeProductModalInstance.result.then(modalParams => {
                if (!modalParams) {
                    return;
                }
                // 打开店铺产品设置页
                const storeInfo = modalParams.stores[0];
                const storeProductType = modalParams.storeProductType;
                const isBind = modalParams.isBind;
                // 创建店铺产品设置页模态框参数
                let modelParams: IStoreProductSettingModalParams = {
                    storeProductType: storeProductType,
                    storeIds: [storeInfo.id],
                    storeName: storeInfo.storeName,
                    storeUrl: storeInfo.storeUrl ? storeInfo.storeUrl : undefined,
                    editType: "add",
                    rootPath: this.rootPath,
                    isFinished: this.$scope.isFinished,
                    cmsConfigVersion: this.$scope.cmsConfigVersion,
                    storeType: storeInfo.platform,
                    propertyModelVersion: "V2",
                    isBind: isBind,
                    designMethodVersion: this.$scope.designMethodVersion
                }
                if (this.$scope.attributeVersion) {
                    modelParams.attributeVersion = this.$scope.attributeVersion;
                }
                if (this.$scope.formCode) {
                    modelParams.propertyFormCode = this.$scope.formCode;
                }
                // 设置产品计价类型
                if (!is.undefined(this.$scope) && !is.undefined(this.$scope.priceType)) {
                    modelParams.whiteLabelPriceType = this.$scope.priceType;
                }
                // 设置产品是否为固定价格
                if (!is.undefined(this.$scope) && !is.undefined(this.$scope.isFixedPrice)) {
                    modelParams.whiteLabelfixedPrice = this.$scope.isFixedPrice;
                }
                // 设置产品价格是否受属性影响
                if (!is.undefined(this.$scope) && !is.undefined(this.$scope.priceAffectedByAttribute)) {
                    modelParams.whiteLabelPriceAffectedByAttribute = this.$scope.priceAffectedByAttribute;
                }
                // 设置产品价格是否受数量影响
                if (!is.undefined(this.$scope) && !is.undefined(this.$scope.priceAffectedByQuantity)) {
                    modelParams.whiteLabelPriceAffectedByQuantity = this.$scope.priceAffectedByQuantity;
                }
                // 设置产品离散计价默认qty数组
                if (!is.undefined(this.$scope) && !is.undefined(this.$scope.discretePriceRange)) {
                    modelParams.whiteLabelDiscretePriceRange = this.$scope.discretePriceRange;
                }
                // 根据店铺产品类型，设置对应的whiteLabelProductId和propertyModelId
                this.openAddProductModalAfterByV2Property(modelParams, storeProductType, storeInfo, propertyModelId);

            }, () => { })
        }
    }

    /**
     * @desc 添加产品到购物车
     * @returns 
     */
    public addToCartByV2Property(propertyModelData: PropertyModelEventData) {
        // 产品最小购买数量MOQ--是否处于加载状态
        if (this.operationStats.updateQty) {
            return;
        }
        // 校验产品类型--是否为成品产品
        if (!this.$scope.isFinished) {
            window.qpAlertPrompt.info(this.$translate.instant('A103B0011'), this.$translate.instant("A103B0012"));
            return;
        }
        // 校验产品购买数量--是否大于等于1,小于最大值
        if (this.productQuantity < this.moq || this.productQuantity > this.QTYMAXLIMIT || !this.productQuantity) {
            window.qpAlertPrompt.info(this.$translate.instant('A103B0013'), this.$translate.instant("A103B0014"));
            return;
        }

        this.qpLoading.open();
        const propertyModelId = propertyModelData.propertyModelId;
        let addCartParams: ICartParams = {
            propertyModelId: Number(propertyModelId),
            qty: this.productQuantity,
            // 旧接口数据兼容
            productInstanceName: null
        }
        if (!angular.isUndefined(this.storeProductId)) {
            addCartParams.storeProductId = this.storeProductId;
        }
        this.cartRestService.addToCart(addCartParams)
            .then(resp => {
                if (!resp) {
                    return;
                }
                // 跳转购物车页
                window.location.href = this.pageContext.rootPath + "cart/";
            })
            .catch(error => {
                // 请求常规错误处理
                this.permissionService.onRequestFail(error);
            })
            .finally(() => {
                this.qpLoading.close();
            })

    }
    /**
      * @desc 添加产品计价队列项
      * @param propertyModelForm
      */
    public addToPricingQueueByV2Property(propertyModelForm: PropertyModelForm) {
        const fromId = propertyModelForm._id;
        this.pricingQueue.push(fromId);
        // 若當前當前沒有執行價格計算，則觸發價格計算
        if (!this.isRequest_pricing) {
            this.doPricingCalculationByV2Property();
        }
    }



    public doPricingCalculationByV2Property() {
        // 检查计价队列是否为空,计价队列为空时,结束价格计算
        if (this.pricingQueue.length == 0) {
            this.isRequest_pricing = false;
            return;
        }
        this.isRequest_pricing = true;
        // 计价队列不为空,取队列最后一项执行价格计算
        const formId = this.pricingQueue[this.pricingQueue.length - 1];
        // 清空计价队列
        this.pricingQueue.length = 0;
        // 获取属性版本
        const attributeVersion = this.$scope.attributeVersion ? Number(this.$scope.attributeVersion) : undefined;
        // 执行价格计算
        if (!this.$objectTree.configurableProductId) {
            // TODO  configurableProductId参数缺失，弹框提示信息
            return;
        }

        // TODO 获取属性表单key
        this.propertyIframeGetKeyValue(ProductPropertyFormEventIdEnum.PRODUCT_PROPERTY_PRICING);
    }

    /**
     * @descriotion 查询产品价格
     * 
     * */
    public doPricingCreatePricingByV2Property(propertyModel: PropertyModelForm, propertyKeys: Array<KeyValueEventDataAttribute>) {
        const formId = propertyModel._id;
        // 获取属性版本
        const attributeVersion = this.$scope.attributeVersion ? Number(this.$scope.attributeVersion) : undefined;
        // 获取产品设计模式，默认为固定设计"fixedDesign"
        const productDesignModel = this.designModel ? this.designModel : undefined;
        this.pricingService.getPricingByFormId(this.$objectTree.configurableProductId as number, formId, propertyKeys, this.userCurrencyCode, productDesignModel, attributeVersion)
            .then(reps => {
                if (!reps) {
                    return;
                }
                // 更新价格列表
                this.pricingList = this.createPriceListViewValue(reps);
                // 更新产品售价
                this.productPrice = this.pricingList.userCurrency[0].currencyEntity.symbol + Number(this.pricingList.userCurrency[0].result).toFixed(2);
                this.doPricingCalculationByV2Property();
            }, (rejectResp) => {
                this.isRequest_pricing = false;
                let modalConfig: IMessageDialogOptions = {
                    title: this.$translate.instant("PRODUCT_DETAIL_PRICE_ISSUE_TITLE"),
                    content: this.$translate.instant("PRODUCT_DETAIL_PRICE_ISSUE_CONTENT", { supportmail: this.supportEmail }),
                }
                this.permissionService.onRequestFailed(rejectResp)
                    .then(e => {
                        const errorCode = !is.undefined(e) && !is.undefined(e.code) ? e.code : "";
                        if (errorCode == "300310") {
                            // 平台货币配置缺失
                            const currentCurrency = e.errorParams?.currencyCode;
                            this.missingCurrencyConfigTipModal(this.$translate.instant('PRODUCT_DETAIL_PRICE_ERROE_TITLE'), currentCurrency);
                            return;
                        } else if (errorCode == "3000601") {
                            //平台:{platformCode} 范围:{usageScope} 不支持货币:{currencyCode} ! 
                            const supportCurrencyCodes = e.errorParams.supportCurrencyCodes ? e.errorParams.supportCurrencyCodes.join(',') : undefined;
                            const platformCode = e.errorParams.platformCode ? e.errorParams.platformCode : (envConfig.APP_NAME).toUpperCase();
                            const currentCurrency = e.errorParams.currencyCode;
                            this.nonsupportCurrencyTipModal(this.$translate.instant('PRODUCT_DETAIL_PRICE_ERROE_TITLE'), currentCurrency, platformCode, supportCurrencyCodes);
                            return;
                        } else {
                            // 未知错误发送sentry
                            this.sendError('product-deatail.productDetailController.doPricingCreatePricingByV2Property.pricingService.getPricingByFormId', rejectResp);
                        }
                        this.qpMessageDialog.info(modalConfig);
                    })

            })
            .finally(() => {
                this.isRequest_pricing = false;
            })
    }


    /**
      * @desc 根据V2属性表单数据，获取属性列表
      * @returns 
      */
    public getAllAttributeValueByV2Property() {
        //TODO 方法待替换，获取产品属性列表数据 
        const attributePromise = this.propertyService.getAllAttributeValue(this);
        return attributePromise;
    }


    /**
      * @desc 根据V2属性表单数据，插叙预估产品费用信息
      * @returns 
     * */
    public searchDeliveryInfoByV2Property(propertyModel: PropertyModelForm, propertyKeys: Array<KeyValueEventDataAttribute>, shippingQty?: number) {
        // 获取地区国家code
        const countryCode = this.getCountryCode(this.currentCountry);
        // 获取货币code
        const currencyCode = this.getCurrencyCode();
        // 获取预估配送信息-产品数量
        const shippingQtyList = this.getShippingQtyList(shippingQty);

        // 获取当前产品属性作为本地缓存key
        // 创建当前属性快照作为pricing的key,进行预估配送运费缓存
        const attributeSnapshot = this.creatAttrKeyValueByV2Property(propertyKeys);
        // 属性快照转为字符串
        const snapshotKey = angular.toJson(attributeSnapshot);
        // 产品数量拼接字符串
        const qtysKey = 'qty' + shippingQtyList.join('-');
        // 预估配送信息查询历史记录表示
        const deliveryCtyQtyKey = `${currencyCode}-${snapshotKey}-${countryCode}-${qtysKey}`;
        // 检查预估运费缓存
        const skuDeliveryCache = this.getSkuCountryDeliveryCache(deliveryCtyQtyKey);
        // 未查询到对应的预估运费缓存信息,调用rest接口
        if (skuDeliveryCache) {
            // 设置预估产品配送信息数据
            this.skuDeliveriesViewValue = [skuDeliveryCache];
        } else {
            // 预估配送信息查询-开启
            this.deliveriesInfoLoading = true;

            this.shippingRestService.getFreightByFormId(currencyCode, countryCode, propertyModel._id, shippingQtyList)
                .then(respData => {
                    // 预估运费（当前查询的countryCode）转为预估运费视图数据
                    let freightData = deserialize(respData.data, Freight);
                    const deliveryInfo = this.createCountryDeliveryView(freightData);
                    // 产品信息
                    const productInfo = this.createProductInfoView(freightData);
                    // 设置预估配送信息视图数据
                    const skuDeliveryView: ISkuDeliveryView = {
                        product: productInfo,
                        shippingMethods: deliveryInfo.deliveries
                    }
                    this.skuDeliveriesViewValue = [skuDeliveryView];
                    //  设置预估配送信息--地区配送信息本地缓存数据
                    this.setSkuCountryDeliveryCache(deliveryCtyQtyKey, skuDeliveryView);
                    // 更新预估配送费用查询记录信息
                    if (this.deliveryCtyQtyHistory) {
                        if (this.deliveryCtyQtyHistory.indexOf(deliveryCtyQtyKey) == -1) {
                            this.deliveryCtyQtyHistory.push(deliveryCtyQtyKey);
                        }
                    } else {
                        this.deliveryCtyQtyHistory = [deliveryCtyQtyKey];
                    }
                }, error => {
                    this.permissionService.onRequestFailed(error)
                        .then(resError => {
                            const errorCode = resError.code;
                            let tipConfig: IMessageDialogOptions = {
                                title: this.$translate.instant("PRODUCT_DETAIL_SHIPPING_ISSUE_TITLE"),
                                content: this.$translate.instant("PRODUCT_DETAIL_SHIPPING_ISSUE_TITLE_CONTENT2", { supportmail: envConfig.supportEmail })
                            }
                            if (errorCode == '200001') {
                                // 产品不存在
                                tipConfig.code = "A103B200001";
                                tipConfig.msg = this.$translate.instant('A103B200001', {
                                    supportmail: this.supportmail
                                });
                            } else if (errorCode == '2000033' || errorCode == '2000055') {
                                //2000033： propertyModel:{propertyModelId}；2000055：单双向属性计算参数错误（非逻辑）原因：{message}
                                tipConfig.code = "A103B2000033";
                                tipConfig.msg = this.$translate.instant('A103B2000033', {
                                    supportmail: this.supportmail
                                });
                            } else if (errorCode == '4000061' || errorCode == '4000062') {
                                // 4000061：计算产品重量异常，原因如下:{message}；4000062：// 错误的产品重量！
                                tipConfig.code = "A103B4000061";
                                tipConfig.msg = this.$translate.instant('A103B4000061', {
                                    supportmail: this.supportmail
                                });
                            } else if (errorCode == '4000063') {
                                // 调用PS运费远程服务接口异常,信息:{message}
                                tipConfig.code = "A103B4000063";
                                tipConfig.msg = this.$translate.instant('A103B4000063', {
                                    supportmail: this.supportmail
                                });
                            } else if (errorCode == '30000027' || errorCode == '30000028') {
                                // 30000027：产品id:{productId}没有找到生效的生产天数配置；30000028：生产天数计算配置id:{configId}没有生产配置,检查ProductionDaySetting
                                tipConfig.code = "A103B30000027";
                                tipConfig.msg = this.$translate.instant('A103B30000027', {
                                    supportmail: this.supportmail
                                });
                            } else if (errorCode == "300310") {
                                // 平台货币配置缺失
                                const currentCurrency = resError.errorParams?.currencyCode;
                                this.missingCurrencyConfigTipModal(this.$translate.instant('PRODUCT_DETAIL_SHIPPING_ERROR_TITLE'), currentCurrency);
                                return;
                            } else if (errorCode == "3000601") {
                                //平台:{platformCode} 范围:{usageScope} 不支持货币:{currencyCode} ! 
                                const supportCurrencyCodes = resError.errorParams.supportCurrencyCodes ? resError.errorParams.supportCurrencyCodes.join(',') : undefined;
                                const platformCode = resError.errorParams.platformCode ? resError.errorParams.platformCode : (envConfig.APP_NAME).toUpperCase();
                                const currentCurrency = resError.errorParams.currencyCode;
                                this.nonsupportCurrencyTipModal(this.$translate.instant('PRODUCT_DETAIL_SHIPPING_ERROR_TITLE'), currentCurrency, platformCode, supportCurrencyCodes);
                                return;
                            } else {
                                // 未知错误发送sentry
                                this.sendError('product-deatail.productDetailController.searchDeliveryInfoByV2Property', error);
                            }
                            this.qpMessageDialog.info(tipConfig);
                        })
                })
                .finally(() => {
                    // 预估配送信息查询状态--关闭
                    this.deliveriesInfoLoading = false;
                })
        }
    }



    /**
     * @desc 根据V2属性表单数据，下载预估产品费用列表信息
     * @returns 
     * */
    public downLoadShippingExcelByV2Property(propertyModelForm: PropertyModelForm) {
        // 获取地区国家code
        const countryCode = this.getCountryCode(this.currentCountry);
        // 获取货币code
        const currencyCode = this.getCurrencyCode();
        // 获取自定义产品数量
        const shippingQtyList = this.getShippingQtyList(this.shippingQty);
        // 预估配送信息excel下载-开启 
        this.shippingExcelLoading = true;
        this.shippingRestService.downloadExcelByFormId(currencyCode, countryCode, propertyModelForm._id, shippingQtyList)
            .then(respData => {

            }, error => {
                this.permissionService.onRequestFailed(error)
                    .then(resError => {
                        const errorCode = resError.code;
                        let tipConfig: IMessageDialogOptions = {
                            title: this.$translate.instant("PRODUCT_DETAIL_SHIPPING_EXPORT_ISSUE_TITLE"),
                            content: this.$translate.instant("PRODUCT_DETAIL_SHIPPING_EXPORT_ISSUE_CONTENT1", { supportmail: envConfig.supportEmail })
                        }
                        if (errorCode == '200001') {
                            // 产品不存在
                            tipConfig.code = "A103B200001";
                            tipConfig.msg = this.$translate.instant('A103B200001');
                        } else if (errorCode == '2000033' || errorCode == '2000055') {
                            //2000033： propertyModel:{propertyModelId}；2000055：单双向属性计算参数错误（非逻辑）原因：{message}
                            tipConfig.code = "A103B2000033";
                            tipConfig.msg = this.$translate.instant('A103B2000033');
                        } else if (errorCode == '4000061' || errorCode == '4000062') {
                            // 4000061：计算产品重量异常，原因如下:{message}；4000062：// 错误的产品重量！
                            tipConfig.code = "A103B4000061";
                            tipConfig.msg = this.$translate.instant('A103B4000061');
                        } else if (errorCode == '4000063') {
                            // 调用PS运费远程服务接口异常,信息:{message}
                            tipConfig.code = "A103B4000063";
                            tipConfig.msg = this.$translate.instant('A103B4000063');
                        } else if (errorCode == '30000027' || errorCode == '30000028') {
                            // 30000027：产品id:{productId}没有找到生效的生产天数配置；30000028：生产天数计算配置id:{configId}没有生产配置,检查ProductionDaySetting
                            tipConfig.code = "A103B30000027";
                            tipConfig.msg = this.$translate.instant('A103B30000027');
                        } else if (errorCode == "300310") {
                            // 平台货币配置缺失
                            const currentCurrency = resError.errorParams?.currencyCode;
                            this.missingCurrencyConfigTipModal(this.$translate.instant('PRODUCT_DETAIL_SHIPPING_EXPORT_ERROE_TITLE'), currentCurrency);
                            return;
                        } else if (errorCode == "3000601") {
                            //平台:{platformCode} 范围:{usageScope} 不支持货币:{currencyCode} ! 
                            const supportCurrencyCodes = resError.errorParams.supportCurrencyCodes ? resError.errorParams.supportCurrencyCodes.join(',') : undefined;
                            const platformCode = resError.errorParams.platformCode ? resError.errorParams.platformCode : (envConfig.APP_NAME).toUpperCase();
                            const currentCurrency = resError.errorParams.currencyCode;
                            this.nonsupportCurrencyTipModal(this.$translate.instant('PRODUCT_DETAIL_SHIPPING_EXPORT_ERROE_TITLE'), currentCurrency, platformCode, supportCurrencyCodes);
                            return;
                        } else {
                            // 未知错误发送sentry
                            this.sendError('product-deatail.productDetailController.downLoadShippingExcelByV2Property', error);
                        }
                        this.qpMessageDialog.info(tipConfig);
                    })
            })
            .finally(() => {
                // 预估配送信息excel下载--关闭
                this.shippingExcelLoading = false;
            })
    }



    public onInitByV2Property() {
        // this.initFinish = true;
        this.qpLoading.close();
        // 绑定变量
        this.productName = this.$scope.productName;
        // this.symbol = this.$scope.symbol;
        this.currentProductId = this.$scope.currentProductId;
        // // TODO校验当前user货币与详情页发布是的货币是否一致，不一致时重新计算产品价格
        // if (this.$scope.currencyCode !== this.userCurrencyCode) {
        //     this.addToPricingQueue();
        // }


    }

    /************************************************属性表单集成***************************************************/

    /**
     * @description 获取页面锚点标识元素
     * @param isinline:是否为dashboard访问该页面
     * */

    public getAnchIdArr(isinline?: boolean) {

        // pc端获取锚点标识元素
        let browserWidth: number = document.documentElement.clientWidth || document.body.clientWidth;
        let headerObj = document.getElementById('fixed-header');
        let headerFixedHeight: number;
        if (headerObj?.classList.contains('sticky-header')) {
            headerFixedHeight = $("#fixed-header")[0].clientHeight;
        } else {
            if (768 < browserWidth && browserWidth < 991) {
                if (isinline) {
                    headerFixedHeight = 81;
                } else {
                    headerFixedHeight = 0;
                }
            } else {
                if (isinline) {
                    headerFixedHeight = 188;
                } else {
                    headerFixedHeight = 0;
                }

            }
        }
        // let headerFixedHeight: number = $("#fixed-header")[0].clientHeight;
        let nodeArr = document.querySelectorAll(".anchId");
        nodeArr.forEach(ele => {
            let idStr: string = "#" + ele.id;
            let nodeTop = $(idStr).offset()?.top;
            nodeTop ? nodeTop = nodeTop - headerFixedHeight : nodeTop = -headerFixedHeight;
            let tempObj = {
                id: idStr,
                nodeTop: Math.floor(nodeTop as number)
            };
            this.anchIdArr.push(tempObj);
        });
    }

    /**
     * @description 点击锚点，修改当前锚点选中值currentanchId,滚动当前被选中锚点对应文本
     * @param anchId 被点击的锚点
     */
    public changeCurrentanchId(anchId: string) {
        this.anchIdArr = [];
        this.getAnchIdArr();
        this.currentAnchId = anchId;
        let anchObj = this.anchIdArr.find((ele) => {
            return ele.id == anchId;
        });
        this.$window.scrollTo({ top: anchObj.nodeTop });
    }


    /*********************************************随机卡********************************************/
    /**
     * @description 更新随机设计选项
     * @param designModel
     * */
    public changeDesignModel(designModel: string) {
        this.designModel = designModel;
        // 根据产品设置模式类型，设置对应的设计模式名称
        this.designModelName = this.getDesignModelName(this.designModel);
        //TODO 更新产品数量价格表(根据设计模式，查询数量价格表)rest接口待修改
        this.addToPricingQueue();
        this.dispatchInquiryPriceChange([
            { propertyName: "isRandomMode", value: this.isRandomMode }
        ]);
    }

    /**
     * @description 根据产品设置模式，获取产品设计模式对应的显示名称
     * @param designModel
     * */
    public getDesignModelName(designModel: string): string {
        let designModelName: string;
        // TODO 临时处理，根据产品设置模式类型，设置对应的设计模式名称
        if (designModel === 'FIX') {
            designModelName = this.$translate.instant('FIXED_SET_MODEL');
        } else {
            designModelName = this.$translate.instant('RANDOMIZED_MODEL');
        }
        return designModelName;
    }

    /**
     * @description 根据属性键值对，获取产品设计模式
     * @param productId
     * @param skuAttributeValues[]
     * @param profileId
     * @param versionedAttributeId
     * @param defaultDesignMode
     * */
    public updateDesignModelInfo(productId: string, skuAttributeValues: Array<ISkuAttributeValue>, profileId: string | undefined, versionedAttributeId: number | undefined, defaultDesignMode?: string): angular.IPromise<string> {
        let defer = this.$q.defer<string>();
        if (this.attributeRelationDesignMethod) {
            //获取产品设计模式信息（默认设计模式，设计模式可选项）
            this.designMethodRestService.calculateDesignMethod(productId, skuAttributeValues, profileId, versionedAttributeId)
                .then((res) => {
                    //更新设置产品设置模式可选列表项
                    this.designModelOptionsViewValue = this.createDesignModelOptionsViewValue(res.data.supportDesignMethod);
                    // 校验产品默认设计模式是否包含在，产品设计模式可选项列表中，若存在设置产品默认设计模式为当前产品的设计模式，否者根据接口返回的当前默认设计模式进行赋值
                    if (!is.undefined(defaultDesignMode)) {
                        const verifyResult = this.designModeVerify(defaultDesignMode, this.designModelOptionsViewValue);
                        this.designModel = defaultDesignMode;
                    } else {
                        this.designModel = res.data.currentAttributeDesignMethod;
                    }
                    this.designModelName = this.getDesignModelName(this.designModel);
                    this.dispatchInquiryPriceChange([
                        { propertyName: "isRandomMode", value: this.isRandomMode }
                    ]);
                    defer.resolve(this.designModel);
                }, error => {
                    this.permissionService.onRequestFailed(error)
                        .then(resError => {
                            const errorCode = resError.code;
                            let tipConfig: IMessageDialogOptions = {
                                title: this.$translate.instant("PRODUCT_DETAIL_DESIGN_METHOD_ISSUE_TITLE"),
                                content: this.$translate.instant("PRODUCT_DETAIL_DESIGN_METHOD_ISSUE_CONTENT", { supportmail: envConfig.supportEmail })
                            }
                            // 未知错误发送sentry
                            this.sendError('product-deatail.productDetailController.updateDesignModelInfo', error);
                            this.qpMessageDialog.info(tipConfig);
                        })
                    defer.reject();
                })
        } else {
            if (!is.undefined(this.designModel)) {
                // 设置产品设置名称显示值 
                this.designModelName = this.getDesignModelName(this.designModel);
            }

            defer.resolve(this.designModel);
        }
        return defer.promise;
    }

    /**
     * @description 根据formId(propertyModel的V2版本)，获取产品设计模式
     * @param productId
     * @param formId
     * @param defaultDesignMode
     * */
    public updateDesignModelInfoByFormId(productId: string, formId: number, defaultDesignMode?: string): angular.IPromise<any> {
        let defer = this.$q.defer<any>();
        if (this.attributeRelationDesignMethod) {
            // 通过rest接口获取产品设计模式信息（默认设计模式，设计模式可选项）
            this.designMethodRestService.getByFormId(productId, formId)
                .then((res) => {
                    //更新设置产品设置模式可选列表项
                    this.designModelOptionsViewValue = this.createDesignModelOptionsViewValue(res.data.supportDesignMethod);
                    // 校验产品默认设计模式是否包含在，产品设计模式可选项列表中，若存在设置产品默认设计模式为当前产品的设计模式，否者根据接口返回的当前默认设计模式进行赋值
                    if (!is.undefined(defaultDesignMode)) {
                        const verifyResult = this.designModeVerify(defaultDesignMode, this.designModelOptionsViewValue);
                        this.designModel = defaultDesignMode;
                    } else {
                        this.designModel = res.data.currentAttributeDesignMethod;
                    }
                    this.designModelName = this.getDesignModelName(this.designModel);
                    this.dispatchInquiryPriceChange([
                        { propertyName: "isRandomMode", value: this.isRandomMode }
                    ]);
                    defer.resolve(this.designModel);
                }, error => {
                    this.permissionService.onRequestFailed(error)
                        .then(resError => {
                            const errorCode = resError.code;
                            let tipConfig: IMessageDialogOptions = {
                                title: this.$translate.instant("PRODUCT_DETAIL_DESIGN_METHOD_ISSUE_TITLE"),
                                content: this.$translate.instant("PRODUCT_DETAIL_DESIGN_METHOD_ISSUE_CONTENT", { supportmail: envConfig.supportEmail })
                            }
                            // 未知错误发送sentry
                            this.sendError('product-deatail.productDetailController.updateDesignModelInfoByFormId', error);
                            this.qpMessageDialog.info(tipConfig);
                        })
                    defer.reject();
                })
        } else {
            defer.resolve(this.designModel);
        }
        return defer.promise;

    }

    /**
     * @description 创建产品属性可选设计模式-视图数据
     * @param designModelOptions
     * */
    public createDesignModelOptionsViewValue(designModelOptions: Array<string>): Array<IDesignModelOptionViewValue> {
        let designModelOptionsViewValue: Array<IDesignModelOptionViewValue> = [];

        for (let i = 0; i < designModelOptions.length; i++) {
            const designModel = designModelOptions[i];
            const designModelViewValue: IDesignModelOptionViewValue = {
                code: designModel,
                name: this.getDesignModelName(designModel)
            }
            designModelOptionsViewValue.push(designModelViewValue);
        }
        return designModelOptionsViewValue;
    }

    /*********************************************随机卡********************************************/

    /**
     * @description 随机设计产品-跳转随机定制页面
     * @param propertyModelId
     * */
    private goRandomDesign(propertyModelId: string, productType) {
        const randomBuilderPagePath = this.rootPath + "random-builder/";
        let urlParams: IRandomBuilderUrlParameter = {
            source: "productDetail",
            sourceId: propertyModelId,
            prePath: window.location.pathname,
            productType: productType,
            designMethodVersion: String(this.$scope.designMethodVersion)
        }
        // 设置店铺产品ID参数
        // if (!angular.isUndefined(this.storeProductId)) {
        //     randomBuilderPath = this.urlBuilder.setUrlParams(randomBuilderPath, {
        //         storeProductId: String(this.storeProductId)
        //     }, this)
        // }
        if (!angular.isUndefined(this.$scope.cmsConfigVersion)) {
            urlParams.cmsConfigVersion = String(this.$scope.cmsConfigVersion)
        }
        // 设置属性版本编号
        if (this.$scope.attributeVersionNumber) {
            urlParams.attributeVersionNumber = this.$scope.attributeVersionNumber
        }
        let randomBuilderPath = this.urlBuilder.setUrlParams(randomBuilderPagePath, urlParams as { [name: string]: string; }, this)

        // 设置属性版本编号
        if (this.$scope.attributeVersionNumber) {
            randomBuilderPath = this.urlBuilder.setUrlParams(randomBuilderPath, {
                attributeVersionNumber: this.$scope.attributeVersionNumber
            }, this)
        }
        window.location.href = randomBuilderPath;
    }
    /**
     * @description 设计模式合法性校验，当前产品设置模式是否包含在产品设置模式可选项列表中
     * @param designMode
     * @param designModeList
     * */
    private designModeVerify(designMode: string, designModeList: Array<IDesignModelOptionViewValue>): boolean {
        const verifyResult = designModeList.find(item => {
            return item.code === designMode;
        })
        if (is.undefined(verifyResult)) {
            return false;
        } else {
            return true;
        }
    }
    /**
     * @description 跳转到shippinginfo tab
     * */
    public shippingInfoShow() {
        this.currentAnchId = '#productInfo'
        this.activeInfoIndex = 1;
        this.infoStatusInMobile.shippingIsOpen = true;
        this.changeCurrentanchId(this.currentAnchId)
    }

    /**
     * @description 判断是否需要更新产品价格
     */
    public isNeedUpdatePrice(changeType?: ChangeType): boolean {
        // 不需要更新产品价格的情况
        // ① 固定价格fixPrice = true
        // ② 属性变更时attributeChange = false
        // ③ 数量变更时qtyChange = false
        let notNeedUpdate = (this.fixedPrice == true) || (changeType == ChangeType.Attr && this.needChangedWhenAttrs === false) || (changeType == ChangeType.Qty && this.needChangedWhenQty === false) || false;
        return !notNeedUpdate;
    }

    /**
     * @description 阶梯价格表中根据当前数量从pricinglist拿出对应的价格
     */
    public getIntervalPrice(qty: number, pricingList: IBulkPriceViewValue): string {
        let priceResult = "";
        if (pricingList && pricingList.userCurrency) {
            for (let price of pricingList.userCurrency) {
                if (qty >= price.from && qty <= price.to) {
                    priceResult = price.currencyEntity.symbol + Number(price.result).toFixed(2);
                }
            }
        }
        return priceResult;
    }


    /**
     * @description 获取产品销售价格对应的产品数量（成品产品根据用户自定的购买数量设置产品数量；非成品产品根据产品最小购买数量设置产品数量） 
     * */
    public getPriceQty(): number {
        let qty: number;
        // 成品产品根据用户自定的购买数量设置产品数量,若用户为自定义购买数量小于产品MOQ，将MOQ设置为产品数量
        if (!is.undefined(this.$scope.isFinished) && this.$scope.isFinished) {
            if (!is.undefined(this.productQuantity) && !is.undefined(this.moq) && (this.productQuantity < this.moq)) {
                qty = this.moq;
            } else {
                qty = this.productQuantity;
            }
        } else {
            qty = this.moq;
        }
        return qty;
    }
    
    private initTrackProductData() {
        let productId = String(this.$objectTree.currentProductId);
        let productName = this.$objectTree.productName;
        let qty = this.getPriceQty();
        let productPrice;
        if (!is.undefined(this.productPrice)) {
            productPrice = Number(this.productPrice.replace(/[^\d.]/g, ''));
        }

        return {
            productId,
            productName,
            productPrice,
            qty
        }
    }
}